
// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { userApp } from "../Admin/Utility";
// import ReactTable from "../General/ReactTable";
// import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
// import { useDispatch, useSelector } from "react-redux";
// import $ from "jquery";
// import CustomizedSelectoption from "./CustomizedSelectoption";
// import { ShowHide_Popup } from "../ReduxStore/Transactionstates";

// // ═══════════════════════════════════════════════════════════════
// //  TOAST — exact match to software notification UI
// // ═══════════════════════════════════════════════════════════════
// function Toast({ toasts, onDismiss }) {
//   const typeConfig = {
//     success: {
//       bg: "#2d8c3e",
//       textColor: "#ffffff",
//       iconBg: "#ffffff",           /* solid white circle */
//       iconColor: "#2d8c3e",        /* green tick inside white circle */
//       icon: "✔",
//     },
//     error: {
//       bg: "#c0392b",
//       textColor: "#ffffff",
//       iconBg: "#ffffff",
//       iconColor: "#c0392b",
//       icon: "✕",
//     },
//     info: {
//       bg: "#1a6fba",
//       textColor: "#ffffff",
//       iconBg: "#ffffff",
//       iconColor: "#1a6fba",
//       icon: "i",
//     },
//     warning: {
//       bg: "#d35400",
//       textColor: "#ffffff",
//       iconBg: "#ffffff",
//       iconColor: "#d35400",
//       icon: "!",
//     },
//   };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 18,
//         right: 18,          /* ← top-right, exactly like your software */
//         zIndex: 99999,
//         display: "flex",
//         flexDirection: "column",
//         gap: 8,
//         pointerEvents: "none",
//       }}
//     >
//       {toasts.map((t) => {
//         const cfg = typeConfig[t.type] || typeConfig.info;
//         return (
//           <div
//             key={t.id}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//               background: cfg.bg,
//               color: cfg.textColor,
//               padding: "10px 14px 10px 12px",
//               borderRadius: 5,
//               fontSize: 13,
//               fontWeight: 600,
//               minWidth: 300,
//               maxWidth: 420,
//               pointerEvents: "all",
//               animation: "toastSlide 0.25s ease-out",
//               boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
//               letterSpacing: "0.01em",
//             }}
//           >
//             {/* Solid white circle with colored tick — exact match to reference */}
//             <div
//               style={{
//                 width: 20,
//                 height: 20,
//                 borderRadius: "50%",
//                 background: cfg.iconBg,      /* solid white */
//                 color: cfg.iconColor,         /* green tick */
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 11,
//                 fontWeight: 900,
//                 flexShrink: 0,
//               }}
//             >
//               {cfg.icon}
//             </div>

//             {/* Message */}
//             <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>

//             {/* × dismiss — like screenshot */}
//             <button
//               onClick={() => onDismiss && onDismiss(t.id)}
//               style={{
//                 background: "none",
//                 border: "none",
//                 color: cfg.textColor,
//                 cursor: "pointer",
//                 fontSize: 18,
//                 fontWeight: 400,
//                 lineHeight: 1,
//                 padding: "0 0 0 6px",
//                 opacity: 0.9,
//                 flexShrink: 0,
//               }}
//               title="Close"
//             >
//               ×
//             </button>
//           </div>
//         );
//       })}
//       <style>{`
//         @keyframes toastSlide {
//           from { opacity:0; transform:translateX(50px); }
//           to   { opacity:1; transform:translateX(0); }
//         }
//       `}</style>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  CANCEL CONFIRM MODAL
// // ═══════════════════════════════════════════════════════════════
// function CancelModal({ irn, onConfirm, onClose }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 9999,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 14,
//           width: 440,
//           padding: "32px 32px 24px",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
//           animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
//           border: "1px solid #fee2e2",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             textAlign: "center",
//             marginBottom: 24,
//           }}
//         >
//           <div
//             style={{
//               width: 56,
//               height: 56,
//               borderRadius: "50%",
//               background: "#fef2f2",
//               border: "2px solid #fecaca",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginBottom: 16,
//               fontSize: 24,
//             }}
//           >
//             ⛔
//           </div>
//           <div
//             style={{
//               fontWeight: 700,
//               fontSize: 17,
//               color: "#111",
//               marginBottom: 6,
//             }}
//           >
//             Cancel E-Invoice?
//           </div>
//           <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>
//             This action is permanent and cannot be reversed.
//             <br />
//             The IRN will be marked as cancelled on the GST portal.
//           </div>
//         </div>
//         <div
//           style={{
//             background: "#fef2f2",
//             border: "1px solid #fecaca",
//             borderRadius: 8,
//             padding: "12px 14px",
//             marginBottom: 24,
//           }}
//         >
//           <div
//             style={{
//               fontSize: 10,
//               color: "#9ca3af",
//               fontWeight: 700,
//               letterSpacing: "0.8px",
//               marginBottom: 4,
//             }}
//           >
//             INVOICE REFERENCE NUMBER
//           </div>
//           <div
//             style={{
//               fontFamily: "monospace",
//               fontSize: 10.5,
//               color: "#374151",
//               wordBreak: "break-all",
//               lineHeight: 1.7,
//             }}
//           >
//             {irn}
//           </div>
//         </div>
//         <div style={{ display: "flex", gap: 10 }}>
//           <button
//             onClick={onClose}
//             style={{
//               flex: 1,
//               padding: "11px",
//               borderRadius: 8,
//               border: "1.5px solid #e5e7eb",
//               background: "#fff",
//               color: "#374151",
//               fontWeight: 600,
//               fontSize: 13,
//               cursor: "pointer",
//             }}
//           >
//             Keep Active
//           </button>
//           <button
//             onClick={onConfirm}
//             style={{
//               flex: 1,
//               padding: "11px",
//               borderRadius: 8,
//               border: "none",
//               background: "#dc2626",
//               color: "#fff",
//               fontWeight: 700,
//               fontSize: 13,
//               cursor: "pointer",
//               boxShadow: "0 4px 14px rgba(220,38,38,0.3)",
//             }}
//           >
//             Yes, Cancel IRN
//           </button>
//         </div>
//       </div>
//       <style>{`@keyframes modalPop{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}`}</style>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  CREDENTIAL POPUP
// // ═══════════════════════════════════════════════════════════════
// function CredentialModal({ cred, onChange, onSave, onClose, saving }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 10000,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 14,
//           width: 420,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
//           animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0f172a,#1e3a5f)",
//             padding: "24px 28px",
//             display: "flex",
//             alignItems: "center",
//             gap: 14,
//           }}
//         >
//           <div
//             style={{
//               width: 44,
//               height: 44,
//               borderRadius: 10,
//               background: "rgba(255,255,255,0.12)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 22,
//             }}
//           >
//             🔐
//           </div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
//               NIC E-Invoice Credentials
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.6)",
//                 marginTop: 2,
//               }}
//             >
//               GST Portal Login — required for API access
//             </div>
//           </div>
//         </div>
//         <div style={{ padding: "24px 28px 20px" }}>
//           <div style={{ marginBottom: 16 }}>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 display: "block",
//                 marginBottom: 6,
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//               }}
//             >
//               GST Username
//             </label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Enter GST portal username"
//               value={cred.ApiUserName}
//               onChange={(e) =>
//                 onChange({ ...cred, ApiUserName: e.target.value })
//               }
//               autoComplete="off"
//               style={{ fontSize: 13 }}
//             />
//           </div>
//           <div style={{ marginBottom: 24 }}>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 display: "block",
//                 marginBottom: 6,
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//               }}
//             >
//               GST Password
//             </label>
//             <input
//               type="password"
//               className="form-control"
//               placeholder="Enter GST portal password"
//               value={cred.ApiPassword}
//               onChange={(e) =>
//                 onChange({ ...cred, ApiPassword: e.target.value })
//               }
//               autoComplete="new-password"
//               style={{ fontSize: 13 }}
//             />
//           </div>
//           <div
//             style={{
//               background: "#eff6ff",
//               border: "1px solid #bfdbfe",
//               borderRadius: 8,
//               padding: "10px 12px",
//               marginBottom: 20,
//               fontSize: 11.5,
//               color: "#1e40af",
//               lineHeight: 1.5,
//             }}
//           >
//             ℹ️ These credentials are used only for NIC E-Invoice API
//             authentication. They are stored securely and encrypted.
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button
//               onClick={onClose}
//               disabled={saving}
//               style={{
//                 flex: 1,
//                 padding: "10px",
//                 borderRadius: 8,
//                 border: "1.5px solid #e5e7eb",
//                 background: "#fff",
//                 color: "#374151",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 cursor: saving ? "not-allowed" : "pointer",
//                 opacity: saving ? 0.5 : 1,
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={onSave}
//               disabled={saving}
//               style={{
//                 flex: 1,
//                 padding: "10px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: saving
//                   ? "#9ca3af"
//                   : "linear-gradient(135deg,#0f172a,#1e3a5f)",
//                 color: "#fff",
//                 fontWeight: 700,
//                 fontSize: 13,
//                 cursor: saving ? "not-allowed" : "pointer",
//               }}
//             >
//               {saving ? "Saving..." : "Save & Generate"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  VALIDATION MODAL
// // ═══════════════════════════════════════════════════════════════
// function ValidationModal({ errors, warnings, invoice, onProceed, onClose }) {
//   const hasErrors = errors.length > 0;
//   const inv = invoice || {};
//   const seller = inv.SellerDtls || {};
//   const buyer = inv.BuyerDtls || {};
//   const doc = inv.DocDtls || {};
//   const val = inv.ValDtls || {};
//   const items = inv.ItemList || [];

//   const checks = [
//     { label: "Invoice Number", ok: !!doc.No, val: doc.No || "Missing" },
//     { label: "Invoice Date", ok: !!doc.Dt, val: doc.Dt || "Missing" },
//     {
//       label: "Seller GSTIN",
//       ok: (seller.Gstin || "").length === 15,
//       val: seller.Gstin || "Missing",
//     },
//     {
//       label: "Buyer GSTIN",
//       ok: (buyer.Gstin || "").length === 15,
//       val: buyer.Gstin || "Missing",
//     },
//     {
//       label: "Seller Email",
//       ok:
//         /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(seller.Em || "") &&
//         (seller.Em || "").length >= 6,
//       val: seller.Em || "Missing",
//     },
//     {
//       label: "Buyer Email",
//       ok:
//         /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(buyer.Em || "") &&
//         (buyer.Em || "").length >= 6,
//       val: buyer.Em || "Missing",
//     },
//     {
//       label: "Seller Pincode",
//       ok: /^\d{6}$/.test(String(seller.Pin || "")),
//       val: String(seller.Pin || "Missing"),
//     },
//     {
//       label: "Buyer Pincode",
//       ok: /^\d{6}$/.test(String(buyer.Pin || "")),
//       val: String(buyer.Pin || "Missing"),
//     },
//     {
//       label: "Vehicle Number",
//       ok:
//         String(inv.EwbDtls?.VehNo || "").length >= 4 &&
//         String(inv.EwbDtls?.VehNo || "").length <= 20,
//       val: inv.EwbDtls?.VehNo || "Missing",
//     },
//     {
//       label: "Transport Mode",
//       ok: ["1", "2", "3", "4"].includes(String(inv.EwbDtls?.TransMode || "")),
//       val: inv.EwbDtls?.TransMode || "Missing",
//     },
//     {
//       label: "Total Items",
//       ok: items.length > 0,
//       val: `${items.length} item(s)`,
//     },
//     {
//       label: "Invoice Value",
//       ok: Number(val.TotInvVal || 0) > 0,
//       val: `₹${Number(val.TotInvVal || 0).toLocaleString("en-IN")}`,
//     },
//   ];

//   const passCount = checks.filter((c) => c.ok).length;
//   const totalCount = checks.length;
//   const progress = Math.round((passCount / totalCount) * 100);

//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 10001,
//         background: "rgba(0,0,0,0.65)",
//         backdropFilter: "blur(6px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: 16,
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 16,
//           width: 580,
//           maxHeight: "90vh",
//           display: "flex",
//           flexDirection: "column",
//           boxShadow: "0 32px 100px rgba(0,0,0,0.35)",
//           animation: "modalPop 0.28s cubic-bezier(0.34,1.56,0.64,1)",
//           overflow: "hidden",
//         }}
//       >
//         {/* ── Header ── */}
//         <div
//           style={{
//             background: hasErrors
//               ? "#dc2626"
//               : "darkgreen",
//             padding: "22px 24px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//               <div
//                 style={{
//                   width: 40,
//                   height: 40,
//                   borderRadius: 10,
//                   background: "rgba(255,255,255,0.15)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: 20,
//                 }}
//               >
//                 {hasErrors ? "🛑" : "✅"}
//               </div>
//               <div>
//                 <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
//                   {hasErrors
//                     ? `${errors.length} Error${errors.length > 1 ? "s" : ""} Found — Cannot Generate`
//                     : "All Checks Passed — Ready to Generate"}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: "rgba(255,255,255,0.65)",
//                     marginTop: 2,
//                   }}
//                 >
//                   {hasErrors
//                     ? "Fix the errors in the invoice and try again"
//                     : `${warnings.length > 0 ? warnings.length + " warning(s) noted · " : ""}Confirm to submit to NIC portal`}
//                 </div>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               style={{
//                 width: 30,
//                 height: 30,
//                 borderRadius: "50%",
//                 background: "rgba(255,255,255,0.15)",
//                 border: "none",
//                 color: "#fff",
//                 fontSize: 16,
//                 cursor: "pointer",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               ✕
//             </button>
//           </div>

//           {/* Progress bar */}
//           <div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginBottom: 6,
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: 11,
//                   color: "rgba(255,255,255,0.7)",
//                   fontWeight: 600,
//                 }}
//               >
//                 VALIDATION PROGRESS
//               </span>
//               <span
//                 style={{
//                   fontSize: 11,
//                   color: "rgba(255,255,255,0.9)",
//                   fontWeight: 700,
//                 }}
//               >
//                 {passCount}/{totalCount} checks passed
//               </span>
//             </div>
//             <div
//               style={{
//                 height: 6,
//                 background: "rgba(255,255,255,0.2)",
//                 borderRadius: 3,
//                 overflow: "hidden",
//               }}
//             >
//               <div
//                 style={{
//                   height: "100%",
//                   width: `${progress}%`,
//                   background: hasErrors ? "#fca5a5" : "rgba(255,255,255,0.75)",
//                   borderRadius: 3,
//                   transition: "width 0.5s ease",
//                 }}
//               />
//             </div>
//           </div>
//         </div>

//         {/* ── Body ── */}
//         <div style={{ overflowY: "auto", flex: 1 }}>
//           {/* Field Checklist */}
//           <div style={{ padding: "16px 24px 0" }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 letterSpacing: "0.7px",
//                 marginBottom: 10,
//                 textTransform: "uppercase",
//               }}
//             >
//               Field Validation Checklist
//             </div>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "4px 10px",
//               }}
//             >
//               {checks.map((c, i) => (
//                 <div
//                   key={i}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 8,
//                     padding: "6px 10px",
//                     borderRadius: 7,
//                     background: c.ok ? "#f0fdf4" : "#fef2f2",
//                     border: `1px solid ${c.ok ? "#bbf7d0" : "#fecaca"}`,
//                   }}
//                 >
//                   <span
//                     style={{
//                       width: 18,
//                       height: 18,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                       background: c.ok ? "#dcfce7" : "#fee2e2",
//                       color: c.ok ? "#15803d" : "#dc2626",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 10,
//                       fontWeight: 700,
//                     }}
//                   >
//                     {c.ok ? "✓" : "✕"}
//                   </span>
//                   <div style={{ minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontSize: 10.5,
//                         fontWeight: 700,
//                         color: c.ok ? "darkgreen" : "#991b1b",
//                       }}
//                     >
//                       {c.label}
//                     </div>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: c.ok ? "darkgreen" : "#f87171",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         whiteSpace: "nowrap",
//                         maxWidth: 180,
//                       }}
//                     >
//                       {c.val}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Errors */}
//           {errors.length > 0 && (
//             <div style={{ padding: "16px 24px 0" }}>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                   marginBottom: 10,
//                 }}
//               >
//                 <div
//                   style={{
//                     background: "#dc2626",
//                     color: "#fff",
//                     borderRadius: 5,
//                     padding: "2px 8px",
//                     fontSize: 10,
//                     fontWeight: 700,
//                     letterSpacing: "0.5px",
//                   }}
//                 >
//                   {errors.length} ERROR{errors.length > 1 ? "S" : ""}
//                 </div>
//                 <div
//                   style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}
//                 >
//                   Must be fixed in the invoice before generating
//                 </div>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                 {errors.map((e, i) => (
//                   <div
//                     key={i}
//                     style={{
//                       display: "flex",
//                       gap: 10,
//                       alignItems: "flex-start",
//                       background: "#fef2f2",
//                       border: "1px solid #fecaca",
//                       borderRadius: 8,
//                       padding: "10px 12px",
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: 20,
//                         height: 20,
//                         borderRadius: "50%",
//                         flexShrink: 0,
//                         background: "#dc2626",
//                         color: "#fff",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: 10,
//                         fontWeight: 700,
//                         marginTop: 1,
//                       }}
//                     >
//                       {i + 1}
//                     </div>
//                     <span
//                       style={{
//                         fontSize: 12,
//                         color: "#7f1d1d",
//                         lineHeight: 1.55,
//                       }}
//                     >
//                       {e}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Warnings */}
//           {warnings.length > 0 && (
//             <div style={{ padding: "14px 24px 0" }}>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                   marginBottom: 10,
//                 }}
//               >
//                 <div
//                   style={{
//                     background: "#d97706",
//                     color: "#fff",
//                     borderRadius: 5,
//                     padding: "2px 8px",
//                     fontSize: 10,
//                     fontWeight: 700,
//                     letterSpacing: "0.5px",
//                   }}
//                 >
//                   {warnings.length} WARNING{warnings.length > 1 ? "S" : ""}
//                 </div>
//                 <div
//                   style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}
//                 >
//                   Will be auto-noted — generation can proceed
//                 </div>
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                 {warnings.map((w, i) => (
//                   <div
//                     key={i}
//                     style={{
//                       display: "flex",
//                       gap: 10,
//                       alignItems: "flex-start",
//                       background: "#fffbeb",
//                       border: "1px solid #fde68a",
//                       borderRadius: 8,
//                       padding: "9px 12px",
//                     }}
//                   >
//                     <span style={{ fontSize: 14, flexShrink: 0, marginTop: 1 }}>
//                       ⚠
//                     </span>
//                     <span
//                       style={{
//                         fontSize: 12,
//                         color: "#78350f",
//                         lineHeight: 1.55,
//                       }}
//                     >
//                       {w}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Invoice Summary */}
//           <div style={{ padding: "16px 24px" }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 letterSpacing: "0.7px",
//                 marginBottom: 10,
//                 textTransform: "uppercase",
//               }}
//             >
//               Invoice Summary
//             </div>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: 8,
//                 marginBottom: 10,
//               }}
//             >
//               {[
//                 {
//                   title: "Seller",
//                   gstin: seller.Gstin,
//                   name: seller.LglNm || seller.TrdNm,
//                   pin: seller.Pin,
//                 },
//                 {
//                   title: "Buyer",
//                   gstin: buyer.Gstin,
//                   name: buyer.LglNm || buyer.TrdNm,
//                   pin: buyer.Pin,
//                 },
//               ].map(({ title, gstin, name, pin }) => (
//                 <div
//                   key={title}
//                   style={{
//                     background: "#f8fafc",
//                     border: "1px solid #e2e8f0",
//                     borderRadius: 8,
//                     padding: "10px 12px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize: 10,
//                       fontWeight: 700,
//                       color: "#94a3b8",
//                       letterSpacing: "0.6px",
//                       marginBottom: 6,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     {title}
//                   </div>
//                   <div
//                     style={{
//                       fontSize: 11.5,
//                       color: "#0f172a",
//                       fontWeight: 700,
//                       marginBottom: 2,
//                     }}
//                   >
//                     {gstin || (
//                       <span style={{ color: "#dc2626" }}>GSTIN Missing</span>
//                     )}
//                   </div>
//                   <div style={{ fontSize: 11, color: "#475569" }}>
//                     {name || "—"}
//                   </div>
//                   <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>
//                     PIN: {pin || "—"}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* Doc Details */}
//             <div
//               style={{
//                 display: "flex",
//                 gap: 20,
//                 background: "#f8fafc",
//                 border: "1px solid #e2e8f0",
//                 borderRadius: 8,
//                 padding: "10px 14px",
//                 marginBottom: 10,
//               }}
//             >
//               <div>
//                 <div
//                   style={{
//                     fontSize: 10,
//                     color: "#94a3b8",
//                     fontWeight: 700,
//                     marginBottom: 2,
//                   }}
//                 >
//                   DOC NUMBER
//                 </div>
//                 <div
//                   style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}
//                 >
//                   {doc.No || <span style={{ color: "#dc2626" }}>Missing</span>}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: 10,
//                     color: "#94a3b8",
//                     fontWeight: 700,
//                     marginBottom: 2,
//                   }}
//                 >
//                   DATE
//                 </div>
//                 <div
//                   style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}
//                 >
//                   {doc.Dt || "—"}
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     fontSize: 10,
//                     color: "#94a3b8",
//                     fontWeight: 700,
//                     marginBottom: 2,
//                   }}
//                 >
//                   TYPE
//                 </div>
//                 <div
//                   style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}
//                 >
//                   {doc.Typ || "—"}
//                 </div>
//               </div>
//             </div>

//             {/* Items */}
//             <div
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 letterSpacing: "0.5px",
//                 marginBottom: 8,
//                 textTransform: "uppercase",
//               }}
//             >
//               Items ({items.length})
//             </div>
//             <div
//               style={{
//                 maxHeight: 160,
//                 overflowY: "auto",
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: 5,
//               }}
//             >
//               {items.map((item, i) => {
//                 const itemOk =
//                   item.HsnCd &&
//                   item.Qty > 0 &&
//                   item.UnitPrice >= 0 &&
//                   item.TotItemVal > 0;
//                 return (
//                   <div
//                     key={i}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       background: itemOk ? "#f0fdf4" : "#fef2f2",
//                       border: `1px solid ${itemOk ? "#bbf7d0" : "#fecaca"}`,
//                       borderRadius: 7,
//                       padding: "7px 11px",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 8 }}
//                     >
//                       <span
//                         style={{
//                           width: 18,
//                           height: 18,
//                           borderRadius: "50%",
//                           flexShrink: 0,
//                           background: itemOk ? "darkgreen" : "#dc2626",
//                           color: "#fff",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontSize: 9,
//                           fontWeight: 700,
//                         }}
//                       >
//                         {itemOk ? "✓" : "✕"}
//                       </span>
//                       <div>
//                         <div
//                           style={{
//                             fontSize: 11.5,
//                             fontWeight: 600,
//                             color: "#0f172a",
//                           }}
//                         >
//                           {item.PrdDesc || "—"}
//                         </div>
//                         <div style={{ fontSize: 10, color: "#6b7280" }}>
//                           HSN:{" "}
//                           {item.HsnCd || (
//                             <span style={{ color: "#dc2626" }}>Missing</span>
//                           )}{" "}
//                           &nbsp;·&nbsp; Qty: {item.Qty} {item.Unit}{" "}
//                           &nbsp;·&nbsp; Rate: ₹
//                           {Number(item.UnitPrice || 0).toLocaleString("en-IN")}
//                         </div>
//                       </div>
//                     </div>
//                     <div
//                       style={{
//                         fontSize: 12,
//                         fontWeight: 700,
//                         color: "#1e40af",
//                       }}
//                     >
//                       ₹{Number(item.TotItemVal || 0).toLocaleString("en-IN")}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             {/* Total */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 background: "linear-gradient(135deg,#0f172a,#1e3a5f)",
//                 borderRadius: 9,
//                 padding: "12px 16px",
//                 marginTop: 10,
//               }}
//             >
//               <span
//                 style={{
//                   color: "rgba(255,255,255,0.7)",
//                   fontSize: 12,
//                   fontWeight: 600,
//                 }}
//               >
//                 Total Invoice Value
//               </span>
//               <span style={{ color: "#fbbf24", fontSize: 17, fontWeight: 700 }}>
//                 ₹{Number(val.TotInvVal || 0).toLocaleString("en-IN")}
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* ── Footer ── */}
//         <div
//           style={{
//             padding: "14px 24px",
//             borderTop: "1px solid #f1f5f9",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             background: "#fafafa",
//           }}
//         >
//           <div
//             style={{
//               fontSize: 12,
//               fontWeight: 600,
//               color: hasErrors ? "#dc2626" : "darkgreen",
//             }}
//           >
//             {hasErrors
//               ? `❌ ${errors.length} error${errors.length > 1 ? "s" : ""} — fix in invoice first`
//               : warnings.length > 0
//                 ? `⚠ ${warnings.length} warning${warnings.length > 1 ? "s" : ""} noted · safe to proceed`
//                 : "✅ All validations passed"}
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button
//               onClick={onClose}
//               style={{
//                 padding: "9px 22px",
//                 borderRadius: 8,
//                 border: "1.5px solid #e5e7eb",
//                 background: "#fff",
//                 color: "#374151",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 cursor: "pointer",
//               }}
//             >
//               {hasErrors ? "Close & Fix Errors" : "Cancel"}
//             </button>
//             {!hasErrors && (
//               <button
//                 onClick={onProceed}
//                 style={{
//                   padding: "9px 22px",
//                   borderRadius: 8,
//                   border: "none",
//                   background: "darkgreen",
//                   color: "#fff",
//                   fontWeight: 700,
//                   fontSize: 13,
//                   cursor: "pointer",
//                   boxShadow: "0 4px 16px rgba(22,101,52,0.35)",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                 }}
//               >
//                 ✅ Confirm & Generate
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  QR FROM JWT
// // ═══════════════════════════════════════════════════════════════
// function QRFromJWT({ jwt, size = 110 }) {
//   const ref = useRef(null);
//   useEffect(() => {
//     if (!jwt || !ref.current) return;
//     const render = () => {
//       if (!ref.current || !window.QRCode) return;
//       ref.current.innerHTML = "";
//       new window.QRCode(ref.current, {
//         text: jwt,
//         width: size,
//         height: size,
//         correctLevel: window.QRCode.CorrectLevel.M,
//       });
//     };
//     if (window.QRCode) {
//       render();
//       return;
//     }
//     const existing = document.getElementById("__qrcodejs_cdn__");
//     if (existing) {
//       existing.addEventListener("load", render);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "__qrcodejs_cdn__";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js";
//     script.onload = render;
//     document.head.appendChild(script);
//   }, [jwt, size]);
//   return (
//     <div
//       ref={ref}
//       style={{
//         width: size,
//         height: size,
//         border: "1px solid #d1fae5",
//         borderRadius: 6,
//         overflow: "hidden",
//         background: "#fff",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     />
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  COPY IRN
// // ═══════════════════════════════════════════════════════════════
// function CopyIRN({ irn }) {
//   const [copied, setCopied] = useState(false);
//   const handleCopy = () => {
//     navigator.clipboard?.writeText(irn).then(() => {
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     });
//   };
//   return (
//     <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
//       <span
//         style={{
//           fontFamily: "monospace",
//           fontSize: 10.5,
//           color: "#1e293b",
//           wordBreak: "break-all",
//           lineHeight: 1.7,
//           flex: 1,
//         }}
//       >
//         {irn}
//       </span>
//       <button
//         onClick={handleCopy}
//         title="Copy IRN"
//         style={{
//           flexShrink: 0,
//           border: `1px solid ${copied ? "darkgreen" : "#e2e8f0"}`,
//           background: copied ? "#f0fff4" : "#f8fafc",
//           borderRadius: 6,
//           padding: "3px 10px",
//           cursor: "pointer",
//           fontSize: 11,
//           color: copied ? "darkgreen" : "#475569",
//           fontWeight: 600,
//           transition: "all 0.2s",
//           whiteSpace: "nowrap",
//         }}
//       >
//         {copied ? "✓ Copied" : "📋 Copy"}
//       </button>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════
// //  FORMAT DATE
// // ═══════════════════════════════════════════════════════════════
// function formatAckDate(raw) {
//   if (!raw || raw === "—") return raw || "—";
//   const d = new Date(raw);
//   if (isNaN(d)) return raw;
//   return d.toLocaleString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// }

// // ═══════════════════════════════════════════════════════════════
// //  MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════
// function EInvoice() {
//   const dispatch = useDispatch();
//   const _Common = useSelector((store) => store.states.Common);
//   const _HT = useSelector((store) => store.states.Header);
//   const _selecrparem = useSelector((state) => state.SelectOption.parems);

//   // ─── column/area/settings state ───
//   const [iScrId, setiScrId] = useState(0);
//   const [strColName, setstrColName] = useState("");
//   const [strAliasName, setstrAliasName] = useState("");
//   const [strDatatype, setstrDatatype] = useState("");
//   const [strTransName, setstrTransName] = useState("");
//   const [strdefaultval, setstrdefaultval] = useState("");
//   const [strval, setstrval] = useState("");
//   const [isShow, setisShow] = useState(true);
//   const [iAreaId, setiAreaId] = useState(0);
//   const [iColId, setiColId] = useState(0);
//   const [isSetting, setisSetting] = useState(false);

//   // ─── data state ───
//   const [ListEntItem, setListEntItem] = useState([]);
//   const [arrEntCol, setarrEntCol] = useState([]);
//   const [arrEntArea, setarrEntArea] = useState([]);
//   const [EntJsonInv, setEntJsonInv] = useState([]);
//   const [einvResp, setEinvResp] = useState(null);

//   // ─── UI state ───
//   const [toasts, setToasts] = useState([]);
//   const [showCancelModal, setShowCancelModal] = useState(false);

//   // ─── credential popup state ───
//   const [showCredPopup, setShowCredPopup] = useState(false);
//   const [nicCred, setNicCred] = useState({ ApiUserName: "", ApiPassword: "" });
//   const [credSaving, setCredSaving] = useState(false);

//   // ─── validation modal state ───
//   const [showValidModal, setShowValidModal] = useState(false);
//   const [validErrors, setValidErrors] = useState([]);
//   const [validWarnings, setValidWarnings] = useState([]);

//   useEffect(() => {
//     Load_EInvoice(_Common.iScrId, _HT.SelectedVouchId);
//   }, []);

//   // ─────────────────────────────────────────────────────────────
//   //  TOAST HELPER
//   // ─────────────────────────────────────────────────────────────
//   const showToast = useCallback(
//     (message, type = "success", duration = 3500) => {
//       const id = Date.now() + Math.random();
//       setToasts((prev) => [...prev, { id, message, type }]);
//       setTimeout(
//         () => setToasts((prev) => prev.filter((t) => t.id !== id)),
//         duration,
//       );
//     },
//     [],
//   );

//   // ─────────────────────────────────────────────────────────────
//   //  NORMALIZE
//   // ─────────────────────────────────────────────────────────────
//   const normalizeEInv = (d) => {
//     console.log("RAW TaxPro Response:", JSON.stringify(d, null, 2));
//     return {
//       irn:           d?.irn           || d?.Irn           || d?.IRN           || "",
//       ackNo:         d?.ackNo         || d?.AckNo         || d?.AckNO         || "",
//       ackDt:         d?.ackDt         || d?.AckDt         || d?.AckDate       || "",
//       signedQRCode:  d?.signedQRCode  || d?.SignedQRCode  || d?.SignedQrCode  || d?.signedQrCode || d?.QrCode || d?.qrCode || d?.QRCode || "",
//       signedInvoice: d?.signedInvoice || d?.SignedInvoice || d?.signedJson    || d?.SignedJson   || "",
//       qrCodeImage:   d?.qrCodeImage   || d?.QrCodeImage   || d?.QRCodeImage   || d?.qrImage     || d?.QrImage || "",
//       cancelIRN:     d?.cancelIRN     || d?.CancelIRN     || null,
//     };
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  LOAD
//   // ─────────────────────────────────────────────────────────────
//   const Load_EInvoice = async (ScrId, VouchId) => {
//     try {
//       setiScrId(ScrId);
//       dispatch(setload_Screen(true));
//       const Res = await userApp.get(
//         `GST/Load_EInvoice/${ScrId}/${VouchId}/${Number(localStorage.ComId)}/${Number(localStorage.FYId)}/${localStorage.db}/${localStorage.Msdb}`,
//       );
//       if (Res.data.strStatus !== "Success") {
//         setEinvResp(null);
//         return;
//       }
//       await AssignVoucher_Data(ScrId, Res.data);
//       const raw = Res.data.eInvoice || Res.data.EInvoice || null;
//       const mapped = raw ? normalizeEInv(raw) : null;
//       setEinvResp(mapped?.irn ? mapped : null);
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  ASSIGN VOUCHER DATA
//   // ─────────────────────────────────────────────────────────────
//   const AssignVoucher_Data = async (ScrId, InvtDT) => {
//     let EntArea = InvtDT.EntArea,
//       EntCol = InvtDT.EntCol;
//     let EntTax = InvtDT.objEntTax,
//       EntSummary = InvtDT.objEntSummary;
//     let Summary = EntSummary[0],
//       EntHT = InvtDT.objEntHT;
//     let EntParty = InvtDT.Party,
//       EntShipAdd = InvtDT.EntShippingAdd;
//     let EntCompany = InvtDT.Company,
//       EntItem = InvtDT.objEntDT;
//     let TaxRelId = EntHT[0].iTaxTypeId,
//       iTCSApplicable = EntHT[0].iTCSApplicable;
//     let dSGST = 0,
//       dCGST = 0,
//       dIGST = 0,
//       dTCS = 0;

//     const checkbuyerseller = (p, c, type) => {
//       switch (ScrId) {
//         case 11:
//         case 76:
//         case 78:
//           return type === "Sell" ? p : c;
//         case 17:
//         case 67:
//         case 73:
//           return type === "Sell" ? c : p;
//         default:
//           return p;
//       }
//     };

//     EntTax.forEach((dt) => {
//       if (dt.taxDesc.startsWith("SGST") && TaxRelId === 1) dSGST += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("CGST") && TaxRelId === 1)
//         dCGST += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("IGST") && TaxRelId === 2)
//         dIGST += dt.taxAmt;
//       else if (dt.taxDesc.startsWith("TCS") && iTCSApplicable === 1)
//         dTCS += dt.taxAmt;
//     });
//     Summary = { ...Summary, sgst: dSGST, cgst: dCGST, igst: dIGST, tcs: dTCS };

//     const objData = [
//       { iAreaId: 1, data: EntHT[0] },
//       { iAreaId: 2, data: EntHT[0] },
//       {
//         iAreaId: 3,
//         data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell"),
//       },
//       { iAreaId: 4, data: checkbuyerseller(EntParty[0], EntCompany[0], "Buy") },
//       {
//         iAreaId: 5,
//         data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell"),
//       },
//       { iAreaId: 6, data: EntShipAdd },
//       { iAreaId: 7, data: Summary },
//       { iAreaId: 8, data: EntHT[0] },
//       { iAreaId: 9, data: EntItem },
//     ];

//     let objInvoice = { Version: "1.1" };
//     EntArea.forEach((area) => {
//       const AreaCol = EntCol.filter((c) => c.iAreaId === area.iAreaId);
//       const Entdt = objData.find((c) => c.iAreaId === area.iAreaId)?.data;

//       if (area.iAreaId !== 9) {
//         let objDT = {};
//         AreaCol.forEach((col) => {
//           if (col.strConditionCol === "") {
//             if (col.strdatatype === "cmb")
//               objDT = { ...objDT, [col.strGstcolName]: col.strValue };
//             else if (col.strdatatype === "decimal")
//               objDT = {
//                 ...objDT,
//                 [col.strGstcolName]: Number(col.strdefaultvalue),
//               };
//             else objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
//           } else {
//             let value = Entdt[col.strConditionCol];
//             if (col.strGstcolName === "Dt" && value) {
//               const dt = new Date(value);
//               if (!isNaN(dt))
//                 value = `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
//               else value = "";
//             } else if (["Stcd", "Pin", "Gstin"].includes(col.strGstcolName)) {
//               value = value ? String(value) : "";
//             } else if (col.strdatatype === "decimal") {
//               value = value ? Number(value) : 0;
//             }
//             objDT = { ...objDT, [col.strGstcolName]: value };
//           }
//         });
//         objInvoice = { ...objInvoice, [area.strAreaCol]: objDT };
//       } else {
//         const arrItem = [];
//         Entdt.forEach((dt) => {
//           let objDT = {};
//           AreaCol.forEach((col) => {
//             if (col.strConditionCol === "") {
//               if (col.strdatatype === "decimal") {
//                 switch (col.strGstcolName) {
//                   case "igstAmt":
//                     if (TaxRelId === 2)
//                       objDT = {
//                         ...objDT,
//                         [col.strGstcolName]: Number(dt.taxAmt),
//                       };
//                     break;
//                   case "CgstAmt":
//                   case "SgstAmt":
//                     if (TaxRelId === 1)
//                       objDT = {
//                         ...objDT,
//                         [col.strGstcolName]: Number(dt.taxAmt / 2),
//                       };
//                     break;
//                   default:
//                     objDT = {
//                       ...objDT,
//                       [col.strGstcolName]: Number(col.strdefaultvalue),
//                     };
//                     break;
//                 }
//               } else {
//                 objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
//               }
//             } else {
//               let v = dt[col.strConditionCol];
//               if (col.strdatatype === "decimal") v = v ? Number(v) : 0;
//               else if (col.strGstcolName === "IsServc") v = "N";
//               else if (col.strGstcolName === "SlNo") v = v ? v.toString() : "1";
//               else if (col.strGstcolName === "HsnCd") {
//                 v = v ? String(v) : null;
//                 if (v && v.length > 8) v = v.substring(0, 8);
//               }
//               objDT = { ...objDT, [col.strGstcolName]: v };
//             }
//           });
//           arrItem.push(objDT);
//         });
//         setListEntItem(arrItem);
//         objInvoice = { ...objInvoice, ItemList: arrItem };
//       }
//     });

//     if (objInvoice.DocDtls?.Dt?.includes("-")) {
//       const p = objInvoice.DocDtls.Dt.split("-");
//       if (p.length === 3) objInvoice.DocDtls.Dt = `${p[2]}/${p[1]}/${p[0]}`;
//     }
//     await View_Distance(objInvoice);
//     setarrEntArea(EntArea);
//     setarrEntCol(EntCol);
//   };
// const View_Distance = async (objInvoice) => {
//     try {
//       const p1 = objInvoice["SellerDtls"]?.["Pin"],
//         p2 = objInvoice["ShipDtls"]?.["Pin"];

//       if (!p1 || !p2) {
//         objInvoice["EwbDtls"]["Distance"] = 0;
//       } else {
//         const c1 = await fetchCoordinates(p1),
//           c2 = await fetchCoordinates(p2);

//         if (!c1 || !c2) {
//           objInvoice["EwbDtls"]["Distance"] = 0;
//         } else {
//           let roadDistance = 0;
//           try {
//             // ✅ OSRM — actual road distance (free, no API key)
//             const osrmRes = await fetch(
//               `https://router.project-osrm.org/route/v1/driving/${c1.lon},${c1.lat};${c2.lon},${c2.lat}?overview=false`
//             );
//             const osrmData = await osrmRes.json();

//             if (osrmData.code === "Ok" && osrmData.routes?.length > 0) {
//               roadDistance = Math.round(osrmData.routes[0].distance / 1000);
//             } else {
//               throw new Error("OSRM no route");
//             }
//           } catch {
//             // ✅ Fallback — Haversine * 1.35 if OSRM fails
//             const R = 6371e3,
//               φ1 = (c1.lat * Math.PI) / 180,
//               φ2 = (c2.lat * Math.PI) / 180,
//               Δφ = ((c2.lat - c1.lat) * Math.PI) / 180,
//               Δλ = ((c2.lon - c1.lon) * Math.PI) / 180;
//             const a =
//               Math.sin(Δφ / 2) ** 2 +
//               Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
//             roadDistance = Math.round(
//               ((R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) / 1000) * 1.35
//             );
//           }

//           objInvoice["EwbDtls"]["Distance"] = roadDistance;
//         }
//       }
//       setEntJsonInv([objInvoice]);
//     } catch (err) {
//       showToast(err.message, "error");
//     }
//   };

// const fetchCoordinates = async (pincode) => {
//     try {
//       const res = await fetch(
//         `https://nominatim.openstreetmap.org/search?q=${pincode}&countrycodes=in&format=json`,
//       );
//       const data = await res.json();
//       return data?.length > 0
//         ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) }
//         : null;
//     } catch {
//       return null;
//     }
//   };
//   // ─────────────────────────────────────────────────────────────
//   //  VALIDATE — FULL NIC PORTAL RULES (world-class)
//   // ─────────────────────────────────────────────────────────────
//   const validateEInvoice = () => {
//     const inv = EntJsonInv?.[0];
//     const errors = [];
//     const warnings = [];

//     if (!inv) {
//       errors.push("Invoice data not loaded. Please refresh and try again.");
//       return { errors, warnings };
//     }

//     const emailRx = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;

//     // ── Document ──────────────────────────────────────────────
//     const docNo = inv.DocDtls?.No || "";
//     if (!docNo)
//       errors.push("Invoice Number is missing — required by NIC portal.");
//     else if (!/^([a-zA-Z1-9]{1}[a-zA-Z0-9\/\-]{0,15})$/.test(docNo.trim()))
//       errors.push(
//         `Invoice Number "${docNo}" is invalid — only letters, numbers, / and - are allowed. Max 16 characters.`,
//       );

//     const docDt = inv.DocDtls?.Dt || "";
//     if (!docDt) {
//       errors.push("Invoice Date is missing — required by NIC portal.");
//     } else {
//       const parts = docDt.includes("-")
//         ? docDt.split("-").reverse()
//         : docDt.split("/");
//       const dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
//       if (isNaN(dt))
//         errors.push(
//           `Invoice Date "${docDt}" is invalid. Expected format: DD/MM/YYYY.`,
//         );
//       else if (dt > new Date())
//         errors.push(
//           `Invoice Date "${docDt}" is a future date — NIC does not allow future-dated invoices.`,
//         );
//     }

//     // ── Transaction Details ───────────────────────────────────
//     const supTyp = inv.TranDtls?.SupTyp || "";
//     if (!supTyp)
//       errors.push("Supply Type (SupTyp) is missing in Transaction Details.");

//     // ── Seller ────────────────────────────────────────────────
//     const selGstin = inv.SellerDtls?.Gstin || "";
//     if (!selGstin)
//       errors.push("Seller GSTIN is missing — mandatory for E-Invoice.");
//     else if (selGstin.length !== 15)
//       errors.push(
//         `Seller GSTIN "${selGstin}" must be exactly 15 characters (currently ${selGstin.length} characters).`,
//       );

//     const selPin = String(inv.SellerDtls?.Pin || "");
//     if (!selPin || selPin.length !== 6 || isNaN(selPin))
//       errors.push(
//         `Seller Pincode "${selPin || "empty"}" must be exactly 6 digits (e.g. 641001).`,
//       );

//     const selLoc = inv.SellerDtls?.Loc || "";
//     if (!selLoc) errors.push("Seller Location (city/town name) is missing.");

//     const selAddr1 = inv.SellerDtls?.Addr1 || "";
//     if (!selAddr1)
//       errors.push("Seller Address Line 1 is missing — required by NIC portal.");

//     // Email — NIC ErrorCode 5002: must be 6–100 chars, valid format → ERROR
//     const selEmail = inv.SellerDtls?.Em || "";
//     if (
//       !selEmail ||
//       selEmail.length < 6 ||
//       selEmail.length > 100 ||
//       !emailRx.test(selEmail)
//     )
//       errors.push(
//         `Seller Email "${selEmail || "empty"}" is invalid — NIC requires a valid email address between 6 and 100 characters (e.g. info@yourcompany.com). [NIC ErrorCode 5002]`,
//       );

//     // ── Buyer ─────────────────────────────────────────────────
//     const buyGstin = inv.BuyerDtls?.Gstin || "";
//     if (!buyGstin)
//       errors.push("Buyer GSTIN is missing — mandatory for E-Invoice.");
//     else if (buyGstin.length !== 15)
//       errors.push(
//         `Buyer GSTIN "${buyGstin}" must be exactly 15 characters (currently ${buyGstin.length} characters).`,
//       );

//     const buyPin = String(inv.BuyerDtls?.Pin || "");
//     if (!buyPin || buyPin.length !== 6 || isNaN(buyPin))
//       errors.push(
//         `Buyer Pincode "${buyPin || "empty"}" must be exactly 6 digits (e.g. 641001).`,
//       );

//     const buyLoc = inv.BuyerDtls?.Loc || "";
//     if (!buyLoc) errors.push("Buyer Location (city/town name) is missing.");

//     const buyAddr1 = inv.BuyerDtls?.Addr1 || "";
//     if (!buyAddr1)
//       errors.push("Buyer Address Line 1 is missing — required by NIC portal.");

//     const buyStcd = String(inv.BuyerDtls?.Stcd || "");
//     if (!buyStcd)
//       errors.push(
//         "Buyer State Code (Place of Supply) is missing — required for GST computation.",
//       );

//     // Email — NIC ErrorCode 5002: must be 6–100 chars → ERROR
//     const buyEmail = inv.BuyerDtls?.Em || "";
//     if (
//       !buyEmail ||
//       buyEmail.length < 6 ||
//       buyEmail.length > 100 ||
//       !emailRx.test(buyEmail)
//     )
//       errors.push(
//         `Buyer Email "${buyEmail || "empty"}" is invalid — NIC requires a valid email between 6 and 100 characters (e.g. buyer@company.com). [NIC ErrorCode 5002]`,
//       );

//     // ── E-Way Bill ────────────────────────────────────────────
//     const ewb = inv.EwbDtls;
//     if (ewb) {
//       const vehNo = String(ewb.VehNo || "").trim();
//       const transMode = String(ewb.TransMode || "").trim();
//       const distance = Number(ewb.Distance || 0);

//       // NIC ErrorCode 5002: min 4, max 20 chars → ERROR
//       if (!vehNo) {
//         errors.push(
//           "Vehicle Number is missing — NIC requires Vehicle Number between 4 and 20 characters (e.g. TN01AB1234). [NIC ErrorCode 5002]",
//         );
//       } else if (vehNo.length < 4) {
//         errors.push(
//           `Vehicle Number "${vehNo}" is too short — minimum 4 characters required by NIC portal. [NIC ErrorCode 5002]`,
//         );
//       } else if (vehNo.length > 20) {
//         errors.push(
//           `Vehicle Number "${vehNo}" is too long — maximum 20 characters allowed by NIC portal. [NIC ErrorCode 5002]`,
//         );
//       } else if (!/^[A-Z0-9]+$/i.test(vehNo)) {
//         errors.push(
//           `Vehicle Number "${vehNo}" contains invalid characters — only letters and numbers are allowed.`,
//         );
//       }

//       if (!transMode) {
//         errors.push(
//           "Transport Mode is missing — select: 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).",
//         );
//       } else if (!["1", "2", "3", "4"].includes(transMode)) {
//         errors.push(
//           `Transport Mode "${transMode}" is invalid — must be 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).`,
//         );
//       }

//       if (distance <= 0)
//         warnings.push(
//           "Distance is 0 km — verify that seller and buyer pincodes are correct. NIC may reject E-Way Bill if distance is 0.",
//         );
//       else if (distance > 4000)
//         warnings.push(
//           `Distance of ${distance} km seems unusually high — please verify seller and buyer pincodes are correct.`,
//         );

//       const transDocNo = String(ewb.TransDocNo || "").trim();
//       if (transDocNo && (transDocNo.length < 1 || transDocNo.length > 15))
//         errors.push(
//           `Transport Document No "${transDocNo}" must be between 1 and 15 characters.`,
//         );

//       const vehType = ewb.VehType || "";
//       if (vehType && !["R", "O"].includes(vehType))
//         errors.push(
//           `Vehicle Type "${vehType}" is invalid — must be R (Regular) or O (ODC/Over-Dimensional Cargo).`,
//         );
//     }

//     // ── Items ─────────────────────────────────────────────────
//     const items = inv.ItemList || [];
//     if (items.length === 0)
//       errors.push(
//         "No items found in invoice — at least 1 item is required to generate E-Invoice.",
//       );
//     else if (items.length > 100)
//       errors.push(
//         `Invoice has ${items.length} items — NIC portal allows a maximum of 100 items per E-Invoice.`,
//       );

//     items.forEach((item, i) => {
//       const n = i + 1;
//       const name = item.PrdDesc || `Item ${n}`;

//       if (!item.PrdDesc || String(item.PrdDesc).trim().length < 3)
//         errors.push(
//           `Item ${n}: Product Description is missing or too short — minimum 3 characters required.`,
//         );

//       const hsnCd = String(item.HsnCd || "").trim();
//       if (!hsnCd)
//         errors.push(
//           `Item ${n} (${name}): HSN Code is missing — mandatory for all E-Invoice items.`,
//         );
//       else if (!/^\d+$/.test(hsnCd))
//         errors.push(
//           `Item ${n} (${name}): HSN Code "${hsnCd}" must contain digits only.`,
//         );
//       else if (hsnCd.length < 4)
//         errors.push(
//           `Item ${n} (${name}): HSN Code "${hsnCd}" must be at least 4 digits.`,
//         );
//       else if (hsnCd.length > 8)
//         errors.push(
//           `Item ${n} (${name}): HSN Code "${hsnCd}" must be maximum 8 digits.`,
//         );

//       if (!item.Unit)
//         errors.push(
//           `Item ${n} (${name}): Unit of measurement is missing (e.g. NOS, KGS, MTR, LTR).`,
//         );

//       const qty = Number(item.Qty);
//       if (!qty || qty <= 0)
//         errors.push(
//           `Item ${n} (${name}): Quantity must be greater than 0 (current value: ${item.Qty || 0}).`,
//         );

//       const rate = Number(item.UnitPrice);
//       if (rate === undefined || rate === null || rate < 0)
//         errors.push(
//           `Item ${n} (${name}): Unit Price cannot be negative (current value: ${item.UnitPrice || 0}).`,
//         );

//       const totVal = Number(item.TotItemVal);
//       if (!totVal || totVal <= 0)
//         errors.push(
//           `Item ${n} (${name}): Total Item Value must be greater than 0.`,
//         );

//       const gstRt = Number(
//         item.GstRt ?? item.IgstRt ?? Number(item.CgstRt || 0) * 2 ?? 0,
//       );
//       if (gstRt < 0)
//         errors.push(`Item ${n} (${name}): GST Rate cannot be negative.`);
//       else if (
//         ![0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28].includes(gstRt)
//       )
//         warnings.push(
//           `Item ${n} (${name}): GST Rate ${gstRt}% is non-standard — verify it's a valid GST slab (0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, or 28%).`,
//         );

//       const slNo = String(item.SlNo || "");
//       if (!slNo || isNaN(Number(slNo)))
//         warnings.push(
//           `Item ${n} (${name}): Serial Number (SlNo) is missing or not numeric — may be auto-fixed.`,
//         );
//     });

//     // ── Value Details ─────────────────────────────────────────
//     const totInvVal = Number(inv.ValDtls?.TotInvVal || 0);
//     if (totInvVal <= 0)
//       errors.push("Total Invoice Value must be greater than 0.");
//     else if (totInvVal > 999999999999.99)
//       errors.push(
//         `Total Invoice Value ₹${totInvVal.toLocaleString("en-IN")} exceeds NIC maximum limit.`,
//       );

//     const assAmt = Number(inv.ValDtls?.AssVal || 0);
//     if (assAmt <= 0)
//       warnings.push(
//         "Assessable Value (AssVal) in Value Details is 0 — please verify invoice totals are correct.",
//       );

//     return { errors, warnings };
//   };

// // const validateEInvoice = () => {
// //   const inv = EntJsonInv?.[0];
// //   const errors = [];
// //   const warnings = [];

// //   if (!inv) {
// //     errors.push("Invoice data not loaded.");
// //     return { errors, warnings };
// //   }

// //   // ── Doc Details ──
// //   if (!inv.DocDtls?.No)
// //     errors.push("Invoice Number is missing.");
// //   if (!inv.DocDtls?.Dt)
// //     errors.push("Invoice Date is missing.");
// //   if (!inv.DocDtls?.Typ)
// //     errors.push("Document Type is missing.");

// //   // ── Transaction ──
// //   if (!inv.TranDtls?.SupTyp)
// //     errors.push("Supply Type is missing.");
// //   if (!inv.TranDtls?.TaxSch)
// //     errors.push("Tax Scheme is missing.");

// //   // ── Seller ──
// //   if (!inv.SellerDtls?.Gstin || inv.SellerDtls.Gstin.length !== 15)
// //     errors.push("Seller GSTIN is invalid or missing.");
// //   if (!inv.SellerDtls?.LglNm)
// //     errors.push("Seller Legal Name is missing.");
// //   if (!inv.SellerDtls?.Addr1)
// //     errors.push("Seller Address is missing.");
// //   if (!inv.SellerDtls?.Loc)
// //     errors.push("Seller Location is missing.");
// //   if (!inv.SellerDtls?.Pin)
// //     errors.push("Seller Pincode is missing.");
// //   if (!inv.SellerDtls?.Stcd)
// //     errors.push("Seller State Code is missing.");

// //   // ── Buyer ──
// //   if (!inv.BuyerDtls?.Gstin || inv.BuyerDtls.Gstin.length !== 15)
// //     errors.push("Buyer GSTIN is invalid or missing.");
// //   if (!inv.BuyerDtls?.LglNm)
// //     errors.push("Buyer Legal Name is missing.");
// //   if (!inv.BuyerDtls?.Addr1)
// //     errors.push("Buyer Address is missing.");
// //   if (!inv.BuyerDtls?.Loc)
// //     errors.push("Buyer Location is missing.");
// //   if (!inv.BuyerDtls?.Pin)
// //     errors.push("Buyer Pincode is missing.");
// //   if (!inv.BuyerDtls?.Stcd)
// //     errors.push("Buyer State Code is missing.");
// //   if (!inv.BuyerDtls?.Pos)
// //     errors.push("Place of Supply is missing.");

// //   // ── Items ──
// //   if (!inv.ItemList || inv.ItemList.length === 0)
// //     errors.push("No items found in invoice.");

// //   inv.ItemList?.forEach((item, i) => {
// //     const n = i + 1;
// //     const nm = item.PrdDesc || `Item ${n}`;
// //     if (!item.PrdDesc)
// //       errors.push(`Item ${n}: Product Description is missing.`);
// //     if (!item.HsnCd)
// //       errors.push(`Item ${n} (${nm}): HSN Code is missing.`);
// //     if (!item.Unit)
// //       errors.push(`Item ${n} (${nm}): Unit is missing.`);
// //     if (!item.Qty || Number(item.Qty) <= 0)
// //       errors.push(`Item ${n} (${nm}): Quantity must be greater than 0.`);
// //     if (Number(item.UnitPrice) < 0)
// //       errors.push(`Item ${n} (${nm}): Unit Price cannot be negative.`);
// //     if (!item.TotItemVal || Number(item.TotItemVal) <= 0)
// //       errors.push(`Item ${n} (${nm}): Total Item Value must be greater than 0.`);
// //   });

// //   // ── Value Details ──
// //   if (!inv.ValDtls?.TotInvVal || Number(inv.ValDtls.TotInvVal) <= 0)
// //     errors.push("Total Invoice Value must be greater than 0.");

// //   return { errors, warnings };
// // };

//   // ─────────────────────────────────────────────────────────────
//   //  HANDLE GENERATE CLICK
//   // ─────────────────────────────────────────────────────────────
//   const Handle_Generate_Click = () => {
//     const { errors, warnings } = validateEInvoice();
//     setValidErrors(errors);
//     setValidWarnings(warnings);
//     setShowValidModal(true);
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  GENERATE
//   // ─────────────────────────────────────────────────────────────
//   const Create_EInvoice = async () => {
//     try {
//       dispatch(setload_Screen(true));
//       if (EntJsonInv?.[0]?.DocDtls?.Dt?.includes("-")) {
//         const [y, m, d] = EntJsonInv[0].DocDtls.Dt.split("-");
//         EntJsonInv[0].DocDtls.Dt = `${d}/${m}/${y}`;
//       }
//       if (EntJsonInv?.[0]?.TranDtls) {
//         const t = EntJsonInv[0].TranDtls;
//         if (!t.EcmGstin || t.EcmGstin.length !== 15) delete t.EcmGstin;
//       }
//       const payload = {
//         iSalInvId: _HT.SelectedVouchId,
//         iClientId: Number(localStorage.ClientId),
//         strCompanyDB: localStorage.db,
//         EntJsonInv: JSON.stringify(EntJsonInv[0]),
//       };
//       const res = await userApp.post("GST/Generate_EInvoice", payload);
//       if (res?.data?.strStatus === "Success") {
//         const mapped = normalizeEInv(res.data.data);
//         if (!mapped.irn) {
//           showToast("IRN not received. Please try again.", "error");
//           return;
//         }
//         setEinvResp(mapped);
//         showToast("E-Invoice generated successfully!", "success");
//       } else {
//         showToast(
//           res.data?.strMessage || "Generate failed. Please try again.",
//           "error",
//         );
//       }
//     } catch (err) {
//       const msg =
//         err?.response?.data?.strMessage ||
//         err?.response?.data?.message ||
//         err.message ||
//         "Unexpected error";
//       if (
//         msg?.toLowerCase().includes("nic credential not found") ||
//         msg?.toLowerCase().includes("credential not found")
//       ) {
//         setShowCredPopup(true);
//         return;
//       }
//       if (msg?.includes("2150") || msg?.toLowerCase().includes("duplicate")) {
//         showToast("IRN already exists. Loading existing record...", "info");
//         await Load_EInvoice(iScrId, _HT.SelectedVouchId);
//         return;
//       }
//       showToast(msg, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  SAVE CREDENTIAL
//   // ─────────────────────────────────────────────────────────────
//   const Save_Credential = async () => {
//     if (!nicCred.ApiUserName.trim() || !nicCred.ApiPassword.trim()) {
//       showToast("Please enter both Username and Password.", "error");
//       return;
//     }
//     try {
//       setCredSaving(true);
//       const gstin = EntJsonInv?.[0]?.SellerDtls?.Gstin || "";
//       const res = await userApp.post("GST/Save_NIC_Credential", {
//         ClientId: Number(localStorage.ClientId),
//         GSTIN: gstin,
//         ApiUserName: nicCred.ApiUserName.trim(),
//         ApiPassword: nicCred.ApiPassword.trim(),
//       });
//       if (res.data?.strStatus === "Success") {
//         showToast("Credential saved successfully!", "success");
//         setShowCredPopup(false);
//         setNicCred({ ApiUserName: "", ApiPassword: "" });
//         await Create_EInvoice();
//       } else {
//         showToast(
//           res.data?.strMessage || "Failed to save credential.",
//           "error",
//         );
//       }
//     } catch (err) {
//       showToast(
//         err?.response?.data?.strMessage ||
//           err.message ||
//           "Error saving credential.",
//         "error",
//       );
//     } finally {
//       setCredSaving(false);
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  CANCEL
//   // ─────────────────────────────────────────────────────────────
//   const Cancel_EInvoice = async () => {
//     const irn = einvResp?.irn;
//     if (!irn) return;
//     setShowCancelModal(false);
//     try {
//       dispatch(setload_Screen(true));
//       const res = await userApp.post("GST/Cancel_EInvoice", {
//         Irn: irn,
//         Reason: 1,
//         Remarks: "Cancelled by user",
//         iSalInvId: _HT.SelectedVouchId,
//         iClientId: Number(localStorage.ClientId),
//         strCompanyDB: localStorage.db,
//       });
//       if (res.data?.strStatus === "Success") {
//         showToast("E-Invoice cancelled successfully.", "success");
//         await Load_EInvoice(iScrId, _HT.SelectedVouchId);
//       } else {
//         showToast(res.data?.strMessage || "Cancel failed.", "error");
//       }
//     } catch (err) {
//       showToast(
//         err?.response?.data?.strMessage ||
//           err.message ||
//           "Error cancelling E-Invoice.",
//         "error",
//       );
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  PRINT
//   // ─────────────────────────────────────────────────────────────
//   const Print_EInvoice = async () => {
//     try {
//       const inv = EntJsonInv[0] || {};
//       const einv = einvResp || {};
//       const seller = inv.SellerDtls || {};
//       const buyer = inv.BuyerDtls || {};
//       const ship = inv.ShipDtls || {};
//       const doc2 = inv.DocDtls || {};
//       const tran = inv.TranDtls || {};
//       const val = inv.ValDtls || {};
//       const items = inv.ItemList || [];

//       const getQRDataUrl = () =>
//         new Promise((resolve) => {
//           if (einv.qrCodeImage) {
//             resolve(`data:image/png;base64,${einv.qrCodeImage}`);
//             return;
//           }
//           if (!einv.signedQRCode) {
//             resolve("");
//             return;
//           }
//           const jwt = einv.signedQRCode;
//           const doRender = () => {
//             try {
//               const wrap = document.createElement("div");
//               document.body.appendChild(wrap);
//               wrap.style.cssText = "position:fixed;left:-9999px;top:-9999px;";
//               new window.QRCode(wrap, {
//                 text: jwt,
//                 width: 160,
//                 height: 160,
//                 correctLevel: window.QRCode.CorrectLevel.M,
//               });
//               setTimeout(() => {
//                 const c = wrap.querySelector("canvas");
//                 resolve(c ? c.toDataURL("image/png") : "");
//                 document.body.removeChild(wrap);
//               }, 150);
//             } catch (e) {
//               resolve("");
//             }
//           };
//           if (window.QRCode) {
//             doRender();
//             return;
//           }
//           const ex = document.getElementById("__qrcodejs__");
//           if (ex) {
//             ex.addEventListener("load", doRender);
//             return;
//           }
//           const s = document.createElement("script");
//           s.id = "__qrcodejs__";
//           s.src =
//             "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js";
//           s.onload = doRender;
//           s.onerror = () => resolve("");
//           document.head.appendChild(s);
//         });

//       const qrDataUrl = await getQRDataUrl();
//       const qrHtml = qrDataUrl
//         ? `<img src="${qrDataUrl}" style="width:130px;height:130px;display:block;"/>`
//         : `<div style="width:130px;height:130px;border:1px dashed #aaa;display:flex;align-items:center;justify-content:center;font-size:10px;color:#999;">QR N/A</div>`;

//       const fmt = (n, d = 2) => Number(n || 0).toFixed(d);
//       const esc = (s) =>
//         String(s || "")
//           .replace(/&/g, "&amp;")
//           .replace(/</g, "&lt;")
//           .replace(/>/g, "&gt;");
//       const addr = (o) =>
//         [o.Addr1, o.Addr2, o.Loc, o.Dst, o.Stcd, o.Pin]
//           .filter(Boolean)
//           .join(", ");

//       const totTaxableAmt = items.reduce(
//         (s, it) => s + Number(it.AssAmt || it.TaxableAmt || 0),
//         0,
//       );
//       const roundOff = Number(val.RndOffAmt || 0);
//       const totInvAmt = Number(val.TotInvVal || 0) || totTaxableAmt + roundOff;
//       const cgstTot = fmt(
//         items.reduce((s, it) => s + Number(it.CgstAmt || 0), 0),
//       );
//       const sgstTot = fmt(
//         items.reduce((s, it) => s + Number(it.SgstAmt || 0), 0),
//       );
//       const igstTot = fmt(
//         items.reduce((s, it) => s + Number(it.IgstAmt || 0), 0),
//       );
//       const cessTot = fmt(
//         items.reduce((s, it) => s + Number(it.CesAmt || 0), 0),
//       );

//       const itemRows = items
//         .map(
//           (it, i) => `
//         <tr>
//           <td style="text-align:center;">${i + 1}</td>
//           <td>${esc(it.PrdDesc || "")}</td>
//           <td style="text-align:center;">${esc(it.HsnCd || "")}</td>
//           <td style="text-align:right;">${fmt(it.Qty, 3)}</td>
//           <td style="text-align:center;">${esc(it.Unit || "")}</td>
//           <td style="text-align:right;">${fmt(it.UnitPrice || it.UnitVal, 2)}</td>
//           <td style="text-align:right;">${fmt(it.Discount || it.Disc || 0, 2)}</td>
//           <td style="text-align:right;">${fmt(it.AssAmt || it.TaxableAmt, 2)}</td>
//           <td style="text-align:center;">${fmt(it.GstRt || 0, 2)}%</td>
//           <td style="text-align:right;">0.00</td>
//           <td style="text-align:right;">${fmt(it.TotItemVal || it.AssAmt, 2)}</td>
//         </tr>`,
//         )
//         .join("");

//       const printDate = new Date()
//         .toLocaleString("en-IN", {
//           day: "2-digit",
//           month: "2-digit",
//           year: "numeric",
//           hour: "2-digit",
//           minute: "2-digit",
//           hour12: false,
//         })
//         .replace(",", "");

// //       const html = `<!DOCTYPE html>
// // <html lang="en">
// // <head>
// // <meta charset="UTF-8"/>
// // <title>e-Invoice — ${esc(doc2.No || "")}</title>
// // <style>
// // *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
// // @page{size:A4 portrait;margin:10mm 12mm 10mm 12mm}
// // html,body{width:210mm;font-family:Arial,Helvetica,sans-serif;font-size:8.5pt;color:#111;background:#fff;}
// // .page-wrap{width:210mm;min-height:297mm;margin:0 auto;padding:10mm 12mm;background:#fff;}
// // @media print{html,body{width:210mm;margin:0;padding:0}.page-wrap{padding:0;margin:0;width:100%}.no-print{display:none!important}}
// // .top-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;}
// // .company-block .gstin{font-size:11pt;font-weight:700;letter-spacing:.4px;margin-bottom:2px;}
// // .company-block .name{font-size:13pt;font-weight:700;}
// // .section{border:1px solid #000;margin-bottom:0;}
// // .section+.section{border-top:none;}
// // .sec-title{font-weight:700;font-size:8pt;padding:3px 6px;border-bottom:1px solid #000;background:#fff;}
// // .einv-row{display:flex;gap:0;padding:3px 6px;font-size:7.5pt;line-height:1.5;}
// // .einv-row .label{font-weight:700;white-space:nowrap;margin-right:4px;}
// // .einv-row .irn-val{font-family:'Courier New',monospace;font-size:7pt;word-break:break-all;flex:1;}
// // .ack-row{display:flex;gap:40px;padding:2px 6px 4px;font-size:7.5pt;}
// // .ack-row .label{font-weight:700;}
// // .tran-grid{display:grid;grid-template-columns:1fr 1fr 1fr;padding:4px 6px;font-size:7.5pt;line-height:1.6;gap:2px 0;}
// // .tran-grid .label{font-weight:700;}
// // .party-grid{display:grid;grid-template-columns:1fr 1fr;border-bottom:1px solid #000;}
// // .party-col{padding:4px 6px;font-size:7.5pt;line-height:1.55;}
// // .party-col+.party-col{border-left:1px solid #000;}
// // .party-col .ptitle{font-weight:700;font-size:8pt;margin-bottom:2px;border-bottom:1px solid #ddd;padding-bottom:1px;}
// // .dispatch-grid{display:grid;grid-template-columns:1fr 1fr;}
// // .dispatch-col{padding:4px 6px;font-size:7.5pt;line-height:1.55;border-top:1px solid #000;}
// // .dispatch-col+.dispatch-col{border-left:1px solid #000;}
// // .dispatch-col .ptitle{font-weight:700;font-size:8pt;margin-bottom:2px;}
// // .items-table{width:100%;border-collapse:collapse;font-size:7pt;}
// // .items-table th{font-weight:700;padding:3px 2px;border:1px solid #000;text-align:center;font-size:7pt;line-height:1.2;background:#fff;}
// // .items-table td{padding:3px 2px;border:1px solid #000;vertical-align:top;line-height:1.35;}
// // .tax-summary{width:100%;border-collapse:collapse;font-size:7pt;border-top:none;}
// // .tax-summary th,.tax-summary td{border:1px solid #000;padding:3px 3px;text-align:right;font-size:7pt;}
// // .tax-summary th{text-align:center;font-weight:700;background:#fff;}
// // .footer-row{display:flex;justify-content:space-between;align-items:flex-end;margin-top:6px;padding-top:4px;border-top:1px solid #ccc;}
// // .sign-area{font-size:7pt;color:#444;font-style:italic;text-align:right;line-height:1.6;}
// // .sign-area .esign{font-size:13pt;font-style:italic;font-family:Georgia,serif;color:#1a3c6e;font-weight:700;}
// // .print-btn{display:block;margin:0 auto 12px;padding:9px 36px;background:#0f172a;color:#fff;border:none;border-radius:6px;font-size:11pt;font-weight:700;cursor:pointer;}
// // </style>
// // </head>
// // <body>
// // <div class="no-print" style="background:#f8fafc;padding:10px;text-align:center;border-bottom:2px solid #0f172a;position:sticky;top:0;z-index:99;">
// //   <button class="print-btn" onclick="window.print()">🖨️&nbsp; Print e-Invoice (A4)</button>
// // </div>
// // <div class="page-wrap">
// // <div class="top-header">
// //   <div class="company-block">
// //     <div class="gstin">${esc(seller.Gstin || "")}</div>
// //     <div class="name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
// //   </div>
// //   <div>${qrHtml}</div>
// // </div>
// // <div class="section">
// //   <div class="sec-title">1. e-Invoice Details</div>
// //   <div class="einv-row"><span class="label">IRN :</span><span class="irn-val">${esc(einv.irn || "")}</span></div>
// //   <div class="ack-row">
// //     <div><span class="label">Ack No. : </span>${esc(String(einv.ackNo || ""))}</div>
// //     <div><span class="label">Ack Date : </span>${esc(String(einv.ackDt || ""))}</div>
// //   </div>
// // </div>
// // <div class="section">
// //   <div class="sec-title">2. Transaction Details</div>
// //   <div class="tran-grid">
// //     <div><span class="label">Supply Type : </span>${esc(tran.SupTyp || "B2B")}</div>
// //     <div><span class="label">Document No. : </span>${esc(doc2.No || "")}</div>
// //     <div><span class="label">IGST on Intra : </span>${tran.IgstOnIntra === "Y" ? "Yes" : "No"}</div>
// //     <div><span class="label">Place of Supply : </span>${esc(ship.Stcd || buyer.Stcd || "")}</div>
// //     <div><span class="label">Document Type : </span>${esc(doc2.Typ || "Tax Invoice")}</div>
// //     <div><span class="label">Document Date : </span>${esc(doc2.Dt || "")}</div>
// //     <div><span class="label">Vehicle No. : </span>${esc(String(inv.EwbDtls?.VehNo || "—"))}</div>
// //     <div><span class="label">Transport Mode : </span>${esc(
// //       inv.EwbDtls?.TransMode === "1" ? "Road" :
// //       inv.EwbDtls?.TransMode === "2" ? "Rail" :
// //       inv.EwbDtls?.TransMode === "3" ? "Air" :
// //       inv.EwbDtls?.TransMode === "4" ? "Ship" : "—"
// //     )}</div>
// //     <div><span class="label">Distance : </span>${esc(String(inv.EwbDtls?.Distance || "0"))} KM</div>
// //   </div>
// // </div>
// // <div class="section">
// //   <div class="sec-title">3. Party Details</div>
// //   <div class="party-grid">
// //     <div class="party-col">
// //       <div class="ptitle">Supplier :</div>
// //       <div><b>GSTIN :</b> ${esc(seller.Gstin || "")}</div>
// //       <div>${esc(seller.LglNm || seller.TrdNm || "")}</div>
// //       <div>${esc(addr(seller))}</div>
// //       ${seller.Ph ? `<div>${esc(seller.Ph)}</div>` : ""}
// //       ${seller.Em ? `<div>${esc(seller.Em)}</div>` : ""}
// //     </div>
// //     <div class="party-col">
// //       <div class="ptitle">Recipient :</div>
// //       <div><b>GSTIN :</b> ${esc(buyer.Gstin || "")}</div>
// //       <div>${esc(buyer.LglNm || buyer.TrdNm || "")}</div>
// //       <div>${esc(addr(buyer))}</div>
// //       <div>Place of Supply: ${esc(buyer.Stcd || "")}</div>
// //     </div>
// //   </div>
// //   <div class="dispatch-grid">
// //     <div class="dispatch-col">
// //       <div class="ptitle">Dispatch From :</div>
// //       <div>${esc(seller.LglNm || seller.TrdNm || "")}</div>
// //       <div>${esc(addr(seller))}</div>
// //     </div>
// //     <div class="dispatch-col">
// //       <div class="ptitle">Ship To :</div>
// //       <div><b>GSTIN :</b> ${esc(ship.Gstin || buyer.Gstin || "")}</div>
// //       <div>${esc(ship.LglNm || ship.TrdNm || buyer.LglNm || buyer.TrdNm || "")}</div>
// //       <div>${esc(addr(Object.keys(ship).length > 2 ? ship : buyer))}</div>
// //     </div>
// //   </div>
// // </div>
// // <div class="section">
// //   <div class="sec-title">4. Details of Goods / Services</div>
// //   <table class="items-table">
// //     <thead>
// //       <tr>
// //         <th style="width:25px;">SlNo</th>
// //         <th>Item Description</th>
// //         <th style="width:60px;">HSN Code</th>
// //         <th style="width:50px;">Quantity</th>
// //         <th style="width:35px;">Unit</th>
// //         <th style="width:65px;">Unit Price (₹)</th>
// //         <th style="width:55px;">Discount (₹)</th>
// //         <th style="width:65px;">Taxable Amt (₹)</th>
// //         <th style="width:50px;">GST Rate</th>
// //         <th style="width:45px;">Other Charges</th>
// //         <th style="width:65px;">Total (₹)</th>
// //       </tr>
// //     </thead>
// //     <tbody>${itemRows}</tbody>
// //   </table>
// //   <table class="tax-summary">
// //     <thead>
// //       <tr>
// //         <th>Taxable Amt</th><th>CGST Amt</th><th>SGST Amt</th><th>IGST Amt</th>
// //         <th>CESS Amt</th><th>State CESS</th><th>Discount</th>
// //         <th>Other Charges</th><th>Round Off</th><th>Total Inv. Amt</th>
// //       </tr>
// //     </thead>
// //     <tbody>
// //       <tr>
// //         <td>${fmt(totTaxableAmt)}</td><td>${cgstTot}</td><td>${sgstTot}</td><td>${igstTot}</td>
// //         <td>${cessTot}</td><td>0.00</td><td>${fmt(val.Discount || 0)}</td>
// //         <td>0.00</td><td>${fmt(roundOff, 2)}</td><td><b>${fmt(totInvAmt)}</b></td>
// //       </tr>
// //     </tbody>
// //   </table>
// // </div>
// // <div class="footer-row">
// //   <div>
// //     <div style="font-weight:700;font-size:7.5pt;">Generated By : ${esc(seller.Gstin || "")}</div>
// //     <div style="font-size:7pt;color:#555;margin-top:2px;">Print Date : ${printDate}</div>
// //   </div>
// //   <div class="sign-area">
// //     <div class="esign">eSign</div>
// //     <div>Digitally Signed by NIC-IRP</div>
// //     <div>on : ${esc(String(einv.ackDt || ""))}</div>
// //   </div>
// // </div>
// // </div>
// // </body>
// // </html>`;


// const html = `<!DOCTYPE html>
// <html lang="en">
// <head>
// <meta charset="UTF-8"/>
// <title>e-Invoice — ${esc(doc2.No || "")}</title>
// <style>
// *{box-sizing:border-box;margin:0;padding:0}
// @page{size:A4 portrait;margin:12mm 14mm 12mm 14mm}
// html,body{font-family:'Segoe UI',Arial,sans-serif;font-size:8pt;color:#111;background:#fff;}
// .page{width:182mm;margin:0 auto;background:#fff;}
// @media print{.no-print{display:none!important}}

// /* ══ TOP HEADER ══ */
// .header{
//   display:flex;
//   justify-content:space-between;
//   align-items:flex-start;
//   padding-bottom:10px;
//   border-bottom:2.5px solid #111;
//   margin-bottom:8px;
// }
// .header-left{}
// .tag{
//   font-size:6pt;
//   font-weight:800;
//   letter-spacing:3px;
//   text-transform:uppercase;
//   color:#555;
//   margin-bottom:4px;
// }
// .company-gstin{
//   font-size:8pt;
//   color:#444;
//   font-weight:600;
//   margin-bottom:2px;
//   letter-spacing:.5px;
// }
// .company-name{
//   font-size:18pt;
//   font-weight:800;
//   color:#111;
//   letter-spacing:-.3px;
//   line-height:1.1;
// }
// .header-right{
//   display:flex;
//   flex-direction:column;
//   align-items:flex-end;
//   gap:6px;
// }
// .doc-no-block{text-align:right;}
// .doc-no-label{
//   font-size:6pt;
//   font-weight:800;
//   letter-spacing:2px;
//   text-transform:uppercase;
//   color:#777;
//   margin-bottom:2px;
// }
// .doc-no-val{
//   font-size:13pt;
//   font-weight:800;
//   color:#111;
//   letter-spacing:.5px;
// }

// /* ══ IRN BLOCK ══ */
// .irn-block{
//   border-left:3px solid #111;
//   padding:5px 10px;
//   background:#f8f8f8;
//   margin-bottom:0;
//   display:flex;
//   align-items:baseline;
//   gap:8px;
// }
// .irn-label{
//   font-size:6.5pt;
//   font-weight:800;
//   letter-spacing:1.5px;
//   text-transform:uppercase;
//   white-space:nowrap;
//   flex-shrink:0;
// }
// .irn-val{
//   font-family:'Courier New',monospace;
//   font-size:7pt;
//   color:#222;
//   word-break:break-all;
//   line-height:1.5;
// }
// .ack-row{
//   display:flex;
//   gap:0;
//   border-bottom:1.5px solid #111;
//   border-top:1px solid #ccc;
// }
// .ack-cell{
//   padding:4px 10px;
//   font-size:7.5pt;
//   border-right:1px solid #ddd;
//   flex:1;
// }
// .ack-cell:last-child{border-right:none;}
// .ack-cell .lbl{
//   font-size:6pt;
//   font-weight:800;
//   text-transform:uppercase;
//   letter-spacing:.8px;
//   color:#777;
//   display:block;
//   margin-bottom:1px;
// }
// .ack-cell .val{font-weight:700;color:#111;}

// /* ══ SECTION HEADER ══ */
// .sec-hdr{
//   background:#111;
//   color:#fff;
//   padding:4px 10px;
//   font-size:6.5pt;
//   font-weight:800;
//   letter-spacing:2px;
//   text-transform:uppercase;
//   margin-top:0;
// }

// /* ══ GRID ROWS ══ */
// .info-grid{
//   display:grid;
//   grid-template-columns:repeat(3,1fr);
//   border-bottom:1.5px solid #111;
// }
// .info-cell{
//   padding:6px 10px;
//   border-right:1px solid #ddd;
//   font-size:7.5pt;
// }
// .info-cell:last-child{border-right:none;}
// .info-cell .lbl{
//   font-size:6pt;
//   font-weight:800;
//   text-transform:uppercase;
//   letter-spacing:.8px;
//   color:#777;
//   display:block;
//   margin-bottom:2px;
// }
// .info-cell .val{font-weight:700;color:#111;font-size:8pt;}

// /* ══ PARTY ══ */
// .party-grid{
//   display:grid;
//   grid-template-columns:1fr 1fr;
//   border-bottom:1px solid #ddd;
// }
// .party-col{padding:8px 10px;font-size:7.5pt;line-height:1.7;}
// .party-col+.party-col{border-left:1px solid #ddd;}
// .party-type{
//   font-size:6pt;
//   font-weight:800;
//   text-transform:uppercase;
//   letter-spacing:1.5px;
//   color:#555;
//   margin-bottom:4px;
//   padding-bottom:3px;
//   border-bottom:1px solid #e0e0e0;
// }
// .party-gstin{
//   display:inline-block;
//   border:1.5px solid #111;
//   font-size:7pt;
//   font-weight:800;
//   padding:1px 8px;
//   border-radius:2px;
//   margin-bottom:3px;
//   letter-spacing:.5px;
// }
// .party-name{font-weight:800;font-size:9pt;color:#111;margin-bottom:2px;line-height:1.3;}
// .party-addr{color:#444;font-size:7pt;line-height:1.65;}
// .party-contact{color:#666;font-size:7pt;margin-top:3px;font-style:italic;}
// .party-divider{
//   border-top:1.5px dashed #bbb;
// }

// /* ══ TABLE ══ */
// .items-outer{border-bottom:1.5px solid #111;}
// table{width:100%;border-collapse:collapse;font-size:7pt;}
// thead tr{border-bottom:2px solid #111;border-top:1.5px solid #111;}
// thead th{
//   padding:5px 4px;
//   font-weight:800;
//   font-size:6.5pt;
//   text-transform:uppercase;
//   letter-spacing:.4px;
//   text-align:center;
//   background:#fff;
//   color:#111;
//   border:none;
// }
// tbody tr{border-bottom:1px solid #e8e8e8;}
// tbody tr:last-child{border-bottom:2px solid #111;}
// tbody td{
//   padding:5px 4px;
//   border:none;
//   vertical-align:middle;
// }
// .sl{text-align:center;color:#888;font-weight:700;}
// .item-name{font-weight:700;font-size:7.5pt;padding-left:4px!important;}
// .num{text-align:right;}
// .cen{text-align:center;}
// .total-cell{text-align:right;font-weight:800;font-size:8pt;}

// /* ══ TAX SUMMARY ══ */
// .tax-outer{
//   border-bottom:1.5px solid #111;
//   display:grid;
//   grid-template-columns:repeat(4,1fr) 1.6fr;
// }
// .tax-cell{
//   padding:6px 8px;
//   border-right:1px solid #ddd;
//   font-size:7.5pt;
// }
// .tax-cell:last-child{
//   border-right:none;
//   background:#f0f0f0;
// }
// .tax-cell .lbl{
//   font-size:6pt;
//   font-weight:800;
//   text-transform:uppercase;
//   letter-spacing:.6px;
//   color:#777;
//   display:block;
//   margin-bottom:2px;
// }
// .tax-cell .val{font-weight:700;color:#111;}
// .tax-cell.grand .lbl{color:#111;font-size:6.5pt;}
// .tax-cell.grand .val{font-size:12pt;font-weight:900;color:#111;}

// .tax-row2{
//   border-bottom:1.5px solid #111;
//   display:grid;
//   grid-template-columns:repeat(4,1fr);
// }

// /* ══ FOOTER ══ */
// .footer{
//   display:flex;
//   justify-content:space-between;
//   align-items:flex-end;
//   padding-top:10px;
// }
// .footer-left{}
// .gen-by{font-size:7pt;color:#555;margin-bottom:1px;}
// .gen-by strong{color:#111;}
// .print-dt{font-size:6.5pt;color:#999;margin-bottom:8px;}
// #ack-barcode{}
// .barcode-num{
//   font-size:6.5pt;
//   text-align:center;
//   color:#555;
//   margin-top:2px;
//   letter-spacing:.8px;
//   font-family:'Courier New',monospace;
// }

// /* ══ ESIGN ══ */
// .esign-wrap{text-align:right;}
// .esign-logo{
//   font-family:'Brush Script MT','Segoe Script',cursive;
//   font-size:42pt;
//   color:#111;
//   font-style:italic;
//   line-height:1;
//   font-weight:700;
// }
// .esign-rule{
//   width:100%;
//   height:1px;
//   background:#111;
//   margin:3px 0;
// }
// .esign-sub{font-size:7pt;font-weight:800;color:#111;letter-spacing:.5px;}
// .esign-date{font-size:6.5pt;color:#666;margin-top:1px;}

// .print-btn{
//   display:block;margin:0 auto 12px;padding:9px 36px;
//   background:#111;color:#fff;border:none;
//   font-size:10pt;font-weight:700;cursor:pointer;
//   letter-spacing:1px;
// }
// </style>
// </head>
// <body>

// <div class="no-print" style="background:#f5f5f5;padding:10px;text-align:center;border-bottom:2px solid #111;position:sticky;top:0;z-index:99;">
//   <button class="print-btn" onclick="window.print()">🖨️ &nbsp; Print e-Invoice (A4)</button>
// </div>

// <div class="page">

//   <!-- ══ HEADER ══ -->
//   <div class="header">
//     <div class="header-left">
//       <div class="tag">GST e-Invoice</div>
//       <div class="company-gstin">${esc(seller.Gstin || "")}</div>
//       <div class="company-name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
//     </div>
//     <div class="header-right">
//       ${qrHtml}
//       <div class="doc-no-block">
//         <div class="doc-no-label">Document No.</div>
//         <div class="doc-no-val">${esc(doc2.No || "")}</div>
//       </div>
//     </div>
//   </div>

//   <!-- ══ IRN ══ -->
//   <div class="irn-block">
//     <span class="irn-label">IRN</span>
//     <span class="irn-val">${esc(einv.irn || "")}</span>
//   </div>
//   <div class="ack-row">
//     <div class="ack-cell">
//       <span class="lbl">Ack No</span>
//       <span class="val">${esc(String(einv.ackNo || ""))}</span>
//     </div>
//     <div class="ack-cell">
//       <span class="lbl">Ack Date</span>
//       <span class="val">${esc(String(einv.ackDt || ""))}</span>
//     </div>
//     <div class="ack-cell">
//       <span class="lbl">Doc Type</span>
//       <span class="val">${esc(doc2.Typ === "INV" ? "Tax Invoice" : doc2.Typ || "Tax Invoice")}</span>
//     </div>
//   </div>

//   <!-- ══ TRANSACTION DETAILS ══ -->
//   <div class="sec-hdr">Transaction Details</div>
//   <div class="info-grid">
//     <div class="info-cell">
//       <span class="lbl">Supply Type</span>
//       <span class="val">${esc(tran.SupTyp || "B2B")}</span>
//     </div>
//     <div class="info-cell">
//       <span class="lbl">Document Date</span>
//       <span class="val">${esc(doc2.Dt || "")}</span>
//     </div>
//     <div class="info-cell">
//       <span class="lbl">Place of Supply</span>
//       <span class="val">${esc(
//         buyer.Stcd === "01" ? "JAMMU AND KASHMIR" : buyer.Stcd === "02" ? "HIMACHAL PRADESH" :
//         buyer.Stcd === "03" ? "PUNJAB" : buyer.Stcd === "04" ? "CHANDIGARH" :
//         buyer.Stcd === "05" ? "UTTARAKHAND" : buyer.Stcd === "06" ? "HARYANA" :
//         buyer.Stcd === "07" ? "DELHI" : buyer.Stcd === "08" ? "RAJASTHAN" :
//         buyer.Stcd === "09" ? "UTTAR PRADESH" : buyer.Stcd === "10" ? "BIHAR" :
//         buyer.Stcd === "11" ? "SIKKIM" : buyer.Stcd === "12" ? "ARUNACHAL PRADESH" :
//         buyer.Stcd === "13" ? "NAGALAND" : buyer.Stcd === "14" ? "MANIPUR" :
//         buyer.Stcd === "15" ? "MIZORAM" : buyer.Stcd === "16" ? "TRIPURA" :
//         buyer.Stcd === "17" ? "MEGHALAYA" : buyer.Stcd === "18" ? "ASSAM" :
//         buyer.Stcd === "19" ? "WEST BENGAL" : buyer.Stcd === "20" ? "JHARKHAND" :
//         buyer.Stcd === "21" ? "ODISHA" : buyer.Stcd === "22" ? "CHHATTISGARH" :
//         buyer.Stcd === "23" ? "MADHYA PRADESH" : buyer.Stcd === "24" ? "GUJARAT" :
//         buyer.Stcd === "27" ? "MAHARASHTRA" : buyer.Stcd === "29" ? "KARNATAKA" :
//         buyer.Stcd === "30" ? "GOA" : buyer.Stcd === "32" ? "KERALA" :
//         buyer.Stcd === "33" ? "TAMIL NADU" : buyer.Stcd === "34" ? "PUDUCHERRY" :
//         buyer.Stcd === "36" ? "TELANGANA" : buyer.Stcd === "37" ? "ANDHRA PRADESH" :
//         buyer.Stcd || ""
//       )}</span>
//     </div>
//     <div class="info-cell">
//       <span class="lbl">Tax Scheme</span>
//       <span class="val">${esc(tran.TaxSch || "GST")}</span>
//     </div>
//     <div class="info-cell">
//       <span class="lbl">Vehicle Number</span>
//       <span class="val">${esc(String(inv.EwbDtls?.VehNo || "—"))}</span>
//     </div>
//     <div class="info-cell">
//       <span class="lbl">Transport Mode</span>
//       <span class="val">${esc(
//         inv.EwbDtls?.TransMode === "1" ? "Road" :
//         inv.EwbDtls?.TransMode === "2" ? "Rail" :
//         inv.EwbDtls?.TransMode === "3" ? "Air" :
//         inv.EwbDtls?.TransMode === "4" ? "Ship" : "—"
//       )}</span>
//     </div>
//   </div>

//   <!-- ══ PARTY DETAILS ══ -->
//   <div class="sec-hdr">Party Details</div>
//   <div class="party-grid">
//     <div class="party-col">
//       <div class="party-type">Supplier</div>
//       <div class="party-gstin">${esc(seller.Gstin || "")}</div>
//       <div class="party-name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
//       <div class="party-addr">${esc([seller.Addr1, seller.Addr2].filter(Boolean).join(", "))}</div>
//       <div class="party-addr">${esc(seller.Loc || "")} — ${esc(String(seller.Pin || ""))} &nbsp;${esc(seller.Stcd === "33" ? "TAMIL NADU" : seller.Stcd || "")}</div>
//       ${seller.Ph || seller.Em ? `<div class="party-contact">${[seller.Ph, seller.Em].filter(Boolean).join(" &nbsp;·&nbsp; ")}</div>` : ""}
//     </div>
//     <div class="party-col">
//       <div class="party-type">Recipient</div>
//       <div class="party-gstin">${esc(buyer.Gstin || "")}</div>
//       <div class="party-name">${esc(buyer.LglNm || buyer.TrdNm || "")}</div>
//       <div class="party-addr">${esc([buyer.Addr1, buyer.Addr2].filter(Boolean).join(", "))}</div>
//       <div class="party-addr">${esc(buyer.Loc || "")} — ${esc(String(buyer.Pin || ""))} &nbsp;${esc(buyer.Stcd === "33" ? "TAMIL NADU" : buyer.Stcd || "")}</div>
//       ${buyer.Ph || buyer.Em ? `<div class="party-contact">${[buyer.Ph, buyer.Em].filter(Boolean).join(" &nbsp;·&nbsp; ")}</div>` : ""}
//     </div>
//   </div>
//   <div class="party-grid party-divider">
//     <div class="party-col">
//       <div class="party-type">Dispatch From</div>
//       <div class="party-name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
//       <div class="party-addr">${esc([seller.Addr1, seller.Addr2].filter(Boolean).join(", "))}</div>
//       <div class="party-addr">${esc(seller.Loc || "")} — ${esc(String(seller.Pin || ""))} &nbsp;${esc(seller.Stcd === "33" ? "TAMIL NADU" : seller.Stcd || "")}</div>
//     </div>
//     <div class="party-col">
//       <div class="party-type">Ship To</div>
//       <div class="party-gstin">${esc(
//         Object.keys(inv.ShipDtls || {}).length > 2 ? (inv.ShipDtls?.Gstin || buyer.Gstin || "") : (buyer.Gstin || "")
//       )}</div>
//       <div class="party-name">${esc(
//         Object.keys(inv.ShipDtls || {}).length > 2
//           ? (inv.ShipDtls?.LglNm || inv.ShipDtls?.TrdNm || buyer.LglNm || buyer.TrdNm || "")
//           : (buyer.LglNm || buyer.TrdNm || "")
//       )}</div>
//       <div class="party-addr">${esc(
//         Object.keys(inv.ShipDtls || {}).length > 2
//           ? [inv.ShipDtls?.Addr1, inv.ShipDtls?.Addr2].filter(Boolean).join(", ")
//           : [buyer.Addr1, buyer.Addr2].filter(Boolean).join(", ")
//       )}</div>
//       <div class="party-addr">${esc(
//         Object.keys(inv.ShipDtls || {}).length > 2
//           ? (inv.ShipDtls?.Loc || "")
//           : (buyer.Loc || "")
//       )} — ${esc(
//         Object.keys(inv.ShipDtls || {}).length > 2
//           ? String(inv.ShipDtls?.Pin || "")
//           : String(buyer.Pin || "")
//       )}</div>
//     </div>
//   </div>

//   <!-- ══ ITEMS ══ -->
//   <div class="sec-hdr">Details of Goods / Services</div>
//   <div class="items-outer">
//     <table>
//       <thead>
//         <tr>
//           <th style="width:20px;">#</th>
//           <th style="text-align:left;padding-left:6px;">Item Description</th>
//           <th style="width:52px;">HSN Code</th>
//           <th style="width:38px;">Qty</th>
//           <th style="width:28px;">Unit</th>
//           <th style="width:55px;">Unit Price</th>
//           <th style="width:50px;">Discount</th>
//           <th style="width:58px;">Taxable Amt</th>
//           <th style="width:65px;">GST Rate</th>
//           <th style="width:40px;">Other Chg</th>
//           <th style="width:52px;">Total (₹)</th>
//         </tr>
//       </thead>
//       <tbody>
//         ${items.map((it, i) => {
//           const gstRt = Number(it.GstRt || 0);
//           const cess = Number(it.CesAmt || 0);
//           const cessRate = cess > 0 ? fmt(cess / Number(it.AssAmt || 1) * 100, 2) : "0.00";
//           return `<tr>
//             <td class="sl">${i + 1}</td>
//             <td class="item-name">${esc(it.PrdDesc || "")}</td>
//             <td class="cen">${esc(it.HsnCd || "")}</td>
//             <td class="num">${Number(it.Qty || 0)}</td>
//             <td class="cen">${esc(it.Unit || "")}</td>
//             <td class="num">${fmt(it.UnitPrice || 0)}</td>
//             <td class="num">${fmt(it.Discount || 0)}</td>
//             <td class="num">${fmt(it.AssAmt || 0)}</td>
//             <td class="cen">${fmt(gstRt, 2)}% + ${cessRate}%</td>
//             <td class="num">0.00</td>
//             <td class="total-cell">${fmt(it.TotItemVal || 0)}</td>
//           </tr>`;
//         }).join("")}
//       </tbody>
//     </table>
//   </div>

//   <!-- ══ TAX SUMMARY ══ -->
//   <div class="tax-outer">
//     <div class="tax-cell">
//       <span class="lbl">Taxable Amount</span>
//       <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.AssAmt || 0), 0))}</span>
//     </div>
//     <div class="tax-cell">
//       <span class="lbl">CGST</span>
//       <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.CgstAmt || 0), 0))}</span>
//     </div>
//     <div class="tax-cell">
//       <span class="lbl">SGST</span>
//       <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.SgstAmt || 0), 0))}</span>
//     </div>
//     <div class="tax-cell">
//       <span class="lbl">IGST</span>
//       <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.IgstAmt || 0), 0))}</span>
//     </div>
//     <div class="tax-cell grand">
//       <span class="lbl">Total Invoice Amount</span>
//       <span class="val">₹${fmt(Number(val.TotInvVal || 0))}</span>
//     </div>
//   </div>
//   <div class="tax-row2">
//     <div class="tax-cell">
//       <span class="lbl">CESS</span>
//       <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.CesAmt || 0), 0))}</span>
//     </div>
//     <div class="tax-cell">
//       <span class="lbl">Discount</span>
//       <span class="val">₹${fmt(Number(val.Discount || 0))}</span>
//     </div>
//     <div class="tax-cell">
//       <span class="lbl">Other Charges</span>
//       <span class="val">₹0.00</span>
//     </div>
//     <div class="tax-cell">
//       <span class="lbl">Round Off</span>
//       <span class="val">₹${fmt(Number(val.RndOffAmt || 0))}</span>
//     </div>
//   </div>

//   <!-- ══ FOOTER ══ -->
//   <div class="footer">
//     <div class="footer-left">
//       <div class="gen-by">Generated By : <strong>${esc(seller.Gstin || "")}</strong></div>
//       <div class="print-dt">Print Date : ${printDate}</div>
//       <svg id="ack-barcode"></svg>
//       <div class="barcode-num">${esc(String(einv.ackNo || ""))}</div>
//     </div>
//     <div class="esign-wrap">
//       <div class="esign-logo">eSign</div>
//       <div class="esign-rule"></div>
//       <div class="esign-sub">Digitally Signed by NIC-IRP</div>
//       <div class="esign-date">on : ${esc(String(einv.ackDt || ""))}</div>
//     </div>
//   </div>

// </div>

// <script src="https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js"
//   onload="try{JsBarcode('#ack-barcode','${einv.ackNo || ""}',{format:'CODE128',width:1.5,height:45,displayValue:false,margin:0});}catch(e){}">
// </script>
// </body>
// </html>`;
//       const pw = window.open(
//         "",
//         "_blank",
//         "width=850,height=1100,scrollbars=yes,resizable=yes",
//       );
//       if (pw) {
//         pw.document.open();
//         pw.document.write(html);
//         // ── Barcode generate (JsBarcode library) ──
// const barcodeScript = pw.document.createElement("script");
// barcodeScript.src = "https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js";
// barcodeScript.onload = () => {
//   try {
//     pw.JsBarcode("#ack-barcode", "${einv.ackNo || ''}", {
//       format: "CODE128",
//       width: 1.5,
//       height: 40,
//       displayValue: false,
//       margin: 0
//     });
//   } catch(e) {}
// };
// pw.document.head.appendChild(barcodeScript);
//         pw.document.close();
//       } else {
//         dispatch(
//           Show_MsgBox({
//             Message: "Popup blocked! Please allow popups for this site.",
//             Type: "error",
//             isMsg: true,
//           }),
//         );
//       }
//     } catch (err) {
//       dispatch(
//         Show_MsgBox({ Message: err.message, Type: "error", isMsg: true }),
//       );
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  SETTINGS HELPERS
//   // ─────────────────────────────────────────────────────────────
//   // const Input_Onchange = (val, element, area) => {
//   //   setEntJsonInv((prev) =>
//   //     prev.map((json) => {
//   //       const u = { ...json };
//   //       u[area.strAreaCol] = {
//   //         ...u[area.strAreaCol],
//   //         [element.strGstcolName]:
//   //           element.strdatatype === "decimal" ? Number(val) : val,
//   //       };
//   //       return u;
//   //     }),
//   //   );
//   // };
  

//   const Input_Onchange = (val, element, area) => {
//   setEntJsonInv((prev) => {
//     const updated = prev.map((json) => {
//       const u = { ...json };
//       u[area.strAreaCol] = {
//         ...u[area.strAreaCol],
//         [element.strGstcolName]:
//           element.strdatatype === "decimal" ? Number(val) : val,
//       };
//       return u;
//     });

//     // ✅ Pincode மாத்தும்போது distance recalculate பண்ணு
//     if (element.strGstcolName === "Pin" && String(val).length === 6) {
//       const updatedInv = updated[0];
//       if (updatedInv) {
//         // setTimeout — state update முடிஞ்சதுக்கு அப்புறம் call பண்ண
//         setTimeout(() => View_Distance(updatedInv), 0);
//       }
//     }

//     return updated;
//   });
// };

//   const Area_Onchange = async (AreaId) => {
//     try {
//       setiAreaId(AreaId);
//       dispatch(setload_Screen(true));
//       const Res = await userApp.get(
//         `GST/Area_Onchange/${Number(AreaId)}/${Number(iScrId)}/${localStorage.db}`,
//       );
//       if (Res.data.strStatus === "Success") setarrEntCol(Res.data.EntCol);
//       else showToast(Res.data.strMessage, "info");
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   const View_GSTColumns = (col) => {
//     setstrColName(col.strGstcolName);
//     setstrAliasName(col.strAliasName);
//     setstrDatatype(col.strdatatype);
//     setstrTransName(col.strConditionCol);
//     setstrdefaultval(col.strdefaultvalue);
//     setstrval(col.strValue);
//     setiAreaId(col.iAreaId);
//     setiColId(col.iGstcolId);
//     setisShow(col.iShwinScr === 1);
//   };

//   const Clear_Colums = () => {
//     setstrColName("");
//     setstrAliasName("");
//     setstrDatatype("string");
//     setstrTransName("");
//     setstrdefaultval("");
//     setstrval("");
//     setiAreaId(0);
//     setiColId(0);
//     setisShow(true);
//   };

//   const Updat_GSTColumn = async () => {
//     try {
//       dispatch(setload_Screen(true));
//       const Res = await userApp.post("GST/InsUpd_GSTColumns", {
//         strCompanyDB: localStorage.db,
//         EntArea: [],
//         EntCol: [
//           {
//             iGstcolId: iColId,
//             strGstcolName: strColName,
//             strAliasName,
//             strdatatype: strDatatype,
//             strConditionCol: strTransName,
//             strdefaultvalue: strdefaultval,
//             strValue: strval,
//             iShwinScr: isShow ? 1 : 0,
//             iAreaId,
//             iScrId,
//           },
//         ],
//       });
//       if (Res.data.strStatus === "Success") {
//         Area_Onchange(iAreaId);
//         Clear_Colums();
//       } else showToast(Res.data.strMessage, "error");
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   const TransMode = [
//     { val: "1", Name: "Road" },
//     { val: "2", Name: "Rail" },
//     { val: "3", Name: "Air" },
//     { val: "4", Name: "Ship" },
//   ];
//   const VechicleType = [
//     { val: "R", Name: "Regular" },
//     { val: "O", Name: "ODC" },
//   ];
//   const Option_list = (col, EntDT) =>
//     col === "VehType" ? VechicleType : col === "TransMode" ? TransMode : EntDT;
//   const Option_Value = (Val, col) =>
//     col === "VehType" || col === "TransMode" ? Val.val : Val;
//   const Option_display = (Val, col) =>
//     col === "VehType" || col === "TransMode" ? Val.Name : Val;
//   const display_Value = (Val, col) => {
//     if (col === "VehType")
//       return VechicleType.find((d) => d.val === Val)?.Name || Val;
//     if (col === "TransMode")
//       return TransMode.find((d) => d.val === Val)?.Name || Val;
//     return Val;
//   };
//   const Hide_Option = (val, element) =>
//     setarrEntCol((prev) =>
//       prev.map((col) =>
//         col.iGstcolId === element.iGstcolId
//           ? { ...col, isShowOption: val }
//           : col,
//       ),
//     );

//   const CreateHTMLElemet = (element, area, Index) => {
//     if (element.iAreaId !== area.iAreaId || area.iAreaId === 9) return null;
//     const json = EntJsonInv[0];
//     const val = json ? json[area.strAreaCol][element.strGstcolName] : "";
//     switch (element.strdatatype) {
//       case "string":
//         return (
//           <div className="col-sm-6 col-md-3" key={Index}>
//             <label>{element.strAliasName}</label>
//             <input
//               type="text"
//               className="form-control"
//               value={val}
//               onChange={(e) => Input_Onchange(e.target.value, element, area)}
//             />
//           </div>
//         );
//       case "cmb":
//         return (
//           <div className="col-sm-6 col-md-3" key={Index}>
//             <label>{element.strAliasName}</label>
//             <div
//               className="custom-select"
//               onMouseLeave={() => Hide_Option(false, element)}
//             >
//               <input
//                 type="text"
//                 className="form-control"
//                 readOnly
//                 placeholder="Select Value"
//                 value={display_Value(val, element.strGstcolName)}
//                 onClick={() => Hide_Option(true, element)}
//               />
//               <i className="fa-solid fa-caret-down"></i>
//               {element.isShowOption && (
//                 <div className="custom-option">
//                   <div className="option-list">
//                     {Option_list(element.strGstcolName, element.arrOption).map(
//                       (item, i) => (
//                         <button
//                           key={i}
//                           tabIndex={i}
//                           onClick={() => {
//                             Input_Onchange(
//                               Option_Value(item, element.strGstcolName),
//                               element,
//                               area,
//                             );
//                             Hide_Option(false, element);
//                           }}
//                           onKeyDown={(e) => {
//                             const len = element.arrOption.length - 1;
//                             if (e.key === "ArrowDown")
//                               $(
//                                 `.option-list [tabindex=${i === len ? 0 : i + 1}]`,
//                               ).focus();
//                             if (e.key === "ArrowUp")
//                               $(
//                                 `.option-list [tabindex=${i === 0 ? len : i - 1}]`,
//                               ).focus();
//                             if (e.key === "Enter") {
//                               Input_Onchange(
//                                 Option_Value(item, element.strGstcolName),
//                                 element,
//                                 area,
//                               );
//                               Hide_Option(false, element);
//                             }
//                           }}
//                         >
//                           {Option_display(item, element.strGstcolName)}
//                         </button>
//                       ),
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         );
//       case "decimal":
//         return (
//           <div className="col-sm-6 col-md-3" key={Index}>
//             <label>{element.strAliasName}</label>
//             <input
//               type="number"
//               className="form-control"
//               value={val}
//               onChange={(e) => Input_Onchange(e.target.value, element, area)}
//             />
//           </div>
//         );
//       case "date":
//         return (
//           <div className="col-sm-6 col-md-3" key={Index}>
//             <label>{element.strAliasName}</label>
//             <input
//               type="date"
//               className="form-control"
//               value={val}
//               onChange={(e) => Input_Onchange(e.target.value, element, area)}
//             />
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   //  DERIVED STATE
//   // ─────────────────────────────────────────────────────────────
//   const hasIRN = !!einvResp?.irn;
//   const isCancelled = hasIRN && !!einvResp?.cancelIRN;
//   const isActive = hasIRN && !isCancelled;

//   // ─────────────────────────────────────────────────────────────
//   //  TABLE COLUMNS
//   // ─────────────────────────────────────────────────────────────
//   const ItemColumn = [
//     { Header: "Product Name", accessor: "PrdDesc", minWidth: 200 },
//     { Header: "HSN Code", accessor: "HsnCd", minWidth: 100 },
//     {
//       Header: "Qty",
//       accessor: "Qty",
//       minWidth: 80,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "Unit",
//       accessor: "Unit",
//       minWidth: 80,
//       style: { justifyContent: "center" },
//     },
//     {
//       Header: "Rate",
//       accessor: "UnitPrice",
//       minWidth: 100,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "SGST Amount",
//       accessor: "SgstAmt",
//       minWidth: 100,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "CGST Amount",
//       accessor: "CgstAmt",
//       minWidth: 100,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "IGST Amount",
//       accessor: "IgstAmt",
//       minWidth: 100,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "Tax %",
//       accessor: "GstRt",
//       minWidth: 80,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "Taxable Amount",
//       accessor: "taxableAmt",
//       minWidth: 110,
//       style: { justifyContent: "right" },
//     },
//     {
//       Header: "Item Amount",
//       accessor: "TotItemVal",
//       minWidth: 110,
//       style: { justifyContent: "right" },
//     },
//   ];
//   const GstColumn = [
//     { Header: "GST Column", accessor: "strGstcolName" },
//     { Header: "Alias Name", accessor: "strAliasName", minWidth: 200 },
//     { Header: "Data Type", accessor: "strdatatype", minWidth: 100 },
//     { Header: "Trans Name", accessor: "strConditionCol", minWidth: 100 },
//     { Header: "Default Value", accessor: "strdefaultvalue", minWidth: 200 },
//     {
//       Header: "Value",
//       accessor: "strValue",
//       minWidth: 100,
//       style: { justifyContent: "center" },
//     },
//     {
//       Header: "Show",
//       accessor: "iShwinScr",
//       minWidth: 70,
//       style: { justifyContent: "center" },
//       cell: ({ rowinfo }) => (
//         <input
//           type="checkbox"
//           className="form-check"
//           checked={rowinfo.iShwinScr}
//           readOnly
//         />
//       ),
//     },
//   ];

//   // ─────────────────────────────────────────────────────────────
//   //  RENDER
//   // ─────────────────────────────────────────────────────────────
//   return (
//     <>
//       <Toast
//         toasts={toasts}
//         onDismiss={(id) =>
//           setToasts((prev) => prev.filter((t) => t.id !== id))
//         }
//       />

//       {showCancelModal && (
//         <CancelModal
//           irn={einvResp?.irn}
//           onConfirm={Cancel_EInvoice}
//           onClose={() => setShowCancelModal(false)}
//         />
//       )}

//       {showValidModal && (
//         <ValidationModal
//           errors={validErrors}
//           warnings={validWarnings}
//           invoice={EntJsonInv?.[0]}
//           onProceed={() => {
//             setShowValidModal(false);
//             Create_EInvoice();
//           }}
//           onClose={() => setShowValidModal(false)}
//         />
//       )}

//       {showCredPopup && (
//         <CredentialModal
//           cred={nicCred}
//           onChange={setNicCred}
//           onSave={Save_Credential}
//           onClose={() => {
//             setShowCredPopup(false);
//             setNicCred({ ApiUserName: "", ApiPassword: "" });
//           }}
//           saving={credSaving}
//         />
//       )}

//       <div className="popup-container">
//         <div className="popup-content">
//           {/* ── Header ── */}
//           <div className="popup-header">
//             <h5>
//               <span style={{ marginRight: 8 }}>📋</span>
//               GST E-Invoice
//               {hasIRN && (
//                 <span
//                   style={{
//                     marginLeft: 10,
//                     fontSize: 11,
//                     fontWeight: 600,
//                     padding: "2px 10px",
//                     borderRadius: 20,
//                     background: isCancelled ? "#fef2f2" : "#f0fff4",
//                     color: isCancelled ? "#dc2626" : "darkgreen",
//                     border: `1px solid ${isCancelled ? "#fecaca" : "darkgreen"}`,
//                     verticalAlign: "middle",
//                   }}
//                 >
//                   {isCancelled ? "⛔ Cancelled" : "✅ Active"}
//                 </span>
//               )}
//             </h5>
//             <div className="icon-popup-btn-grp">
//               {!isSetting && (
//                 <span
//                   className="icon-btn"
//                   title="Settings"
//                   onClick={() => {
//                     setisSetting(true);
//                     Area_Onchange(1);
//                   }}
//                 >
//                   <i className="fa-solid fa-gear"></i>
//                 </span>
//               )}
//               <span
//                 className="icon-btn"
//                 title="Close"
//                 onClick={() => dispatch(ShowHide_Popup("IsEInvoice"))}
//               >
//                 <i className="fa-regular fa-rectangle-xmark"></i>
//               </span>
//             </div>
//           </div>

//           {/* ── Body ── */}
//           <div className="popup-body">
//             {/* Invoice Form */}
//             {!isSetting && (
//               <div className="row">
//                 {arrEntArea.map((area, i) => (
//                   <div className="row" key={i}>
//                     <h6 className="gstcol-h">{area.strAliasName}</h6>
//                     {arrEntCol.map((col, j) => CreateHTMLElemet(col, area, j))}
//                   </div>
//                 ))}
//                 <div className="TransactionTable">
//                   <ReactTable
//                     sortable={true}
//                     data={ListEntItem}
//                     columns={ItemColumn}
//                     minRows={5}
//                     defaultPageSize={500}
//                     showPaginationBottom={false}
//                     row_click={() => {}}
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Settings */}
//             {isSetting && (
//               <div className="row p-2">
//                 <div className="col-sm-12 col-md-3">
//                   <label>GST Column Type</label>
//                   <CustomizedSelectoption
//                     optionparem="isoptionShow10"
//                     showoption={_selecrparem.isoptionShow10}
//                     placeholder="Select Column Type"
//                     select_value={(val) => Area_Onchange(val)}
//                     btnname=""
//                     btnshow={false}
//                     show_popup={""}
//                     valueonly={true}
//                     defaultval={iAreaId}
//                     displayName="strAreaCol"
//                     disvalue="iAreaId"
//                     arrydata={arrEntArea}
//                     EmptVal="Column Type"
//                   />
//                 </div>
//                 {[
//                   { l: "GST Column Name", v: strColName, s: setstrColName },
//                   { l: "Alias Name", v: strAliasName, s: setstrAliasName },
//                   { l: "Trans Name", v: strTransName, s: setstrTransName },
//                   { l: "Default Value", v: strdefaultval, s: setstrdefaultval },
//                   { l: "Value", v: strval, s: setstrval },
//                 ].map(({ l, v, s }, i) => (
//                   <div className="col-sm-12 col-md-3" key={i}>
//                     <label>{l}</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={v}
//                       onChange={(e) => s(e.target.value)}
//                       spellCheck={false}
//                       autoComplete="off"
//                     />
//                   </div>
//                 ))}
//                 <div className="col-sm-12 col-md-3">
//                   <label>Show Screen</label>
//                   <input
//                     type="checkbox"
//                     className="form-check"
//                     checked={isShow}
//                     onChange={() => setisShow((v) => !v)}
//                   />
//                 </div>
//                 <div className="col-sm-12 col-md-3">
//                   <label>Data Type</label>
//                   <div className="row">
//                     {["string", "date", "decimal", "cmb"].map((dt) => (
//                       <div className="col-sm-3" key={dt}>
//                         <label>{dt}</label>
//                         <input
//                           type="checkbox"
//                           className="form-check"
//                           checked={strDatatype === dt}
//                           onChange={() => setstrDatatype(dt)}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <ReactTable
//                   columns={GstColumn}
//                   data={arrEntCol}
//                   minRows={5}
//                   row_click={() => {}}
//                   row_doubleclick={(rowInfo) => View_GSTColumns(rowInfo)}
//                   background={true}
//                   className="full-table"
//                 />
//               </div>
//             )}

//             {/* ── IRN Result Card ── */}
//             {hasIRN && !isSetting && (
//               <div
//                 style={{
//                   margin: "16px 2px 0",
//                   border: `1.5px solid ${isCancelled ? "#fecaca" : "darkgreen"}`,
//                   borderRadius: 12,
//                   overflow: "hidden",
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                 }}
//               >
//                 {/* Card Header */}
//                 <div
//                   style={{
//                     background: isCancelled
//                       ? "#dc2626"
//                       : "darkgreen",
//                     padding: "12px 18px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div
//                     style={{ display: "flex", alignItems: "center", gap: 10 }}
//                   >
//                     <span style={{ fontSize: 18 }}>
//                       {isCancelled ? "⛔" : "✅"}
//                     </span>
//                     <div>
//                       <div
//                         style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}
//                       >
//                         {isCancelled
//                           ? "E-Invoice Cancelled"
//                           : "E-Invoice Generated Successfully"}
//                       </div>
//                       <div
//                         style={{
//                           color: "rgba(255,255,255,0.6)",
//                           fontSize: 10.5,
//                           marginTop: 1,
//                         }}
//                       >
//                         {isCancelled
//                           ? "This invoice is marked cancelled on the GST portal"
//                           : "Verified and registered on NIC E-Invoice portal"}
//                       </div>
//                     </div>
//                   </div>
//                   {isActive && (
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 6,
//                         background: "rgba(255,255,255,0.12)",
//                         padding: "4px 12px",
//                         borderRadius: 20,
//                       }}
//                     >
//                       <span
//                         style={{
//                           width: 7,
//                           height: 7,
//                           borderRadius: "50%",
//                           background: "#ffffff",
//                           display: "inline-block",
//                           animation: "pulse 1.6s infinite",
//                         }}
//                       />
//                       <span
//                         style={{
//                           color: "rgba(255,255,255,0.9)",
//                           fontSize: 11,
//                           fontWeight: 600,
//                         }}
//                       >
//                         Active
//                       </span>
//                     </div>
//                   )}
//                 </div>

//                 {/* Card Body */}
//                 <div
//                   style={{
//                     background: isCancelled ? "#fff5f5" : "#ffffff",
//                     padding: "16px 18px",
//                     display: "flex",
//                     gap: 18,
//                     alignItems: "flex-start",
//                   }}
//                 >
//                   {/* Left — details */}
//                   <div style={{ flex: 1 }}>
//                     <div style={{ marginBottom: 12 }}>
//                       <div
//                         style={{
//                           fontSize: 10,
//                           fontWeight: 700,
//                           color: "#6b7280",
//                           textTransform: "uppercase",
//                           letterSpacing: ".7px",
//                           marginBottom: 5,
//                         }}
//                       >
//                         Invoice Reference Number (IRN)
//                       </div>
//                       <div
//                         style={{
//                           background: "#fff",
//                           border: "1px solid #e2e8f0",
//                           borderRadius: 8,
//                           padding: "8px 12px",
//                           boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
//                         }}
//                       >
//                         <CopyIRN irn={einvResp.irn} />
//                       </div>
//                     </div>

//                     <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
//                       <div>
//                         <div
//                           style={{
//                             fontSize: 10,
//                             fontWeight: 700,
//                             color: "#6b7280",
//                             textTransform: "uppercase",
//                             letterSpacing: ".6px",
//                             marginBottom: 4,
//                           }}
//                         >
//                           Acknowledgement Number
//                         </div>
//                         <div
//                           style={{
//                             fontSize: 14,
//                             color: "#0f172a",
//                             fontWeight: 700,
//                           }}
//                         >
//                           {einvResp.ackNo || "—"}
//                         </div>
//                       </div>
//                       <div>
//                         <div
//                           style={{
//                             fontSize: 10,
//                             fontWeight: 700,
//                             color: "#6b7280",
//                             textTransform: "uppercase",
//                             letterSpacing: ".6px",
//                             marginBottom: 4,
//                           }}
//                         >
//                           Acknowledgement Date &amp; Time
//                         </div>
//                         <div
//                           style={{
//                             fontSize: 14,
//                             color: "#0f172a",
//                             fontWeight: 700,
//                           }}
//                         >
//                           {formatAckDate(einvResp.ackDt) || "—"}
//                         </div>
//                       </div>
//                     </div>

//                     {isCancelled && (
//                       <div
//                         style={{
//                           marginTop: 12,
//                           padding: "9px 12px",
//                           background: "#fef2f2",
//                           border: "1px solid #fecaca",
//                           borderRadius: 8,
//                           fontSize: 12,
//                         }}
//                       >
//                         <span style={{ fontWeight: 700, color: "#dc2626" }}>
//                           Cancel IRN:{" "}
//                         </span>
//                         <span
//                           style={{
//                             fontFamily: "monospace",
//                             color: "#7f1d1d",
//                             fontSize: 11,
//                           }}
//                         >
//                           {einvResp.cancelIRN}
//                         </span>
//                       </div>
//                     )}
//                   </div>

//                   {/* Right — QR */}
//                   <div style={{ textAlign: "center", flexShrink: 0 }}>
//                     <div
//                       style={{
//                         width: 118,
//                         height: 118,
//                         border: "1.5px solid #e2e8f0",
//                         borderRadius: 10,
//                         background: "#fff",
//                         padding: 6,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//                       }}
//                     >
//                       {einvResp.qrCodeImage ? (
//                         <img
//                           src={`data:image/png;base64,${einvResp.qrCodeImage}`}
//                           alt="QR"
//                           style={{ width: 104, height: 104, display: "block" }}
//                         />
//                       ) : einvResp.signedQRCode ? (
//                         <QRFromJWT jwt={einvResp.signedQRCode} size={104} />
//                       ) : (
//                         <div
//                           style={{
//                             width: 104,
//                             height: 104,
//                             border: "1.5px dashed #cbd5e1",
//                             borderRadius: 6,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             fontSize: 10,
//                             color: "#94a3b8",
//                             background: "#f8fafc",
//                             textAlign: "center",
//                             padding: 8,
//                           }}
//                         >
//                           QR N/A
//                         </div>
//                       )}
//                     </div>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#94a3b8",
//                         marginTop: 5,
//                         fontWeight: 500,
//                       }}
//                     >
//                       📷 Scan to verify on NIC
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* ── Footer Buttons ── */}
//           <div className="popup-footer">
//             <div className="popup-btn-group">
//               {!isSetting && (
//                 <>
//                   {!hasIRN && (
//                     <button
//                       onClick={Handle_Generate_Click}
//                       className="btn-fabgreen"
//                     >
//                       <i className="fas fa-file-invoice"></i>&nbsp;Generate
//                       E-Invoice
//                     </button>
//                   )}
//                   {isActive && (
//                     <>
//                       <button
//                         onClick={() => Print_EInvoice()}
//                         className="btn-fabgreen"
//                       >
//                         <i className="fas fa-print"></i>&nbsp;Print
//                       </button>
//                       <button
//                         onClick={() => setShowCancelModal(true)}
//                         className="btn-fabred"
//                       >
//                         <i className="fas fa-ban"></i>&nbsp;Cancel IRN
//                       </button>
//                     </>
//                   )}
//                   {isCancelled && (
//                     <span
//                       style={{
//                         color: "#dc2626",
//                         fontWeight: 700,
//                         fontSize: 13,
//                         padding: "7px 16px",
//                         background: "#fef2f2",
//                         border: "1.5px solid #fecaca",
//                         borderRadius: 8,
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 6,
//                       }}
//                     >
//                       ⛔ E-Invoice Cancelled
//                     </span>
//                   )}
//                   <button
//                     onClick={() =>
//                       Load_EInvoice(_Common.iScrId, _HT.SelectedVouchId)
//                     }
//                     className="btn-fabgreen"
//                   >
//                     <i className="fas fa-sync-alt"></i>&nbsp;Refresh
//                   </button>
//                 </>
//               )}
//               {isSetting && (
//                 <>
//                   <button onClick={Updat_GSTColumn} className="btn-fabgreen">
//                     Update&nbsp;<i className="fas fa-save"></i>
//                   </button>
//                   <button onClick={Clear_Colums} className="btn-fabgreen">
//                     Clear&nbsp;<i className="fas fa-eraser"></i>
//                   </button>
//                   <button
//                     onClick={() => setisSetting(false)}
//                     className="btn-fabgreen"
//                   >
//                     <i className="bx bx-arrow-back"></i>&nbsp;Back
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes pulse {
//           0%,100% { opacity:1; transform:scale(1); }
//           50%      { opacity:0.5; transform:scale(1.4); }
//         }
//         @keyframes modalPop {
//           from { opacity:0; transform:scale(0.88); }
//           to   { opacity:1; transform:scale(1); }
//         }
//         @keyframes toastSlide {
//           from { opacity:0; transform:translateX(60px) scale(0.9); }
//           to   { opacity:1; transform:translateX(0) scale(1); }
//         }
//       `}</style>
//     </>
//   );
// }

// export default EInvoice;



import React, { useEffect, useRef, useState, useCallback } from "react";
import { userApp } from "../Admin/Utility";
import ReactTable from "../General/ReactTable";
import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import CustomizedSelectoption from "./CustomizedSelectoption";
import { ShowHide_Popup } from "../ReduxStore/Transactionstates";

// ═══════════════════════════════════════════════════════════════
//  TOAST — exact match to software notification UI
// ═══════════════════════════════════════════════════════════════
function Toast({ toasts, onDismiss }) {
  const typeConfig = {
    success: {
      bg: "darkgreen",
      textColor: "#ffffff",
      iconBg: "#ffffff",           /* solid white circle */
      iconColor: "darkgreen",        /* green tick inside white circle */
      icon: "✔",
    },
    error: {
      bg: "darkgreen",
      textColor: "#ffffff",
      iconBg: "#ffffff",           /* solid white circle */
      iconColor: "darkgreen", 
      icon: "✕",
    },
    info: {
      bg: "darkgreen",
      textColor: "#ffffff",
      iconBg: "#ffffff",           /* solid white circle */
      iconColor: "darkgreen", 
      icon: "i",
    },
    warning: {
      bg: "darkgreen",
      textColor: "#ffffff",
      iconBg: "#ffffff",           /* solid white circle */
      iconColor: "darkgreen", 
      icon: "!",
    },
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 18,
        right: 18,          /* ← top-right, exactly like your software */
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        pointerEvents: "none",
      }}
    >
      {toasts.map((t) => {
        const cfg = typeConfig[t.type] || typeConfig.info;
        return (
          <div
            key={t.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: cfg.bg,
              color: cfg.textColor,
              padding: "10px 14px 10px 12px",
              borderRadius: 5,
              fontSize: 13,
              fontWeight: 600,
              minWidth: 300,
              maxWidth: 420,
              pointerEvents: "all",
              animation: "toastSlide 0.25s ease-out",
              boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
              letterSpacing: "0.01em",
            }}
          >
            {/* Solid white circle with colored tick — exact match to reference */}
            <div
              style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: cfg.iconBg,      /* solid white */
                color: cfg.iconColor,         /* green tick */
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 11,
                fontWeight: 900,
                flexShrink: 0,
              }}
            >
              {cfg.icon}
            </div>

            {/* Message */}
            <span style={{ flex: 1, lineHeight: 1.4 }}>{t.message}</span>

            {/* × dismiss — like screenshot */}
            <button
              onClick={() => onDismiss && onDismiss(t.id)}
              style={{
                background: "none",
                border: "none",
                color: cfg.textColor,
                cursor: "pointer",
                fontSize: 18,
                fontWeight: 400,
                lineHeight: 1,
                padding: "0 0 0 6px",
                opacity: 0.9,
                flexShrink: 0,
              }}
              title="Close"
            >
              ×
            </button>
          </div>
        );
      })}
      <style>{`
        @keyframes toastSlide {
          from { opacity:0; transform:translateX(50px); }
          to   { opacity:1; transform:translateX(0); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  CANCEL CONFIRM MODAL
// ═══════════════════════════════════════════════════════════════
function CancelModal({ irn, onConfirm, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          width: 440,
          padding: "32px 32px 24px",
          boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
          animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
          border: "1px solid #fee2e2",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "#fef2f2",
              border: "2px solid #fecaca",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16,
              fontSize: 24,
            }}
          >
            ⛔
          </div>
          <div
            style={{
              fontWeight: 700,
              fontSize: 17,
              color: "#111",
              marginBottom: 6,
            }}
          >
            Cancel E-Invoice?
          </div>
          <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.5 }}>
            This action is permanent and cannot be reversed.
            <br />
            The IRN will be marked as cancelled on the GST portal.
          </div>
        </div>
        <div
          style={{
            background: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: 8,
            padding: "12px 14px",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              fontSize: 10,
              color: "#9ca3af",
              fontWeight: 700,
              letterSpacing: "0.8px",
              marginBottom: 4,
            }}
          >
            INVOICE REFERENCE NUMBER
          </div>
          <div
            style={{
              fontFamily: "monospace",
              fontSize: 10.5,
              color: "#374151",
              wordBreak: "break-all",
              lineHeight: 1.7,
            }}
          >
            {irn}
          </div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: "11px",
              borderRadius: 8,
              border: "1.5px solid #e5e7eb",
              background: "#fff",
              color: "#374151",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Keep Active
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: "11px",
              borderRadius: 8,
              border: "none",
              background: "#dc2626",
              color: "#fff",
              fontWeight: 700,
              fontSize: 13,
              cursor: "pointer",
              boxShadow: "0 4px 14px rgba(220,38,38,0.3)",
            }}
          >
            Yes, Cancel IRN
          </button>
        </div>
      </div>
      <style>{`@keyframes modalPop{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  CREDENTIAL POPUP
// ═══════════════════════════════════════════════════════════════
function CredentialModal({ cred, onChange, onSave, onClose, saving }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          width: 420,
          boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
          animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "darkgreen",
            padding: "24px 28px",
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: "rgba(255,255,255,0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 22,
            }}
          >
            🔐
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
              NIC E-Invoice Credentials
            </div>
            <div
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,0.6)",
                marginTop: 2,
              }}
            >
              GST Portal Login — required for API access
            </div>
          </div>
        </div>
        <div style={{ padding: "24px 28px 20px" }}>
          <div style={{ marginBottom: 16 }}>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              GST Username
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter GST portal username"
              value={cred.ApiUserName}
              onChange={(e) =>
                onChange({ ...cred, ApiUserName: e.target.value })
              }
              autoComplete="off"
              style={{ fontSize: 13 }}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              GST Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter GST portal password"
              value={cred.ApiPassword}
              onChange={(e) =>
                onChange({ ...cred, ApiPassword: e.target.value })
              }
              autoComplete="new-password"
              style={{ fontSize: 13 }}
            />
          </div>
          <div
            style={{
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              borderRadius: 8,
              padding: "10px 12px",
              marginBottom: 20,
              fontSize: 11.5,
              color: "#1e40af",
              lineHeight: 1.5,
            }}
          >
            ℹ️ These credentials are used only for NIC E-Invoice API
            authentication. They are stored securely and encrypted.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={onClose}
              disabled={saving}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: 8,
                border: "1.5px solid #e5e7eb",
                background: "#fff",
                color: "#374151",
                fontWeight: 600,
                fontSize: 13,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.5 : 1,
              }}
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={saving}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: 8,
                border: "none",
                background: saving
                  ? "#9ca3af"
                  : "darkgreen",
                color: "#fff",
                fontWeight: 700,
                fontSize: 13,
                cursor: saving ? "not-allowed" : "pointer",
              }}
            >
              {saving ? "Saving..." : "Save & Generate"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  VALIDATION MODAL
// ═══════════════════════════════════════════════════════════════
function ValidationModal({ errors, warnings, invoice, onProceed, onClose }) {
  const hasErrors = errors.length > 0;
  const inv = invoice || {};
  const seller = inv.SellerDtls || {};
  const buyer = inv.BuyerDtls || {};
  const doc = inv.DocDtls || {};
  const val = inv.ValDtls || {};
  const items = inv.ItemList || [];

  const checks = [
    { label: "Invoice Number", ok: !!doc.No, val: doc.No || "Missing" },
    { label: "Invoice Date", ok: !!doc.Dt, val: doc.Dt || "Missing" },
    {
      label: "Seller GSTIN",
      ok: (seller.Gstin || "").length === 15,
      val: seller.Gstin || "Missing",
    },
    {
      label: "Buyer GSTIN",
      ok: (buyer.Gstin || "").length === 15,
      val: buyer.Gstin || "Missing",
    },
    {
      label: "Seller Email",
      ok:
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(seller.Em || "") &&
        (seller.Em || "").length >= 6,
      val: seller.Em || "Missing",
    },
    {
      label: "Buyer Email",
      ok:
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(buyer.Em || "") &&
        (buyer.Em || "").length >= 6,
      val: buyer.Em || "Missing",
    },
    {
      label: "Seller Pincode",
      ok: /^\d{6}$/.test(String(seller.Pin || "")),
      val: String(seller.Pin || "Missing"),
    },
    {
      label: "Buyer Pincode",
      ok: /^\d{6}$/.test(String(buyer.Pin || "")),
      val: String(buyer.Pin || "Missing"),
    },
    {
      label: "Vehicle Number",
      ok:
        String(inv.EwbDtls?.VehNo || "").length >= 4 &&
        String(inv.EwbDtls?.VehNo || "").length <= 20,
      val: inv.EwbDtls?.VehNo || "Missing",
    },
    {
      label: "Transport Mode",
      ok: ["1", "2", "3", "4"].includes(String(inv.EwbDtls?.TransMode || "")),
      val: inv.EwbDtls?.TransMode || "Missing",
    },
    {
      label: "Total Items",
      ok: items.length > 0,
      val: `${items.length} item(s)`,
    },
    {
      label: "Invoice Value",
      ok: Number(val.TotInvVal || 0) > 0,
      val: `₹${Number(val.TotInvVal || 0).toLocaleString("en-IN")}`,
    },
  ];

  const passCount = checks.filter((c) => c.ok).length;
  const totalCount = checks.length;
  const progress = Math.round((passCount / totalCount) * 100);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10001,
        background: "rgba(0,0,0,0.65)",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          width: 580,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 32px 100px rgba(0,0,0,0.35)",
          animation: "modalPop 0.28s cubic-bezier(0.34,1.56,0.64,1)",
          overflow: "hidden",
        }}
      >
        {/* ── Header ── */}
        <div
          style={{
            background: hasErrors
              ? "#dc2626"
              : "darkgreen",
            padding: "22px 24px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 14,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: "rgba(255,255,255,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 20,
                }}
              >
                {hasErrors ? "🛑" : "✅"}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
                  {hasErrors
                    ? `${errors.length} Error${errors.length > 1 ? "s" : ""} Found — Cannot Generate`
                    : "All Checks Passed — Ready to Generate"}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "rgba(255,255,255,0.65)",
                    marginTop: 2,
                  }}
                >
                  {hasErrors
                    ? "Fix the errors in the invoice and try again"
                    : `${warnings.length > 0 ? warnings.length + " warning(s) noted · " : ""}Confirm to submit to NIC portal`}
                </div>
              </div>
            </div>
            <button
              onClick={onClose}
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.15)",
                border: "none",
                color: "#fff",
                fontSize: 16,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ✕
            </button>
          </div>

          {/* Progress bar */}
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 6,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,0.7)",
                  fontWeight: 600,
                }}
              >
                VALIDATION PROGRESS
              </span>
              <span
                style={{
                  fontSize: 11,
                  color: "rgba(255,255,255,0.9)",
                  fontWeight: 700,
                }}
              >
                {passCount}/{totalCount} checks passed
              </span>
            </div>
            <div
              style={{
                height: 6,
                background: "rgba(255,255,255,0.2)",
                borderRadius: 3,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${progress}%`,
                  background: hasErrors ? "#fca5a5" : "rgba(255,255,255,0.75)",
                  borderRadius: 3,
                  transition: "width 0.5s ease",
                }}
              />
            </div>
          </div>
        </div>

        {/* ── Body ── */}
        <div style={{ overflowY: "auto", flex: 1 }}>
          {/* Field Checklist */}
          <div style={{ padding: "16px 24px 0" }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                letterSpacing: "0.7px",
                marginBottom: 10,
                textTransform: "uppercase",
              }}
            >
              Field Validation Checklist
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "4px 10px",
              }}
            >
              {checks.map((c, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "6px 10px",
                    borderRadius: 7,
                    background: c.ok ? "#f0fdf4" : "#fef2f2",
                    border: `1px solid ${c.ok ? "#bbf7d0" : "#fecaca"}`,
                  }}
                >
                  <span
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      flexShrink: 0,
                      background: c.ok ? "#dcfce7" : "#fee2e2",
                      color: c.ok ? "#15803d" : "#dc2626",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      fontWeight: 700,
                    }}
                  >
                    {c.ok ? "✓" : "✕"}
                  </span>
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 10.5,
                        fontWeight: 700,
                        color: c.ok ? "darkgreen" : "#991b1b",
                      }}
                    >
                      {c.label}
                    </div>
                    <div
                      style={{
                        fontSize: 10,
                        color: c.ok ? "darkgreen" : "#f87171",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: 180,
                      }}
                    >
                      {c.val}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Errors */}
          {errors.length > 0 && (
            <div style={{ padding: "16px 24px 0" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 10,
                }}
              >
                <div
                  style={{
                    background: "#dc2626",
                    color: "#fff",
                    borderRadius: 5,
                    padding: "2px 8px",
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: "0.5px",
                  }}
                >
                  {errors.length} ERROR{errors.length > 1 ? "S" : ""}
                </div>
                <div
                  style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}
                >
                  Must be fixed in the invoice before generating
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {errors.map((e, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                      background: "#fef2f2",
                      border: "1px solid #fecaca",
                      borderRadius: 8,
                      padding: "10px 12px",
                    }}
                  >
                    <div
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        flexShrink: 0,
                        background: "#dc2626",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 10,
                        fontWeight: 700,
                        marginTop: 1,
                      }}
                    >
                      {i + 1}
                    </div>
                    <span
                      style={{
                        fontSize: 12,
                        color: "#7f1d1d",
                        lineHeight: 1.55,
                      }}
                    >
                      {e}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Warnings */}
          {warnings.length > 0 && (
            <div style={{ padding: "14px 24px 0" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 10,
                }}
              >
                <div
                  style={{
                    background: "#d97706",
                    color: "#fff",
                    borderRadius: 5,
                    padding: "2px 8px",
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: "0.5px",
                  }}
                >
                  {warnings.length} WARNING{warnings.length > 1 ? "S" : ""}
                </div>
                <div
                  style={{ fontSize: 11, color: "#6b7280", fontWeight: 600 }}
                >
                  Will be auto-noted — generation can proceed
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {warnings.map((w, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                      background: "#fffbeb",
                      border: "1px solid #fde68a",
                      borderRadius: 8,
                      padding: "9px 12px",
                    }}
                  >
                    <span style={{ fontSize: 14, flexShrink: 0, marginTop: 1 }}>
                      ⚠
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                        color: "#78350f",
                        lineHeight: 1.55,
                      }}
                    >
                      {w}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Invoice Summary */}
          <div style={{ padding: "16px 24px" }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                letterSpacing: "0.7px",
                marginBottom: 10,
                textTransform: "uppercase",
              }}
            >
              Invoice Summary
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 8,
                marginBottom: 10,
              }}
            >
              {[
                {
                  title: "Seller",
                  gstin: seller.Gstin,
                  name: seller.LglNm || seller.TrdNm,
                  pin: seller.Pin,
                },
                {
                  title: "Buyer",
                  gstin: buyer.Gstin,
                  name: buyer.LglNm || buyer.TrdNm,
                  pin: buyer.Pin,
                },
              ].map(({ title, gstin, name, pin }) => (
                <div
                  key={title}
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    padding: "10px 12px",
                  }}
                >
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: 700,
                      color: "#94a3b8",
                      letterSpacing: "0.6px",
                      marginBottom: 6,
                      textTransform: "uppercase",
                    }}
                  >
                    {title}
                  </div>
                  <div
                    style={{
                      fontSize: 11.5,
                      color: "#0f172a",
                      fontWeight: 700,
                      marginBottom: 2,
                    }}
                  >
                    {gstin || (
                      <span style={{ color: "#dc2626" }}>GSTIN Missing</span>
                    )}
                  </div>
                  <div style={{ fontSize: 11, color: "#475569" }}>
                    {name || "—"}
                  </div>
                  <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>
                    PIN: {pin || "—"}
                  </div>
                </div>
              ))}
            </div>

            {/* Doc Details */}
            <div
              style={{
                display: "flex",
                gap: 20,
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 10,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#94a3b8",
                    fontWeight: 700,
                    marginBottom: 2,
                  }}
                >
                  DOC NUMBER
                </div>
                <div
                  style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}
                >
                  {doc.No || <span style={{ color: "#dc2626" }}>Missing</span>}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#94a3b8",
                    fontWeight: 700,
                    marginBottom: 2,
                  }}
                >
                  DATE
                </div>
                <div
                  style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}
                >
                  {doc.Dt || "—"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#94a3b8",
                    fontWeight: 700,
                    marginBottom: 2,
                  }}
                >
                  TYPE
                </div>
                <div
                  style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}
                >
                  {doc.Typ || "—"}
                </div>
              </div>
            </div>

            {/* Items */}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                letterSpacing: "0.5px",
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              Items ({items.length})
            </div>
            <div
              style={{
                maxHeight: 160,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 5,
              }}
            >
              {items.map((item, i) => {
                const itemOk =
                  item.HsnCd &&
                  item.Qty > 0 &&
                  item.UnitPrice >= 0 &&
                  item.TotItemVal > 0;
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: itemOk ? "#f0fdf4" : "#fef2f2",
                      border: `1px solid ${itemOk ? "#bbf7d0" : "#fecaca"}`,
                      borderRadius: 7,
                      padding: "7px 11px",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span
                        style={{
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          flexShrink: 0,
                          background: itemOk ? "darkgreen" : "#dc2626",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 9,
                          fontWeight: 700,
                        }}
                      >
                        {itemOk ? "✓" : "✕"}
                      </span>
                      <div>
                        <div
                          style={{
                            fontSize: 11.5,
                            fontWeight: 600,
                            color: "#0f172a",
                          }}
                        >
                          {item.PrdDesc || "—"}
                        </div>
                        <div style={{ fontSize: 10, color: "#6b7280" }}>
                          HSN:{" "}
                          {item.HsnCd || (
                            <span style={{ color: "#dc2626" }}>Missing</span>
                          )}{" "}
                          &nbsp;·&nbsp; Qty: {item.Qty} {item.Unit}{" "}
                          &nbsp;·&nbsp; Rate: ₹
                          {Number(item.UnitPrice || 0).toLocaleString("en-IN")}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "#1e40af",
                      }}
                    >
                      ₹{Number(item.TotItemVal || 0).toLocaleString("en-IN")}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Total */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "linear-gradient(135deg,#0f172a,#1e3a5f)",
                borderRadius: 9,
                padding: "12px 16px",
                marginTop: 10,
              }}
            >
              <span
                style={{
                  color: "rgba(255,255,255,0.7)",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                Total Invoice Value
              </span>
              <span style={{ color: "#fbbf24", fontSize: 17, fontWeight: 700 }}>
                ₹{Number(val.TotInvVal || 0).toLocaleString("en-IN")}
              </span>
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <div
          style={{
            padding: "14px 24px",
            borderTop: "1px solid #f1f5f9",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fafafa",
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: hasErrors ? "#dc2626" : "darkgreen",
            }}
          >
            {hasErrors
              ? `❌ ${errors.length} error${errors.length > 1 ? "s" : ""} — fix in invoice first`
              : warnings.length > 0
                ? `⚠ ${warnings.length} warning${warnings.length > 1 ? "s" : ""} noted · safe to proceed`
                : "✅ All validations passed"}
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={onClose}
              style={{
                padding: "9px 22px",
                borderRadius: 8,
                border: "1.5px solid #e5e7eb",
                background: "#fff",
                color: "#374151",
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              {hasErrors ? "Close & Fix Errors" : "Cancel"}
            </button>
            {!hasErrors && (
              <button
                onClick={onProceed}
                style={{
                  padding: "9px 22px",
                  borderRadius: 8,
                  border: "none",
                  background: "darkgreen",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 13,
                  cursor: "pointer",
                  boxShadow: "0 4px 16px rgba(22,101,52,0.35)",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                ✅ Confirm & Generate
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  QR FROM JWT
// ═══════════════════════════════════════════════════════════════
function QRFromJWT({ jwt, size = 110 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!jwt || !ref.current) return;
    const render = () => {
      if (!ref.current || !window.QRCode) return;
      ref.current.innerHTML = "";
      new window.QRCode(ref.current, {
        text: jwt,
        width: size,
        height: size,
        correctLevel: window.QRCode.CorrectLevel.M,
      });
    };
    if (window.QRCode) {
      render();
      return;
    }
    const existing = document.getElementById("__qrcodejs_cdn__");
    if (existing) {
      existing.addEventListener("load", render);
      return;
    }
    const script = document.createElement("script");
    script.id = "__qrcodejs_cdn__";
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js";
    script.onload = render;
    document.head.appendChild(script);
  }, [jwt, size]);
  return (
    <div
      ref={ref}
      style={{
        width: size,
        height: size,
        border: "1px solid #d1fae5",
        borderRadius: 6,
        overflow: "hidden",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
  );
}

// ═══════════════════════════════════════════════════════════════
//  COPY IRN
// ═══════════════════════════════════════════════════════════════
function CopyIRN({ irn }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard?.writeText(irn).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
      <span
        style={{
          fontFamily: "monospace",
          fontSize: 10.5,
          color: "#1e293b",
          wordBreak: "break-all",
          lineHeight: 1.7,
          flex: 1,
        }}
      >
        {irn}
      </span>
      <button
        onClick={handleCopy}
        title="Copy IRN"
        style={{
          flexShrink: 0,
          border: `1px solid ${copied ? "darkgreen" : "#e2e8f0"}`,
          background: copied ? "#f0fff4" : "#f8fafc",
          borderRadius: 6,
          padding: "3px 10px",
          cursor: "pointer",
          fontSize: 11,
          color: copied ? "darkgreen" : "#475569",
          fontWeight: 600,
          transition: "all 0.2s",
          whiteSpace: "nowrap",
        }}
      >
        {copied ? "✓ Copied" : "📋 Copy"}
      </button>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
//  FORMAT DATE
// ═══════════════════════════════════════════════════════════════
function formatAckDate(raw) {
  if (!raw || raw === "—") return raw || "—";
  const d = new Date(raw);
  if (isNaN(d)) return raw;
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

// ═══════════════════════════════════════════════════════════════
//  MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════
function EInvoice() {
  const dispatch = useDispatch();
  const _Common = useSelector((store) => store.states.Common);
  const _HT = useSelector((store) => store.states.Header);
  const _selecrparem = useSelector((state) => state.SelectOption.parems);

  // ─── column/area/settings state ───
  const [iScrId, setiScrId] = useState(0);
  const [strColName, setstrColName] = useState("");
  const [strAliasName, setstrAliasName] = useState("");
  const [strDatatype, setstrDatatype] = useState("");
  const [strTransName, setstrTransName] = useState("");
  const [strdefaultval, setstrdefaultval] = useState("");
  const [strval, setstrval] = useState("");
  const [isShow, setisShow] = useState(true);
  const [iAreaId, setiAreaId] = useState(0);
  const [iColId, setiColId] = useState(0);
  const [isSetting, setisSetting] = useState(false);

  // ─── data state ───
  const [ListEntItem, setListEntItem] = useState([]);
  const [arrEntCol, setarrEntCol] = useState([]);
  const [arrEntArea, setarrEntArea] = useState([]);
  const [EntJsonInv, setEntJsonInv] = useState([]);
  const [einvResp, setEinvResp] = useState(null);

  // ─── UI state ───
  const [toasts, setToasts] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);

  // ─── credential popup state ───
  const [showCredPopup, setShowCredPopup] = useState(false);
  const [nicCred, setNicCred] = useState({ ApiUserName: "", ApiPassword: "" });
  const [credSaving, setCredSaving] = useState(false);

  // ─── validation modal state ───
  const [showValidModal, setShowValidModal] = useState(false);
  const [validErrors, setValidErrors] = useState([]);
  const [validWarnings, setValidWarnings] = useState([]);

  useEffect(() => {
    Load_EInvoice(_Common.iScrId, _HT.SelectedVouchId);
  }, []);

  // ─────────────────────────────────────────────────────────────
  //  TOAST HELPER
  // ─────────────────────────────────────────────────────────────
  const showToast = useCallback(
    (message, type = "success", duration = 3500) => {
      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, message, type }]);
      setTimeout(
        () => setToasts((prev) => prev.filter((t) => t.id !== id)),
        duration,
      );
    },
    [],
  );

  // ─────────────────────────────────────────────────────────────
  //  NORMALIZE
  // ─────────────────────────────────────────────────────────────
  const normalizeEInv = (d) => {
    console.log("RAW TaxPro Response:", JSON.stringify(d, null, 2));
    return {
      irn:           d?.irn           || d?.Irn           || d?.IRN           || "",
      ackNo:         d?.ackNo         || d?.AckNo         || d?.AckNO         || "",
      ackDt:         d?.ackDt         || d?.AckDt         || d?.AckDate       || "",
      signedQRCode:  d?.signedQRCode  || d?.SignedQRCode  || d?.SignedQrCode  || d?.signedQrCode || d?.QrCode || d?.qrCode || d?.QRCode || "",
      signedInvoice: d?.signedInvoice || d?.SignedInvoice || d?.signedJson    || d?.SignedJson   || "",
      qrCodeImage:   d?.qrCodeImage   || d?.QrCodeImage   || d?.QRCodeImage   || d?.qrImage     || d?.QrImage || "",
      cancelIRN:     d?.cancelIRN     || d?.CancelIRN     || null,
    };
  };

  // ─────────────────────────────────────────────────────────────
  //  LOAD
  // ─────────────────────────────────────────────────────────────
  const Load_EInvoice = async (ScrId, VouchId) => {
    try {
      setiScrId(ScrId);
      dispatch(setload_Screen(true));
      const Res = await userApp.get(
        `GST/Load_EInvoice/${ScrId}/${VouchId}/${Number(localStorage.ComId)}/${Number(localStorage.FYId)}/${localStorage.db}/${localStorage.Msdb}`,
      );
      if (Res.data.strStatus !== "Success") {
        setEinvResp(null);
        return;
      }
      await AssignVoucher_Data(ScrId, Res.data);
      const raw = Res.data.eInvoice || Res.data.EInvoice || null;
      const mapped = raw ? normalizeEInv(raw) : null;
      setEinvResp(mapped?.irn ? mapped : null);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ─────────────────────────────────────────────────────────────
  //  ASSIGN VOUCHER DATA
  // ─────────────────────────────────────────────────────────────
  const AssignVoucher_Data = async (ScrId, InvtDT) => {
    let EntArea = InvtDT.EntArea,
      EntCol = InvtDT.EntCol;
    let EntTax = InvtDT.objEntTax,
      EntSummary = InvtDT.objEntSummary;
    let Summary = EntSummary[0],
      EntHT = InvtDT.objEntHT;
    let EntParty = InvtDT.Party,
      EntShipAdd = InvtDT.EntShippingAdd;
    let EntCompany = InvtDT.Company,
      EntItem = InvtDT.objEntDT;
    let TaxRelId = EntHT[0].iTaxTypeId,
      iTCSApplicable = EntHT[0].iTCSApplicable;
    let dSGST = 0,
      dCGST = 0,
      dIGST = 0,
      dTCS = 0;

    const checkbuyerseller = (p, c, type) => {
      switch (ScrId) {
        case 11:
        case 76:
        case 78:
          return type === "Sell" ? p : c;
        case 17:
        case 67:
        case 73:
          return type === "Sell" ? c : p;
        default:
          return p;
      }
    };

    EntTax.forEach((dt) => {
      if (dt.taxDesc.startsWith("SGST") && TaxRelId === 1) dSGST += dt.taxAmt;
      else if (dt.taxDesc.startsWith("CGST") && TaxRelId === 1)
        dCGST += dt.taxAmt;
      else if (dt.taxDesc.startsWith("IGST") && TaxRelId === 2)
        dIGST += dt.taxAmt;
      else if (dt.taxDesc.startsWith("TCS") && iTCSApplicable === 1)
        dTCS += dt.taxAmt;
    });
    Summary = { ...Summary, sgst: dSGST, cgst: dCGST, igst: dIGST, tcs: dTCS };

    const objData = [
      { iAreaId: 1, data: EntHT[0] },
      { iAreaId: 2, data: EntHT[0] },
      {
        iAreaId: 3,
        data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell"),
      },
      { iAreaId: 4, data: checkbuyerseller(EntParty[0], EntCompany[0], "Buy") },
      {
        iAreaId: 5,
        data: checkbuyerseller(EntParty[0], EntCompany[0], "Sell"),
      },
      { iAreaId: 6, data: EntShipAdd },
      { iAreaId: 7, data: Summary },
      { iAreaId: 8, data: EntHT[0] },
      { iAreaId: 9, data: EntItem },
    ];

    let objInvoice = { Version: "1.1" };
    EntArea.forEach((area) => {
      const AreaCol = EntCol.filter((c) => c.iAreaId === area.iAreaId);
      const Entdt = objData.find((c) => c.iAreaId === area.iAreaId)?.data;

      if (area.iAreaId !== 9) {
        let objDT = {};
        AreaCol.forEach((col) => {
          if (col.strConditionCol === "") {
            if (col.strdatatype === "cmb")
              objDT = { ...objDT, [col.strGstcolName]: col.strValue };
            else if (col.strdatatype === "decimal")
              objDT = {
                ...objDT,
                [col.strGstcolName]: Number(col.strdefaultvalue),
              };
            else objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
          } else {
            let value = Entdt[col.strConditionCol];
            if (col.strGstcolName === "Dt" && value) {
              const dt = new Date(value);
              if (!isNaN(dt))
                value = `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()}`;
              else value = "";
            } else if (["Stcd", "Pin", "Gstin"].includes(col.strGstcolName)) {
              value = value ? String(value) : "";
            } else if (col.strdatatype === "decimal") {
              value = value ? Number(value) : 0;
            }
            objDT = { ...objDT, [col.strGstcolName]: value };
          }
        });
        objInvoice = { ...objInvoice, [area.strAreaCol]: objDT };
      } else {
        const arrItem = [];
        Entdt.forEach((dt) => {
          let objDT = {};
          AreaCol.forEach((col) => {
            if (col.strConditionCol === "") {
              if (col.strdatatype === "decimal") {
                switch (col.strGstcolName) {
                  case "igstAmt":
                    if (TaxRelId === 2)
                      objDT = {
                        ...objDT,
                        [col.strGstcolName]: Number(dt.taxAmt),
                      };
                    break;
                  case "CgstAmt":
                  case "SgstAmt":
                    if (TaxRelId === 1)
                      objDT = {
                        ...objDT,
                        [col.strGstcolName]: Number(dt.taxAmt / 2),
                      };
                    break;
                  default:
                    objDT = {
                      ...objDT,
                      [col.strGstcolName]: Number(col.strdefaultvalue),
                    };
                    break;
                }
              } else {
                objDT = { ...objDT, [col.strGstcolName]: col.strdefaultvalue };
              }
            } else {
              let v = dt[col.strConditionCol];
              if (col.strdatatype === "decimal") v = v ? Number(v) : 0;
              else if (col.strGstcolName === "IsServc") v = "N";
              else if (col.strGstcolName === "SlNo") v = v ? v.toString() : "1";
              else if (col.strGstcolName === "HsnCd") {
                v = v ? String(v) : null;
                if (v && v.length > 8) v = v.substring(0, 8);
              }
              objDT = { ...objDT, [col.strGstcolName]: v };
            }
          });
          arrItem.push(objDT);
        });
        setListEntItem(arrItem);
        objInvoice = { ...objInvoice, ItemList: arrItem };
      }
    });

    if (objInvoice.DocDtls?.Dt?.includes("-")) {
      const p = objInvoice.DocDtls.Dt.split("-");
      if (p.length === 3) objInvoice.DocDtls.Dt = `${p[2]}/${p[1]}/${p[0]}`;
    }
    await View_Distance(objInvoice);
    setarrEntArea(EntArea);
    setarrEntCol(EntCol);
  };
const View_Distance = async (objInvoice) => {
    try {
      const p1 = objInvoice["SellerDtls"]?.["Pin"],
        p2 = objInvoice["ShipDtls"]?.["Pin"];

      if (!p1 || !p2) {
        objInvoice["EwbDtls"]["Distance"] = 0;
      } else {
        const c1 = await fetchCoordinates(p1),
          c2 = await fetchCoordinates(p2);

        if (!c1 || !c2) {
          objInvoice["EwbDtls"]["Distance"] = 0;
        } else {
          let roadDistance = 0;
          try {
            // ✅ OSRM — actual road distance (free, no API key)
            const osrmRes = await fetch(
              `https://router.project-osrm.org/route/v1/driving/${c1.lon},${c1.lat};${c2.lon},${c2.lat}?overview=false`
            );
            const osrmData = await osrmRes.json();

            if (osrmData.code === "Ok" && osrmData.routes?.length > 0) {
              roadDistance = Math.round(osrmData.routes[0].distance / 1000);
            } else {
              throw new Error("OSRM no route");
            }
          } catch {
            // ✅ Fallback — Haversine * 1.35 if OSRM fails
            const R = 6371e3,
              φ1 = (c1.lat * Math.PI) / 180,
              φ2 = (c2.lat * Math.PI) / 180,
              Δφ = ((c2.lat - c1.lat) * Math.PI) / 180,
              Δλ = ((c2.lon - c1.lon) * Math.PI) / 180;
            const a =
              Math.sin(Δφ / 2) ** 2 +
              Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
            roadDistance = Math.round(
              ((R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) / 1000) * 1.35
            );
          }

          objInvoice["EwbDtls"]["Distance"] = roadDistance;
        }
      }
      setEntJsonInv([objInvoice]);
    } catch (err) {
      showToast(err.message, "error");
    }
  };

const fetchCoordinates = async (pincode) => {
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${pincode}&countrycodes=in&format=json`,
      );
      const data = await res.json();
      return data?.length > 0
        ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) }
        : null;
    } catch {
      return null;
    }
  };
  // ─────────────────────────────────────────────────────────────
  //  VALIDATE — FULL NIC PORTAL RULES (world-class)
  // ─────────────────────────────────────────────────────────────
  const validateEInvoice = () => {
    const inv = EntJsonInv?.[0];
    const errors = [];
    const warnings = [];

    if (!inv) {
      errors.push("Invoice data not loaded. Please refresh and try again.");
      return { errors, warnings };
    }

    const emailRx = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;

    // ── Document ──────────────────────────────────────────────
    const docNo = inv.DocDtls?.No || "";
    if (!docNo)
      errors.push("Invoice Number is missing — required by NIC portal.");
    else if (!/^([a-zA-Z1-9]{1}[a-zA-Z0-9\/\-]{0,15})$/.test(docNo.trim()))
      errors.push(
        `Invoice Number "${docNo}" is invalid — only letters, numbers, / and - are allowed. Max 16 characters.`,
      );

    const docDt = inv.DocDtls?.Dt || "";
    if (!docDt) {
      errors.push("Invoice Date is missing — required by NIC portal.");
    } else {
      const parts = docDt.includes("-")
        ? docDt.split("-").reverse()
        : docDt.split("/");
      const dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
      if (isNaN(dt))
        errors.push(
          `Invoice Date "${docDt}" is invalid. Expected format: DD/MM/YYYY.`,
        );
      else if (dt > new Date())
        errors.push(
          `Invoice Date "${docDt}" is a future date — NIC does not allow future-dated invoices.`,
        );
    }

    // ── Transaction Details ───────────────────────────────────
    const supTyp = inv.TranDtls?.SupTyp || "";
    if (!supTyp)
      errors.push("Supply Type (SupTyp) is missing in Transaction Details.");

    // ── Seller ────────────────────────────────────────────────
    const selGstin = inv.SellerDtls?.Gstin || "";
    if (!selGstin)
      errors.push("Seller GSTIN is missing — mandatory for E-Invoice.");
    else if (selGstin.length !== 15)
      errors.push(
        `Seller GSTIN "${selGstin}" must be exactly 15 characters (currently ${selGstin.length} characters).`,
      );

    const selPin = String(inv.SellerDtls?.Pin || "");
    if (!selPin || selPin.length !== 6 || isNaN(selPin))
      errors.push(
        `Seller Pincode "${selPin || "empty"}" must be exactly 6 digits (e.g. 641001).`,
      );

    const selLoc = inv.SellerDtls?.Loc || "";
    if (!selLoc) errors.push("Seller Location (city/town name) is missing.");

    const selAddr1 = inv.SellerDtls?.Addr1 || "";
    if (!selAddr1)
      errors.push("Seller Address Line 1 is missing — required by NIC portal.");

    // Email — NIC ErrorCode 5002: must be 6–100 chars, valid format → ERROR
    const selEmail = inv.SellerDtls?.Em || "";
    if (
      !selEmail ||
      selEmail.length < 6 ||
      selEmail.length > 100 ||
      !emailRx.test(selEmail)
    )
      errors.push(
        `Seller Email "${selEmail || "empty"}" is invalid — NIC requires a valid email address between 6 and 100 characters (e.g. info@yourcompany.com). [NIC ErrorCode 5002]`,
      );

    // ── Buyer ─────────────────────────────────────────────────
    const buyGstin = inv.BuyerDtls?.Gstin || "";
    if (!buyGstin)
      errors.push("Buyer GSTIN is missing — mandatory for E-Invoice.");
    else if (buyGstin.length !== 15)
      errors.push(
        `Buyer GSTIN "${buyGstin}" must be exactly 15 characters (currently ${buyGstin.length} characters).`,
      );

    const buyPin = String(inv.BuyerDtls?.Pin || "");
    if (!buyPin || buyPin.length !== 6 || isNaN(buyPin))
      errors.push(
        `Buyer Pincode "${buyPin || "empty"}" must be exactly 6 digits (e.g. 641001).`,
      );

    const buyLoc = inv.BuyerDtls?.Loc || "";
    if (!buyLoc) errors.push("Buyer Location (city/town name) is missing.");

    const buyAddr1 = inv.BuyerDtls?.Addr1 || "";
    if (!buyAddr1)
      errors.push("Buyer Address Line 1 is missing — required by NIC portal.");

    const buyStcd = String(inv.BuyerDtls?.Stcd || "");
    if (!buyStcd)
      errors.push(
        "Buyer State Code (Place of Supply) is missing — required for GST computation.",
      );

    // Email — NIC ErrorCode 5002: must be 6–100 chars → ERROR
    const buyEmail = inv.BuyerDtls?.Em || "";
    if (
      !buyEmail ||
      buyEmail.length < 6 ||
      buyEmail.length > 100 ||
      !emailRx.test(buyEmail)
    )
      errors.push(
        `Buyer Email "${buyEmail || "empty"}" is invalid — NIC requires a valid email between 6 and 100 characters (e.g. buyer@company.com). [NIC ErrorCode 5002]`,
      );

    // ── E-Way Bill ────────────────────────────────────────────
    const ewb = inv.EwbDtls;
    if (ewb) {
      const vehNo = String(ewb.VehNo || "").trim();
      const transMode = String(ewb.TransMode || "").trim();
      const distance = Number(ewb.Distance || 0);

      // NIC ErrorCode 5002: min 4, max 20 chars → ERROR
      if (!vehNo) {
        errors.push(
          "Vehicle Number is missing — NIC requires Vehicle Number between 4 and 20 characters (e.g. TN01AB1234). [NIC ErrorCode 5002]",
        );
      } else if (vehNo.length < 4) {
        errors.push(
          `Vehicle Number "${vehNo}" is too short — minimum 4 characters required by NIC portal. [NIC ErrorCode 5002]`,
        );
      } else if (vehNo.length > 20) {
        errors.push(
          `Vehicle Number "${vehNo}" is too long — maximum 20 characters allowed by NIC portal. [NIC ErrorCode 5002]`,
        );
      } else if (!/^[A-Z0-9]+$/i.test(vehNo)) {
        errors.push(
          `Vehicle Number "${vehNo}" contains invalid characters — only letters and numbers are allowed.`,
        );
      }

      if (!transMode) {
        errors.push(
          "Transport Mode is missing — select: 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).",
        );
      } else if (!["1", "2", "3", "4"].includes(transMode)) {
        errors.push(
          `Transport Mode "${transMode}" is invalid — must be 1 (Road), 2 (Rail), 3 (Air), or 4 (Ship).`,
        );
      }

      if (distance <= 0)
        warnings.push(
          "Distance is 0 km — verify that seller and buyer pincodes are correct. NIC may reject E-Way Bill if distance is 0.",
        );
      else if (distance > 4000)
        warnings.push(
          `Distance of ${distance} km seems unusually high — please verify seller and buyer pincodes are correct.`,
        );

      const transDocNo = String(ewb.TransDocNo || "").trim();
      if (transDocNo && (transDocNo.length < 1 || transDocNo.length > 15))
        errors.push(
          `Transport Document No "${transDocNo}" must be between 1 and 15 characters.`,
        );

      const vehType = ewb.VehType || "";
      if (vehType && !["R", "O"].includes(vehType))
        errors.push(
          `Vehicle Type "${vehType}" is invalid — must be R (Regular) or O (ODC/Over-Dimensional Cargo).`,
        );
    }

    // ── Items ─────────────────────────────────────────────────
    const items = inv.ItemList || [];
    if (items.length === 0)
      errors.push(
        "No items found in invoice — at least 1 item is required to generate E-Invoice.",
      );
    else if (items.length > 100)
      errors.push(
        `Invoice has ${items.length} items — NIC portal allows a maximum of 100 items per E-Invoice.`,
      );

    items.forEach((item, i) => {
      const n = i + 1;
      const name = item.PrdDesc || `Item ${n}`;

      if (!item.PrdDesc || String(item.PrdDesc).trim().length < 3)
        errors.push(
          `Item ${n}: Product Description is missing or too short — minimum 3 characters required.`,
        );

      const hsnCd = String(item.HsnCd || "").trim();
      if (!hsnCd)
        errors.push(
          `Item ${n} (${name}): HSN Code is missing — mandatory for all E-Invoice items.`,
        );
      else if (!/^\d+$/.test(hsnCd))
        errors.push(
          `Item ${n} (${name}): HSN Code "${hsnCd}" must contain digits only.`,
        );
      else if (hsnCd.length < 4)
        errors.push(
          `Item ${n} (${name}): HSN Code "${hsnCd}" must be at least 4 digits.`,
        );
      else if (hsnCd.length > 8)
        errors.push(
          `Item ${n} (${name}): HSN Code "${hsnCd}" must be maximum 8 digits.`,
        );

      if (!item.Unit)
        errors.push(
          `Item ${n} (${name}): Unit of measurement is missing (e.g. NOS, KGS, MTR, LTR).`,
        );

      const qty = Number(item.Qty);
      if (!qty || qty <= 0)
        errors.push(
          `Item ${n} (${name}): Quantity must be greater than 0 (current value: ${item.Qty || 0}).`,
        );

      const rate = Number(item.UnitPrice);
      if (rate === undefined || rate === null || rate < 0)
        errors.push(
          `Item ${n} (${name}): Unit Price cannot be negative (current value: ${item.UnitPrice || 0}).`,
        );

      const totVal = Number(item.TotItemVal);
      if (!totVal || totVal <= 0)
        errors.push(
          `Item ${n} (${name}): Total Item Value must be greater than 0.`,
        );

      const gstRt = Number(
        item.GstRt ?? item.IgstRt ?? Number(item.CgstRt || 0) * 2 ?? 0,
      );
      if (gstRt < 0)
        errors.push(`Item ${n} (${name}): GST Rate cannot be negative.`);
      else if (
        ![0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, 28].includes(gstRt)
      )
        warnings.push(
          `Item ${n} (${name}): GST Rate ${gstRt}% is non-standard — verify it's a valid GST slab (0, 0.1, 0.25, 1, 1.5, 3, 5, 6, 7.5, 12, 18, or 28%).`,
        );

      const slNo = String(item.SlNo || "");
      if (!slNo || isNaN(Number(slNo)))
        warnings.push(
          `Item ${n} (${name}): Serial Number (SlNo) is missing or not numeric — may be auto-fixed.`,
        );
    });

    // ── Value Details ─────────────────────────────────────────
    const totInvVal = Number(inv.ValDtls?.TotInvVal || 0);
    if (totInvVal <= 0)
      errors.push("Total Invoice Value must be greater than 0.");
    else if (totInvVal > 999999999999.99)
      errors.push(
        `Total Invoice Value ₹${totInvVal.toLocaleString("en-IN")} exceeds NIC maximum limit.`,
      );

    const assAmt = Number(inv.ValDtls?.AssVal || 0);
    if (assAmt <= 0)
      warnings.push(
        "Assessable Value (AssVal) in Value Details is 0 — please verify invoice totals are correct.",
      );

    return { errors, warnings };
  };

// const validateEInvoice = () => {
//   const inv = EntJsonInv?.[0];
//   const errors = [];
//   const warnings = [];

//   if (!inv) {
//     errors.push("Invoice data not loaded.");
//     return { errors, warnings };
//   }

//   // ── Doc Details ──
//   if (!inv.DocDtls?.No)
//     errors.push("Invoice Number is missing.");
//   if (!inv.DocDtls?.Dt)
//     errors.push("Invoice Date is missing.");
//   if (!inv.DocDtls?.Typ)
//     errors.push("Document Type is missing.");

//   // ── Transaction ──
//   if (!inv.TranDtls?.SupTyp)
//     errors.push("Supply Type is missing.");
//   if (!inv.TranDtls?.TaxSch)
//     errors.push("Tax Scheme is missing.");

//   // ── Seller ──
//   if (!inv.SellerDtls?.Gstin || inv.SellerDtls.Gstin.length !== 15)
//     errors.push("Seller GSTIN is invalid or missing.");
//   if (!inv.SellerDtls?.LglNm)
//     errors.push("Seller Legal Name is missing.");
//   if (!inv.SellerDtls?.Addr1)
//     errors.push("Seller Address is missing.");
//   if (!inv.SellerDtls?.Loc)
//     errors.push("Seller Location is missing.");
//   if (!inv.SellerDtls?.Pin)
//     errors.push("Seller Pincode is missing.");
//   if (!inv.SellerDtls?.Stcd)
//     errors.push("Seller State Code is missing.");

//   // ── Buyer ──
//   if (!inv.BuyerDtls?.Gstin || inv.BuyerDtls.Gstin.length !== 15)
//     errors.push("Buyer GSTIN is invalid or missing.");
//   if (!inv.BuyerDtls?.LglNm)
//     errors.push("Buyer Legal Name is missing.");
//   if (!inv.BuyerDtls?.Addr1)
//     errors.push("Buyer Address is missing.");
//   if (!inv.BuyerDtls?.Loc)
//     errors.push("Buyer Location is missing.");
//   if (!inv.BuyerDtls?.Pin)
//     errors.push("Buyer Pincode is missing.");
//   if (!inv.BuyerDtls?.Stcd)
//     errors.push("Buyer State Code is missing.");
//   if (!inv.BuyerDtls?.Pos)
//     errors.push("Place of Supply is missing.");

//   // ── Items ──
//   if (!inv.ItemList || inv.ItemList.length === 0)
//     errors.push("No items found in invoice.");

//   inv.ItemList?.forEach((item, i) => {
//     const n = i + 1;
//     const nm = item.PrdDesc || `Item ${n}`;
//     if (!item.PrdDesc)
//       errors.push(`Item ${n}: Product Description is missing.`);
//     if (!item.HsnCd)
//       errors.push(`Item ${n} (${nm}): HSN Code is missing.`);
//     if (!item.Unit)
//       errors.push(`Item ${n} (${nm}): Unit is missing.`);
//     if (!item.Qty || Number(item.Qty) <= 0)
//       errors.push(`Item ${n} (${nm}): Quantity must be greater than 0.`);
//     if (Number(item.UnitPrice) < 0)
//       errors.push(`Item ${n} (${nm}): Unit Price cannot be negative.`);
//     if (!item.TotItemVal || Number(item.TotItemVal) <= 0)
//       errors.push(`Item ${n} (${nm}): Total Item Value must be greater than 0.`);
//   });

//   // ── Value Details ──
//   if (!inv.ValDtls?.TotInvVal || Number(inv.ValDtls.TotInvVal) <= 0)
//     errors.push("Total Invoice Value must be greater than 0.");

//   return { errors, warnings };
// };

  // ─────────────────────────────────────────────────────────────
  //  HANDLE GENERATE CLICK
  // ─────────────────────────────────────────────────────────────
  const Handle_Generate_Click = () => {
    const { errors, warnings } = validateEInvoice();
    setValidErrors(errors);
    setValidWarnings(warnings);
    setShowValidModal(true);
  };

  // ─────────────────────────────────────────────────────────────
  //  GENERATE
  // ─────────────────────────────────────────────────────────────
  const Create_EInvoice = async () => {
    try {
      dispatch(setload_Screen(true));
      if (EntJsonInv?.[0]?.DocDtls?.Dt?.includes("-")) {
        const [y, m, d] = EntJsonInv[0].DocDtls.Dt.split("-");
        EntJsonInv[0].DocDtls.Dt = `${d}/${m}/${y}`;
      }
      if (EntJsonInv?.[0]?.TranDtls) {
        const t = EntJsonInv[0].TranDtls;
        if (!t.EcmGstin || t.EcmGstin.length !== 15) delete t.EcmGstin;
      }
      const payload = {
        iSalInvId: _HT.SelectedVouchId,
        iClientId: Number(localStorage.ClientId),
        strCompanyDB: localStorage.db,
        EntJsonInv: JSON.stringify(EntJsonInv[0]),
      };
      const res = await userApp.post("GST/Generate_EInvoice", payload);
      if (res?.data?.strStatus === "Success") {
        const mapped = normalizeEInv(res.data.data);
        if (!mapped.irn) {
          showToast("IRN not received. Please try again.", "error");
          return;
        }
        setEinvResp(mapped);
        showToast("E-Invoice generated successfully!", "success");
      } else {
        showToast(
          res.data?.strMessage || "Generate failed. Please try again.",
          "error",
        );
      }
    } catch (err) {
      const msg =
        err?.response?.data?.strMessage ||
        err?.response?.data?.message ||
        err.message ||
        "Unexpected error";
      if (
        msg?.toLowerCase().includes("nic credential not found") ||
        msg?.toLowerCase().includes("credential not found")
      ) {
        setShowCredPopup(true);
        return;
      }
      if (msg?.includes("2150") || msg?.toLowerCase().includes("duplicate")) {
        showToast("IRN already exists. Loading existing record...", "info");
        await Load_EInvoice(iScrId, _HT.SelectedVouchId);
        return;
      }
      showToast(msg, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ─────────────────────────────────────────────────────────────
  //  SAVE CREDENTIAL
  // ─────────────────────────────────────────────────────────────
  const Save_Credential = async () => {
    if (!nicCred.ApiUserName.trim() || !nicCred.ApiPassword.trim()) {
      showToast("Please enter both Username and Password.", "error");
      return;
    }
    try {
      setCredSaving(true);
      const gstin = EntJsonInv?.[0]?.SellerDtls?.Gstin || "";
      const res = await userApp.post("GST/Save_NIC_Credential", {
        ClientId: Number(localStorage.ClientId),
        GSTIN: gstin,
        ApiUserName: nicCred.ApiUserName.trim(),
        ApiPassword: nicCred.ApiPassword.trim(),
      });
      if (res.data?.strStatus === "Success") {
        showToast("Credential saved successfully!", "success");
        setShowCredPopup(false);
        setNicCred({ ApiUserName: "", ApiPassword: "" });
        await Create_EInvoice();
      } else {
        showToast(
          res.data?.strMessage || "Failed to save credential.",
          "error",
        );
      }
    } catch (err) {
      showToast(
        err?.response?.data?.strMessage ||
          err.message ||
          "Error saving credential.",
        "error",
      );
    } finally {
      setCredSaving(false);
    }
  };

  // ─────────────────────────────────────────────────────────────
  //  CANCEL
  // ─────────────────────────────────────────────────────────────
  const Cancel_EInvoice = async () => {
    const irn = einvResp?.irn;
    if (!irn) return;
    setShowCancelModal(false);
    try {
      dispatch(setload_Screen(true));
      const res = await userApp.post("GST/Cancel_EInvoice", {
        Irn: irn,
        Reason: 1,
        Remarks: "Cancelled by user",
        iSalInvId: _HT.SelectedVouchId,
        iClientId: Number(localStorage.ClientId),
        strCompanyDB: localStorage.db,
      });
      if (res.data?.strStatus === "Success") {
        showToast("E-Invoice cancelled successfully.", "success");
        await Load_EInvoice(iScrId, _HT.SelectedVouchId);
      } else {
        showToast(res.data?.strMessage || "Cancel failed.", "error");
      }
    } catch (err) {
      showToast(
        err?.response?.data?.strMessage ||
          err.message ||
          "Error cancelling E-Invoice.",
        "error",
      );
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ─────────────────────────────────────────────────────────────
  //  PRINT
  // ─────────────────────────────────────────────────────────────
  const Print_EInvoice = async () => {
    try {
      const inv = EntJsonInv[0] || {};
      const einv = einvResp || {};
      const seller = inv.SellerDtls || {};
      const buyer = inv.BuyerDtls || {};
      const ship = inv.ShipDtls || {};
      const doc2 = inv.DocDtls || {};
      const tran = inv.TranDtls || {};
      const val = inv.ValDtls || {};
      const items = inv.ItemList || [];

      const getQRDataUrl = () =>
        new Promise((resolve) => {
          if (einv.qrCodeImage) {
            resolve(`data:image/png;base64,${einv.qrCodeImage}`);
            return;
          }
          if (!einv.signedQRCode) {
            resolve("");
            return;
          }
          const jwt = einv.signedQRCode;
          const doRender = () => {
            try {
              const wrap = document.createElement("div");
              document.body.appendChild(wrap);
              wrap.style.cssText = "position:fixed;left:-9999px;top:-9999px;";
              new window.QRCode(wrap, {
                text: jwt,
                width: 160,
                height: 160,
                correctLevel: window.QRCode.CorrectLevel.M,
              });
              setTimeout(() => {
                const c = wrap.querySelector("canvas");
                resolve(c ? c.toDataURL("image/png") : "");
                document.body.removeChild(wrap);
              }, 150);
            } catch (e) {
              resolve("");
            }
          };
          if (window.QRCode) {
            doRender();
            return;
          }
          const ex = document.getElementById("__qrcodejs__");
          if (ex) {
            ex.addEventListener("load", doRender);
            return;
          }
          const s = document.createElement("script");
          s.id = "__qrcodejs__";
          s.src =
            "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js";
          s.onload = doRender;
          s.onerror = () => resolve("");
          document.head.appendChild(s);
        });

      const qrDataUrl = await getQRDataUrl();
      const qrHtml = qrDataUrl
        ? `<img src="${qrDataUrl}" style="width:130px;height:130px;display:block;"/>`
        : `<div style="width:130px;height:130px;border:1px dashed #aaa;display:flex;align-items:center;justify-content:center;font-size:10px;color:#999;">QR N/A</div>`;

      const fmt = (n, d = 2) => Number(n || 0).toFixed(d);
      const esc = (s) =>
        String(s || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      const addr = (o) =>
        [o.Addr1, o.Addr2, o.Loc, o.Dst, o.Stcd, o.Pin]
          .filter(Boolean)
          .join(", ");

      const totTaxableAmt = items.reduce(
        (s, it) => s + Number(it.AssAmt || it.TaxableAmt || 0),
        0,
      );
      const roundOff = Number(val.RndOffAmt || 0);
      const totInvAmt = Number(val.TotInvVal || 0) || totTaxableAmt + roundOff;
      const cgstTot = fmt(
        items.reduce((s, it) => s + Number(it.CgstAmt || 0), 0),
      );
      const sgstTot = fmt(
        items.reduce((s, it) => s + Number(it.SgstAmt || 0), 0),
      );
      const igstTot = fmt(
        items.reduce((s, it) => s + Number(it.IgstAmt || 0), 0),
      );
      const cessTot = fmt(
        items.reduce((s, it) => s + Number(it.CesAmt || 0), 0),
      );

      const itemRows = items
        .map(
          (it, i) => `
        <tr>
          <td style="text-align:center;">${i + 1}</td>
          <td>${esc(it.PrdDesc || "")}</td>
          <td style="text-align:center;">${esc(it.HsnCd || "")}</td>
          <td style="text-align:right;">${fmt(it.Qty, 3)}</td>
          <td style="text-align:center;">${esc(it.Unit || "")}</td>
          <td style="text-align:right;">${fmt(it.UnitPrice || it.UnitVal, 2)}</td>
          <td style="text-align:right;">${fmt(it.Discount || it.Disc || 0, 2)}</td>
          <td style="text-align:right;">${fmt(it.AssAmt || it.TaxableAmt, 2)}</td>
          <td style="text-align:center;">${fmt(it.GstRt || 0, 2)}%</td>
          <td style="text-align:right;">0.00</td>
          <td style="text-align:right;">${fmt(it.TotItemVal || it.AssAmt, 2)}</td>
        </tr>`,
        )
        .join("");

      const printDate = new Date()
        .toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })
        .replace(",", "");

//       const html = `<!DOCTYPE html>
// <html lang="en">
// <head>
// <meta charset="UTF-8"/>
// <title>e-Invoice — ${esc(doc2.No || "")}</title>
// <style>
// *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
// @page{size:A4 portrait;margin:10mm 12mm 10mm 12mm}
// html,body{width:210mm;font-family:Arial,Helvetica,sans-serif;font-size:8.5pt;color:#111;background:#fff;}
// .page-wrap{width:210mm;min-height:297mm;margin:0 auto;padding:10mm 12mm;background:#fff;}
// @media print{html,body{width:210mm;margin:0;padding:0}.page-wrap{padding:0;margin:0;width:100%}.no-print{display:none!important}}
// .top-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;}
// .company-block .gstin{font-size:11pt;font-weight:700;letter-spacing:.4px;margin-bottom:2px;}
// .company-block .name{font-size:13pt;font-weight:700;}
// .section{border:1px solid #000;margin-bottom:0;}
// .section+.section{border-top:none;}
// .sec-title{font-weight:700;font-size:8pt;padding:3px 6px;border-bottom:1px solid #000;background:#fff;}
// .einv-row{display:flex;gap:0;padding:3px 6px;font-size:7.5pt;line-height:1.5;}
// .einv-row .label{font-weight:700;white-space:nowrap;margin-right:4px;}
// .einv-row .irn-val{font-family:'Courier New',monospace;font-size:7pt;word-break:break-all;flex:1;}
// .ack-row{display:flex;gap:40px;padding:2px 6px 4px;font-size:7.5pt;}
// .ack-row .label{font-weight:700;}
// .tran-grid{display:grid;grid-template-columns:1fr 1fr 1fr;padding:4px 6px;font-size:7.5pt;line-height:1.6;gap:2px 0;}
// .tran-grid .label{font-weight:700;}
// .party-grid{display:grid;grid-template-columns:1fr 1fr;border-bottom:1px solid #000;}
// .party-col{padding:4px 6px;font-size:7.5pt;line-height:1.55;}
// .party-col+.party-col{border-left:1px solid #000;}
// .party-col .ptitle{font-weight:700;font-size:8pt;margin-bottom:2px;border-bottom:1px solid #ddd;padding-bottom:1px;}
// .dispatch-grid{display:grid;grid-template-columns:1fr 1fr;}
// .dispatch-col{padding:4px 6px;font-size:7.5pt;line-height:1.55;border-top:1px solid #000;}
// .dispatch-col+.dispatch-col{border-left:1px solid #000;}
// .dispatch-col .ptitle{font-weight:700;font-size:8pt;margin-bottom:2px;}
// .items-table{width:100%;border-collapse:collapse;font-size:7pt;}
// .items-table th{font-weight:700;padding:3px 2px;border:1px solid #000;text-align:center;font-size:7pt;line-height:1.2;background:#fff;}
// .items-table td{padding:3px 2px;border:1px solid #000;vertical-align:top;line-height:1.35;}
// .tax-summary{width:100%;border-collapse:collapse;font-size:7pt;border-top:none;}
// .tax-summary th,.tax-summary td{border:1px solid #000;padding:3px 3px;text-align:right;font-size:7pt;}
// .tax-summary th{text-align:center;font-weight:700;background:#fff;}
// .footer-row{display:flex;justify-content:space-between;align-items:flex-end;margin-top:6px;padding-top:4px;border-top:1px solid #ccc;}
// .sign-area{font-size:7pt;color:#444;font-style:italic;text-align:right;line-height:1.6;}
// .sign-area .esign{font-size:13pt;font-style:italic;font-family:Georgia,serif;color:#1a3c6e;font-weight:700;}
// .print-btn{display:block;margin:0 auto 12px;padding:9px 36px;background:#0f172a;color:#fff;border:none;border-radius:6px;font-size:11pt;font-weight:700;cursor:pointer;}
// </style>
// </head>
// <body>
// <div class="no-print" style="background:#f8fafc;padding:10px;text-align:center;border-bottom:2px solid #0f172a;position:sticky;top:0;z-index:99;">
//   <button class="print-btn" onclick="window.print()">🖨️&nbsp; Print e-Invoice (A4)</button>
// </div>
// <div class="page-wrap">
// <div class="top-header">
//   <div class="company-block">
//     <div class="gstin">${esc(seller.Gstin || "")}</div>
//     <div class="name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
//   </div>
//   <div>${qrHtml}</div>
// </div>
// <div class="section">
//   <div class="sec-title">1. e-Invoice Details</div>
//   <div class="einv-row"><span class="label">IRN :</span><span class="irn-val">${esc(einv.irn || "")}</span></div>
//   <div class="ack-row">
//     <div><span class="label">Ack No. : </span>${esc(String(einv.ackNo || ""))}</div>
//     <div><span class="label">Ack Date : </span>${esc(String(einv.ackDt || ""))}</div>
//   </div>
// </div>
// <div class="section">
//   <div class="sec-title">2. Transaction Details</div>
//   <div class="tran-grid">
//     <div><span class="label">Supply Type : </span>${esc(tran.SupTyp || "B2B")}</div>
//     <div><span class="label">Document No. : </span>${esc(doc2.No || "")}</div>
//     <div><span class="label">IGST on Intra : </span>${tran.IgstOnIntra === "Y" ? "Yes" : "No"}</div>
//     <div><span class="label">Place of Supply : </span>${esc(ship.Stcd || buyer.Stcd || "")}</div>
//     <div><span class="label">Document Type : </span>${esc(doc2.Typ || "Tax Invoice")}</div>
//     <div><span class="label">Document Date : </span>${esc(doc2.Dt || "")}</div>
//     <div><span class="label">Vehicle No. : </span>${esc(String(inv.EwbDtls?.VehNo || "—"))}</div>
//     <div><span class="label">Transport Mode : </span>${esc(
//       inv.EwbDtls?.TransMode === "1" ? "Road" :
//       inv.EwbDtls?.TransMode === "2" ? "Rail" :
//       inv.EwbDtls?.TransMode === "3" ? "Air" :
//       inv.EwbDtls?.TransMode === "4" ? "Ship" : "—"
//     )}</div>
//     <div><span class="label">Distance : </span>${esc(String(inv.EwbDtls?.Distance || "0"))} KM</div>
//   </div>
// </div>
// <div class="section">
//   <div class="sec-title">3. Party Details</div>
//   <div class="party-grid">
//     <div class="party-col">
//       <div class="ptitle">Supplier :</div>
//       <div><b>GSTIN :</b> ${esc(seller.Gstin || "")}</div>
//       <div>${esc(seller.LglNm || seller.TrdNm || "")}</div>
//       <div>${esc(addr(seller))}</div>
//       ${seller.Ph ? `<div>${esc(seller.Ph)}</div>` : ""}
//       ${seller.Em ? `<div>${esc(seller.Em)}</div>` : ""}
//     </div>
//     <div class="party-col">
//       <div class="ptitle">Recipient :</div>
//       <div><b>GSTIN :</b> ${esc(buyer.Gstin || "")}</div>
//       <div>${esc(buyer.LglNm || buyer.TrdNm || "")}</div>
//       <div>${esc(addr(buyer))}</div>
//       <div>Place of Supply: ${esc(buyer.Stcd || "")}</div>
//     </div>
//   </div>
//   <div class="dispatch-grid">
//     <div class="dispatch-col">
//       <div class="ptitle">Dispatch From :</div>
//       <div>${esc(seller.LglNm || seller.TrdNm || "")}</div>
//       <div>${esc(addr(seller))}</div>
//     </div>
//     <div class="dispatch-col">
//       <div class="ptitle">Ship To :</div>
//       <div><b>GSTIN :</b> ${esc(ship.Gstin || buyer.Gstin || "")}</div>
//       <div>${esc(ship.LglNm || ship.TrdNm || buyer.LglNm || buyer.TrdNm || "")}</div>
//       <div>${esc(addr(Object.keys(ship).length > 2 ? ship : buyer))}</div>
//     </div>
//   </div>
// </div>
// <div class="section">
//   <div class="sec-title">4. Details of Goods / Services</div>
//   <table class="items-table">
//     <thead>
//       <tr>
//         <th style="width:25px;">SlNo</th>
//         <th>Item Description</th>
//         <th style="width:60px;">HSN Code</th>
//         <th style="width:50px;">Quantity</th>
//         <th style="width:35px;">Unit</th>
//         <th style="width:65px;">Unit Price (₹)</th>
//         <th style="width:55px;">Discount (₹)</th>
//         <th style="width:65px;">Taxable Amt (₹)</th>
//         <th style="width:50px;">GST Rate</th>
//         <th style="width:45px;">Other Charges</th>
//         <th style="width:65px;">Total (₹)</th>
//       </tr>
//     </thead>
//     <tbody>${itemRows}</tbody>
//   </table>
//   <table class="tax-summary">
//     <thead>
//       <tr>
//         <th>Taxable Amt</th><th>CGST Amt</th><th>SGST Amt</th><th>IGST Amt</th>
//         <th>CESS Amt</th><th>State CESS</th><th>Discount</th>
//         <th>Other Charges</th><th>Round Off</th><th>Total Inv. Amt</th>
//       </tr>
//     </thead>
//     <tbody>
//       <tr>
//         <td>${fmt(totTaxableAmt)}</td><td>${cgstTot}</td><td>${sgstTot}</td><td>${igstTot}</td>
//         <td>${cessTot}</td><td>0.00</td><td>${fmt(val.Discount || 0)}</td>
//         <td>0.00</td><td>${fmt(roundOff, 2)}</td><td><b>${fmt(totInvAmt)}</b></td>
//       </tr>
//     </tbody>
//   </table>
// </div>
// <div class="footer-row">
//   <div>
//     <div style="font-weight:700;font-size:7.5pt;">Generated By : ${esc(seller.Gstin || "")}</div>
//     <div style="font-size:7pt;color:#555;margin-top:2px;">Print Date : ${printDate}</div>
//   </div>
//   <div class="sign-area">
//     <div class="esign">eSign</div>
//     <div>Digitally Signed by NIC-IRP</div>
//     <div>on : ${esc(String(einv.ackDt || ""))}</div>
//   </div>
// </div>
// </div>
// </body>
// </html>`;


const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8"/>
<title>e-Invoice — ${esc(doc2.No || "")}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
@page{size:A4 portrait;margin:12mm 14mm 12mm 14mm}
html,body{font-family:'Segoe UI',Arial,sans-serif;font-size:8pt;color:#111;background:#fff;}
.page{width:182mm;margin:0 auto;background:#fff;}
@media print{.no-print{display:none!important}}

/* ══ TOP HEADER ══ */
.header{
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  padding-bottom:10px;
  border-bottom:2.5px solid #111;
  margin-bottom:8px;
}
.header-left{}
.tag{
  font-size:6pt;
  font-weight:800;
  letter-spacing:3px;
  text-transform:uppercase;
  color:#555;
  margin-bottom:4px;
}
.company-gstin{
  font-size:8pt;
  color:#444;
  font-weight:600;
  margin-bottom:2px;
  letter-spacing:.5px;
}
.company-name{
  font-size:18pt;
  font-weight:800;
  color:#111;
  letter-spacing:-.3px;
  line-height:1.1;
}
.header-right{
  display:flex;
  flex-direction:column;
  align-items:flex-end;
  gap:6px;
}
.doc-no-block{text-align:right;}
.doc-no-label{
  font-size:6pt;
  font-weight:800;
  letter-spacing:2px;
  text-transform:uppercase;
  color:#777;
  margin-bottom:2px;
}
.doc-no-val{
  font-size:13pt;
  font-weight:800;
  color:#111;
  letter-spacing:.5px;
}

/* ══ IRN BLOCK ══ */
.irn-block{
  border-left:3px solid #111;
  padding:5px 10px;
  background:#f8f8f8;
  margin-bottom:0;
  display:flex;
  align-items:baseline;
  gap:8px;
}
.irn-label{
  font-size:6.5pt;
  font-weight:800;
  letter-spacing:1.5px;
  text-transform:uppercase;
  white-space:nowrap;
  flex-shrink:0;
}
.irn-val{
  font-family:'Courier New',monospace;
  font-size:7pt;
  color:#222;
  word-break:break-all;
  line-height:1.5;
}
.ack-row{
  display:flex;
  gap:0;
  border-bottom:1.5px solid #111;
  border-top:1px solid #ccc;
}
.ack-cell{
  padding:4px 10px;
  font-size:7.5pt;
  border-right:1px solid #ddd;
  flex:1;
}
.ack-cell:last-child{border-right:none;}
.ack-cell .lbl{
  font-size:6pt;
  font-weight:800;
  text-transform:uppercase;
  letter-spacing:.8px;
  color:#777;
  display:block;
  margin-bottom:1px;
}
.ack-cell .val{font-weight:700;color:#111;}

/* ══ SECTION HEADER ══ */
.sec-hdr{
  background:#111;
  color:#fff;
  padding:4px 10px;
  font-size:6.5pt;
  font-weight:800;
  letter-spacing:2px;
  text-transform:uppercase;
  margin-top:0;
}

/* ══ GRID ROWS ══ */
.info-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  border-bottom:1.5px solid #111;
}
.info-cell{
  padding:6px 10px;
  border-right:1px solid #ddd;
  font-size:7.5pt;
}
.info-cell:last-child{border-right:none;}
.info-cell .lbl{
  font-size:6pt;
  font-weight:800;
  text-transform:uppercase;
  letter-spacing:.8px;
  color:#777;
  display:block;
  margin-bottom:2px;
}
.info-cell .val{font-weight:700;color:#111;font-size:8pt;}

/* ══ PARTY ══ */
.party-grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  border-bottom:1px solid #ddd;
}
.party-col{padding:8px 10px;font-size:7.5pt;line-height:1.7;}
.party-col+.party-col{border-left:1px solid #ddd;}
.party-type{
  font-size:6pt;
  font-weight:800;
  text-transform:uppercase;
  letter-spacing:1.5px;
  color:#555;
  margin-bottom:4px;
  padding-bottom:3px;
  border-bottom:1px solid #e0e0e0;
}
.party-gstin{
  display:inline-block;
  border:1.5px solid #111;
  font-size:7pt;
  font-weight:800;
  padding:1px 8px;
  border-radius:2px;
  margin-bottom:3px;
  letter-spacing:.5px;
}
.party-name{font-weight:800;font-size:9pt;color:#111;margin-bottom:2px;line-height:1.3;}
.party-addr{color:#444;font-size:7pt;line-height:1.65;}
.party-contact{color:#666;font-size:7pt;margin-top:3px;font-style:italic;}
.party-divider{
  border-top:1.5px dashed #bbb;
}

/* ══ TABLE ══ */
.items-outer{border-bottom:1.5px solid #111;}
table{width:100%;border-collapse:collapse;font-size:7pt;}
thead tr{border-bottom:2px solid #111;border-top:1.5px solid #111;}
thead th{
  padding:5px 4px;
  font-weight:800;
  font-size:6.5pt;
  text-transform:uppercase;
  letter-spacing:.4px;
  text-align:center;
  background:#fff;
  color:#111;
  border:none;
}
tbody tr{border-bottom:1px solid #e8e8e8;}
tbody tr:last-child{border-bottom:2px solid #111;}
tbody td{
  padding:5px 4px;
  border:none;
  vertical-align:middle;
}
.sl{text-align:center;color:#888;font-weight:700;}
.item-name{font-weight:700;font-size:7.5pt;padding-left:4px!important;}
.num{text-align:right;}
.cen{text-align:center;}
.total-cell{text-align:right;font-weight:800;font-size:8pt;}

/* ══ TAX SUMMARY ══ */
.tax-outer{
  border-bottom:1.5px solid #111;
  display:grid;
  grid-template-columns:repeat(4,1fr) 1.6fr;
}
.tax-cell{
  padding:6px 8px;
  border-right:1px solid #ddd;
  font-size:7.5pt;
}
.tax-cell:last-child{
  border-right:none;
  background:#f0f0f0;
}
.tax-cell .lbl{
  font-size:6pt;
  font-weight:800;
  text-transform:uppercase;
  letter-spacing:.6px;
  color:#777;
  display:block;
  margin-bottom:2px;
}
.tax-cell .val{font-weight:700;color:#111;}
.tax-cell.grand .lbl{color:#111;font-size:6.5pt;}
.tax-cell.grand .val{font-size:12pt;font-weight:900;color:#111;}

.tax-row2{
  border-bottom:1.5px solid #111;
  display:grid;
  grid-template-columns:repeat(4,1fr);
}

/* ══ FOOTER ══ */
.footer{
  display:flex;
  justify-content:space-between;
  align-items:flex-end;
  padding-top:10px;
}
.footer-left{}
.gen-by{font-size:7pt;color:#555;margin-bottom:1px;}
.gen-by strong{color:#111;}
.print-dt{font-size:6.5pt;color:#999;margin-bottom:8px;}
#ack-barcode{}
.barcode-num{
  font-size:6.5pt;
  text-align:center;
  color:#555;
  margin-top:2px;
  letter-spacing:.8px;
  font-family:'Courier New',monospace;
}

/* ══ ESIGN ══ */
.esign-wrap{text-align:right;}
.esign-logo{
  font-family:'Brush Script MT','Segoe Script',cursive;
  font-size:42pt;
  color:#111;
  font-style:italic;
  line-height:1;
  font-weight:700;
}
.esign-rule{
  width:100%;
  height:1px;
  background:#111;
  margin:3px 0;
}
.esign-sub{font-size:7pt;font-weight:800;color:#111;letter-spacing:.5px;}
.esign-date{font-size:6.5pt;color:#666;margin-top:1px;}

.print-btn{
  display:block;margin:0 auto 12px;padding:9px 36px;
  background:#111;color:#fff;border:none;
  font-size:10pt;font-weight:700;cursor:pointer;
  letter-spacing:1px;
}
</style>
</head>
<body>

<div class="no-print" style="background:#f5f5f5;padding:10px;text-align:center;border-bottom:2px solid #111;position:sticky;top:0;z-index:99;">
  <button class="print-btn" onclick="window.print()">🖨️ &nbsp; Print e-Invoice (A4)</button>
</div>

<div class="page">

  <!-- ══ HEADER ══ -->
  <div class="header">
    <div class="header-left">
      <div class="tag">GST e-Invoice</div>
      <div class="company-gstin">${esc(seller.Gstin || "")}</div>
      <div class="company-name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
    </div>
    <div class="header-right">
      ${qrHtml}
      <div class="doc-no-block">
        <div class="doc-no-label">Document No.</div>
        <div class="doc-no-val">${esc(doc2.No || "")}</div>
      </div>
    </div>
  </div>

  <!-- ══ IRN ══ -->
  <div class="irn-block">
    <span class="irn-label">IRN</span>
    <span class="irn-val">${esc(einv.irn || "")}</span>
  </div>
  <div class="ack-row">
    <div class="ack-cell">
      <span class="lbl">Ack No</span>
      <span class="val">${esc(String(einv.ackNo || ""))}</span>
    </div>
    <div class="ack-cell">
      <span class="lbl">Ack Date</span>
      <span class="val">${esc(String(einv.ackDt || ""))}</span>
    </div>
    <div class="ack-cell">
      <span class="lbl">Doc Type</span>
      <span class="val">${esc(doc2.Typ === "INV" ? "Tax Invoice" : doc2.Typ || "Tax Invoice")}</span>
    </div>
  </div>

  <!-- ══ TRANSACTION DETAILS ══ -->
  <div class="sec-hdr">Transaction Details</div>
  <div class="info-grid">
    <div class="info-cell">
      <span class="lbl">Supply Type</span>
      <span class="val">${esc(tran.SupTyp || "B2B")}</span>
    </div>
    <div class="info-cell">
      <span class="lbl">Document Date</span>
      <span class="val">${esc(doc2.Dt || "")}</span>
    </div>
    <div class="info-cell">
      <span class="lbl">Place of Supply</span>
      <span class="val">${esc(
        buyer.Stcd === "01" ? "JAMMU AND KASHMIR" : buyer.Stcd === "02" ? "HIMACHAL PRADESH" :
        buyer.Stcd === "03" ? "PUNJAB" : buyer.Stcd === "04" ? "CHANDIGARH" :
        buyer.Stcd === "05" ? "UTTARAKHAND" : buyer.Stcd === "06" ? "HARYANA" :
        buyer.Stcd === "07" ? "DELHI" : buyer.Stcd === "08" ? "RAJASTHAN" :
        buyer.Stcd === "09" ? "UTTAR PRADESH" : buyer.Stcd === "10" ? "BIHAR" :
        buyer.Stcd === "11" ? "SIKKIM" : buyer.Stcd === "12" ? "ARUNACHAL PRADESH" :
        buyer.Stcd === "13" ? "NAGALAND" : buyer.Stcd === "14" ? "MANIPUR" :
        buyer.Stcd === "15" ? "MIZORAM" : buyer.Stcd === "16" ? "TRIPURA" :
        buyer.Stcd === "17" ? "MEGHALAYA" : buyer.Stcd === "18" ? "ASSAM" :
        buyer.Stcd === "19" ? "WEST BENGAL" : buyer.Stcd === "20" ? "JHARKHAND" :
        buyer.Stcd === "21" ? "ODISHA" : buyer.Stcd === "22" ? "CHHATTISGARH" :
        buyer.Stcd === "23" ? "MADHYA PRADESH" : buyer.Stcd === "24" ? "GUJARAT" :
        buyer.Stcd === "27" ? "MAHARASHTRA" : buyer.Stcd === "29" ? "KARNATAKA" :
        buyer.Stcd === "30" ? "GOA" : buyer.Stcd === "32" ? "KERALA" :
        buyer.Stcd === "33" ? "TAMIL NADU" : buyer.Stcd === "34" ? "PUDUCHERRY" :
        buyer.Stcd === "36" ? "TELANGANA" : buyer.Stcd === "37" ? "ANDHRA PRADESH" :
        buyer.Stcd || ""
      )}</span>
    </div>
    <div class="info-cell">
      <span class="lbl">Tax Scheme</span>
      <span class="val">${esc(tran.TaxSch || "GST")}</span>
    </div>
    <div class="info-cell">
      <span class="lbl">Vehicle Number</span>
      <span class="val">${esc(String(inv.EwbDtls?.VehNo || "—"))}</span>
    </div>
    <div class="info-cell">
      <span class="lbl">Transport Mode</span>
      <span class="val">${esc(
        inv.EwbDtls?.TransMode === "1" ? "Road" :
        inv.EwbDtls?.TransMode === "2" ? "Rail" :
        inv.EwbDtls?.TransMode === "3" ? "Air" :
        inv.EwbDtls?.TransMode === "4" ? "Ship" : "—"
      )}</span>
    </div>
  </div>

  <!-- ══ PARTY DETAILS ══ -->
  <div class="sec-hdr">Party Details</div>
  <div class="party-grid">
    <div class="party-col">
      <div class="party-type">Supplier</div>
      <div class="party-gstin">${esc(seller.Gstin || "")}</div>
      <div class="party-name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
      <div class="party-addr">${esc([seller.Addr1, seller.Addr2].filter(Boolean).join(", "))}</div>
      <div class="party-addr">${esc(seller.Loc || "")} — ${esc(String(seller.Pin || ""))} &nbsp;${esc(seller.Stcd === "33" ? "TAMIL NADU" : seller.Stcd || "")}</div>
      ${seller.Ph || seller.Em ? `<div class="party-contact">${[seller.Ph, seller.Em].filter(Boolean).join(" &nbsp;·&nbsp; ")}</div>` : ""}
    </div>
    <div class="party-col">
      <div class="party-type">Recipient</div>
      <div class="party-gstin">${esc(buyer.Gstin || "")}</div>
      <div class="party-name">${esc(buyer.LglNm || buyer.TrdNm || "")}</div>
      <div class="party-addr">${esc([buyer.Addr1, buyer.Addr2].filter(Boolean).join(", "))}</div>
      <div class="party-addr">${esc(buyer.Loc || "")} — ${esc(String(buyer.Pin || ""))} &nbsp;${esc(buyer.Stcd === "33" ? "TAMIL NADU" : buyer.Stcd || "")}</div>
      ${buyer.Ph || buyer.Em ? `<div class="party-contact">${[buyer.Ph, buyer.Em].filter(Boolean).join(" &nbsp;·&nbsp; ")}</div>` : ""}
    </div>
  </div>
  <div class="party-grid party-divider">
    <div class="party-col">
      <div class="party-type">Dispatch From</div>
      <div class="party-name">${esc(seller.LglNm || seller.TrdNm || "")}</div>
      <div class="party-addr">${esc([seller.Addr1, seller.Addr2].filter(Boolean).join(", "))}</div>
      <div class="party-addr">${esc(seller.Loc || "")} — ${esc(String(seller.Pin || ""))} &nbsp;${esc(seller.Stcd === "33" ? "TAMIL NADU" : seller.Stcd || "")}</div>
    </div>
    <div class="party-col">
      <div class="party-type">Ship To</div>
      <div class="party-gstin">${esc(
        Object.keys(inv.ShipDtls || {}).length > 2 ? (inv.ShipDtls?.Gstin || buyer.Gstin || "") : (buyer.Gstin || "")
      )}</div>
      <div class="party-name">${esc(
        Object.keys(inv.ShipDtls || {}).length > 2
          ? (inv.ShipDtls?.LglNm || inv.ShipDtls?.TrdNm || buyer.LglNm || buyer.TrdNm || "")
          : (buyer.LglNm || buyer.TrdNm || "")
      )}</div>
      <div class="party-addr">${esc(
        Object.keys(inv.ShipDtls || {}).length > 2
          ? [inv.ShipDtls?.Addr1, inv.ShipDtls?.Addr2].filter(Boolean).join(", ")
          : [buyer.Addr1, buyer.Addr2].filter(Boolean).join(", ")
      )}</div>
      <div class="party-addr">${esc(
        Object.keys(inv.ShipDtls || {}).length > 2
          ? (inv.ShipDtls?.Loc || "")
          : (buyer.Loc || "")
      )} — ${esc(
        Object.keys(inv.ShipDtls || {}).length > 2
          ? String(inv.ShipDtls?.Pin || "")
          : String(buyer.Pin || "")
      )}</div>
    </div>
  </div>

  <!-- ══ ITEMS ══ -->
  <div class="sec-hdr">Details of Goods / Services</div>
  <div class="items-outer">
    <table>
      <thead>
        <tr>
          <th style="width:20px;">#</th>
          <th style="text-align:left;padding-left:6px;">Item Description</th>
          <th style="width:52px;">HSN Code</th>
          <th style="width:38px;">Qty</th>
          <th style="width:28px;">Unit</th>
          <th style="width:55px;">Unit Price</th>
          <th style="width:50px;">Discount</th>
          <th style="width:58px;">Taxable Amt</th>
          <th style="width:65px;">GST Rate</th>
          <th style="width:40px;">Other Chg</th>
          <th style="width:52px;">Total (₹)</th>
        </tr>
      </thead>
      <tbody>
        ${items.map((it, i) => {
          const gstRt = Number(it.GstRt || 0);
          const cess = Number(it.CesAmt || 0);
          const cessRate = cess > 0 ? fmt(cess / Number(it.AssAmt || 1) * 100, 2) : "0.00";
          return `<tr>
            <td class="sl">${i + 1}</td>
            <td class="item-name">${esc(it.PrdDesc || "")}</td>
            <td class="cen">${esc(it.HsnCd || "")}</td>
            <td class="num">${Number(it.Qty || 0)}</td>
            <td class="cen">${esc(it.Unit || "")}</td>
            <td class="num">${fmt(it.UnitPrice || 0)}</td>
            <td class="num">${fmt(it.Discount || 0)}</td>
            <td class="num">${fmt(it.AssAmt || 0)}</td>
            <td class="cen">${fmt(gstRt, 2)}% + ${cessRate}%</td>
            <td class="num">0.00</td>
            <td class="total-cell">${fmt(it.TotItemVal || 0)}</td>
          </tr>`;
        }).join("")}
      </tbody>
    </table>
  </div>

  <!-- ══ TAX SUMMARY ══ -->
  <div class="tax-outer">
    <div class="tax-cell">
      <span class="lbl">Taxable Amount</span>
      <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.AssAmt || 0), 0))}</span>
    </div>
    <div class="tax-cell">
      <span class="lbl">CGST</span>
      <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.CgstAmt || 0), 0))}</span>
    </div>
    <div class="tax-cell">
      <span class="lbl">SGST</span>
      <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.SgstAmt || 0), 0))}</span>
    </div>
    <div class="tax-cell">
      <span class="lbl">IGST</span>
      <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.IgstAmt || 0), 0))}</span>
    </div>
    <div class="tax-cell grand">
      <span class="lbl">Total Invoice Amount</span>
      <span class="val">₹${fmt(Number(val.TotInvVal || 0))}</span>
    </div>
  </div>
  <div class="tax-row2">
    <div class="tax-cell">
      <span class="lbl">CESS</span>
      <span class="val">₹${fmt(items.reduce((s,it) => s + Number(it.CesAmt || 0), 0))}</span>
    </div>
    <div class="tax-cell">
      <span class="lbl">Discount</span>
      <span class="val">₹${fmt(Number(val.Discount || 0))}</span>
    </div>
    <div class="tax-cell">
      <span class="lbl">Other Charges</span>
      <span class="val">₹0.00</span>
    </div>
    <div class="tax-cell">
      <span class="lbl">Round Off</span>
      <span class="val">₹${fmt(Number(val.RndOffAmt || 0))}</span>
    </div>
  </div>

  <!-- ══ FOOTER ══ -->
  <div class="footer">
    <div class="footer-left">
      <div class="gen-by">Generated By : <strong>${esc(seller.Gstin || "")}</strong></div>
      <div class="print-dt">Print Date : ${printDate}</div>
      <svg id="ack-barcode"></svg>
      <div class="barcode-num">${esc(String(einv.ackNo || ""))}</div>
    </div>
    <div class="esign-wrap">
      <div class="esign-logo">eSign</div>
      <div class="esign-rule"></div>
      <div class="esign-sub">Digitally Signed by NIC-IRP</div>
      <div class="esign-date">on : ${esc(String(einv.ackDt || ""))}</div>
    </div>
  </div>

</div>

<script src="https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js"
  onload="try{JsBarcode('#ack-barcode','${einv.ackNo || ""}',{format:'CODE128',width:1.5,height:45,displayValue:false,margin:0});}catch(e){}">
</script>
</body>
</html>`;
      const pw = window.open(
        "",
        "_blank",
        "width=850,height=1100,scrollbars=yes,resizable=yes",
      );
      if (pw) {
        pw.document.open();
        pw.document.write(html);
        // ── Barcode generate (JsBarcode library) ──
const barcodeScript = pw.document.createElement("script");
barcodeScript.src = "https://cdnjs.cloudflare.com/ajax/libs/jsbarcode/3.11.5/JsBarcode.all.min.js";
barcodeScript.onload = () => {
  try {
    pw.JsBarcode("#ack-barcode", "${einv.ackNo || ''}", {
      format: "CODE128",
      width: 1.5,
      height: 40,
      displayValue: false,
      margin: 0
    });
  } catch(e) {}
};
pw.document.head.appendChild(barcodeScript);
        pw.document.close();
      } else {
        dispatch(
          Show_MsgBox({
            Message: "Popup blocked! Please allow popups for this site.",
            Type: "error",
            isMsg: true,
          }),
        );
      }
    } catch (err) {
      dispatch(
        Show_MsgBox({ Message: err.message, Type: "error", isMsg: true }),
      );
    }
  };

  // ─────────────────────────────────────────────────────────────
  //  SETTINGS HELPERS
  // ─────────────────────────────────────────────────────────────
  // const Input_Onchange = (val, element, area) => {
  //   setEntJsonInv((prev) =>
  //     prev.map((json) => {
  //       const u = { ...json };
  //       u[area.strAreaCol] = {
  //         ...u[area.strAreaCol],
  //         [element.strGstcolName]:
  //           element.strdatatype === "decimal" ? Number(val) : val,
  //       };
  //       return u;
  //     }),
  //   );
  // };
  

  const Input_Onchange = (val, element, area) => {
  setEntJsonInv((prev) => {
    const updated = prev.map((json) => {
      const u = { ...json };
      u[area.strAreaCol] = {
        ...u[area.strAreaCol],
        [element.strGstcolName]:
          element.strdatatype === "decimal" ? Number(val) : val,
      };
      return u;
    });

    // ✅ Pincode மாத்தும்போது distance recalculate பண்ணு
    if (element.strGstcolName === "Pin" && String(val).length === 6) {
      const updatedInv = updated[0];
      if (updatedInv) {
        // setTimeout — state update முடிஞ்சதுக்கு அப்புறம் call பண்ண
        setTimeout(() => View_Distance(updatedInv), 0);
      }
    }

    return updated;
  });
};

  const Area_Onchange = async (AreaId) => {
    try {
      setiAreaId(AreaId);
      dispatch(setload_Screen(true));
      const Res = await userApp.get(
        `GST/Area_Onchange/${Number(AreaId)}/${Number(iScrId)}/${localStorage.db}`,
      );
      if (Res.data.strStatus === "Success") setarrEntCol(Res.data.EntCol);
      else showToast(Res.data.strMessage, "info");
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  const View_GSTColumns = (col) => {
    setstrColName(col.strGstcolName);
    setstrAliasName(col.strAliasName);
    setstrDatatype(col.strdatatype);
    setstrTransName(col.strConditionCol);
    setstrdefaultval(col.strdefaultvalue);
    setstrval(col.strValue);
    setiAreaId(col.iAreaId);
    setiColId(col.iGstcolId);
    setisShow(col.iShwinScr === 1);
  };

  const Clear_Colums = () => {
    setstrColName("");
    setstrAliasName("");
    setstrDatatype("string");
    setstrTransName("");
    setstrdefaultval("");
    setstrval("");
    setiAreaId(0);
    setiColId(0);
    setisShow(true);
  };

  const Updat_GSTColumn = async () => {
    try {
      dispatch(setload_Screen(true));
      const Res = await userApp.post("GST/InsUpd_GSTColumns", {
        strCompanyDB: localStorage.db,
        EntArea: [],
        EntCol: [
          {
            iGstcolId: iColId,
            strGstcolName: strColName,
            strAliasName,
            strdatatype: strDatatype,
            strConditionCol: strTransName,
            strdefaultvalue: strdefaultval,
            strValue: strval,
            iShwinScr: isShow ? 1 : 0,
            iAreaId,
            iScrId,
          },
        ],
      });
      if (Res.data.strStatus === "Success") {
        Area_Onchange(iAreaId);
        Clear_Colums();
      } else showToast(Res.data.strMessage, "error");
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  const TransMode = [
    { val: "1", Name: "Road" },
    { val: "2", Name: "Rail" },
    { val: "3", Name: "Air" },
    { val: "4", Name: "Ship" },
  ];
  const VechicleType = [
    { val: "R", Name: "Regular" },
    { val: "O", Name: "ODC" },
  ];
  const Option_list = (col, EntDT) =>
    col === "VehType" ? VechicleType : col === "TransMode" ? TransMode : EntDT;
  const Option_Value = (Val, col) =>
    col === "VehType" || col === "TransMode" ? Val.val : Val;
  const Option_display = (Val, col) =>
    col === "VehType" || col === "TransMode" ? Val.Name : Val;
  const display_Value = (Val, col) => {
    if (col === "VehType")
      return VechicleType.find((d) => d.val === Val)?.Name || Val;
    if (col === "TransMode")
      return TransMode.find((d) => d.val === Val)?.Name || Val;
    return Val;
  };
  const Hide_Option = (val, element) =>
    setarrEntCol((prev) =>
      prev.map((col) =>
        col.iGstcolId === element.iGstcolId
          ? { ...col, isShowOption: val }
          : col,
      ),
    );

  const CreateHTMLElemet = (element, area, Index) => {
    if (element.iAreaId !== area.iAreaId || area.iAreaId === 9) return null;
    const json = EntJsonInv[0];
    const val = json ? json[area.strAreaCol][element.strGstcolName] : "";
    switch (element.strdatatype) {
      case "string":
        return (
          <div className="col-sm-6 col-md-3" key={Index}>
            <label>{element.strAliasName}</label>
            <input
              type="text"
              className="form-control"
              value={val}
              onChange={(e) => Input_Onchange(e.target.value, element, area)}
            />
          </div>
        );
      case "cmb":
        return (
          <div className="col-sm-6 col-md-3" key={Index}>
            <label>{element.strAliasName}</label>
            <div
              className="custom-select"
              onMouseLeave={() => Hide_Option(false, element)}
            >
              <input
                type="text"
                className="form-control"
                readOnly
                placeholder="Select Value"
                value={display_Value(val, element.strGstcolName)}
                onClick={() => Hide_Option(true, element)}
              />
              <i className="fa-solid fa-caret-down"></i>
              {element.isShowOption && (
                <div className="custom-option">
                  <div className="option-list">
                    {Option_list(element.strGstcolName, element.arrOption).map(
                      (item, i) => (
                        <button
                          key={i}
                          tabIndex={i}
                          onClick={() => {
                            Input_Onchange(
                              Option_Value(item, element.strGstcolName),
                              element,
                              area,
                            );
                            Hide_Option(false, element);
                          }}
                          onKeyDown={(e) => {
                            const len = element.arrOption.length - 1;
                            if (e.key === "ArrowDown")
                              $(
                                `.option-list [tabindex=${i === len ? 0 : i + 1}]`,
                              ).focus();
                            if (e.key === "ArrowUp")
                              $(
                                `.option-list [tabindex=${i === 0 ? len : i - 1}]`,
                              ).focus();
                            if (e.key === "Enter") {
                              Input_Onchange(
                                Option_Value(item, element.strGstcolName),
                                element,
                                area,
                              );
                              Hide_Option(false, element);
                            }
                          }}
                        >
                          {Option_display(item, element.strGstcolName)}
                        </button>
                      ),
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      case "decimal":
        return (
          <div className="col-sm-6 col-md-3" key={Index}>
            <label>{element.strAliasName}</label>
            <input
              type="number"
              className="form-control"
              value={val}
              onChange={(e) => Input_Onchange(e.target.value, element, area)}
            />
          </div>
        );
      case "date":
        return (
          <div className="col-sm-6 col-md-3" key={Index}>
            <label>{element.strAliasName}</label>
            <input
              type="date"
              className="form-control"
              value={val}
              onChange={(e) => Input_Onchange(e.target.value, element, area)}
            />
          </div>
        );
      default:
        return null;
    }
  };

  // ─────────────────────────────────────────────────────────────
  //  DERIVED STATE
  // ─────────────────────────────────────────────────────────────
  const hasIRN = !!einvResp?.irn;
  const isCancelled = hasIRN && !!einvResp?.cancelIRN;
  const isActive = hasIRN && !isCancelled;

  // ─────────────────────────────────────────────────────────────
  //  TABLE COLUMNS
  // ─────────────────────────────────────────────────────────────
  const ItemColumn = [
    { Header: "Product Name", accessor: "PrdDesc", minWidth: 200 },
    { Header: "HSN Code", accessor: "HsnCd", minWidth: 100 },
    {
      Header: "Qty",
      accessor: "Qty",
      minWidth: 80,
      style: { justifyContent: "right" },
    },
    {
      Header: "Unit",
      accessor: "Unit",
      minWidth: 80,
      style: { justifyContent: "center" },
    },
    {
      Header: "Rate",
      accessor: "UnitPrice",
      minWidth: 100,
      style: { justifyContent: "right" },
    },
    {
      Header: "SGST Amount",
      accessor: "SgstAmt",
      minWidth: 100,
      style: { justifyContent: "right" },
    },
    {
      Header: "CGST Amount",
      accessor: "CgstAmt",
      minWidth: 100,
      style: { justifyContent: "right" },
    },
    {
      Header: "IGST Amount",
      accessor: "IgstAmt",
      minWidth: 100,
      style: { justifyContent: "right" },
    },
    {
      Header: "Tax %",
      accessor: "GstRt",
      minWidth: 80,
      style: { justifyContent: "right" },
    },
    {
      Header: "Taxable Amount",
      accessor: "taxableAmt",
      minWidth: 110,
      style: { justifyContent: "right" },
    },
    {
      Header: "Item Amount",
      accessor: "TotItemVal",
      minWidth: 110,
      style: { justifyContent: "right" },
    },
  ];
  const GstColumn = [
    { Header: "GST Column", accessor: "strGstcolName" },
    { Header: "Alias Name", accessor: "strAliasName", minWidth: 200 },
    { Header: "Data Type", accessor: "strdatatype", minWidth: 100 },
    { Header: "Trans Name", accessor: "strConditionCol", minWidth: 100 },
    { Header: "Default Value", accessor: "strdefaultvalue", minWidth: 200 },
    {
      Header: "Value",
      accessor: "strValue",
      minWidth: 100,
      style: { justifyContent: "center" },
    },
    {
      Header: "Show",
      accessor: "iShwinScr",
      minWidth: 70,
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => (
        <input
          type="checkbox"
          className="form-check"
          checked={rowinfo.iShwinScr}
          readOnly
        />
      ),
    },
  ];

  // ─────────────────────────────────────────────────────────────
  //  RENDER
  // ─────────────────────────────────────────────────────────────
  return (
    <>
      <Toast
        toasts={toasts}
        onDismiss={(id) =>
          setToasts((prev) => prev.filter((t) => t.id !== id))
        }
      />

      {showCancelModal && (
        <CancelModal
          irn={einvResp?.irn}
          onConfirm={Cancel_EInvoice}
          onClose={() => setShowCancelModal(false)}
        />
      )}

      {showValidModal && (
        <ValidationModal
          errors={validErrors}
          warnings={validWarnings}
          invoice={EntJsonInv?.[0]}
          onProceed={() => {
            setShowValidModal(false);
            Create_EInvoice();
          }}
          onClose={() => setShowValidModal(false)}
        />
      )}

      {showCredPopup && (
        <CredentialModal
          cred={nicCred}
          onChange={setNicCred}
          onSave={Save_Credential}
          onClose={() => {
            setShowCredPopup(false);
            setNicCred({ ApiUserName: "", ApiPassword: "" });
          }}
          saving={credSaving}
        />
      )}

      <div className="popup-container">
        <div className="popup-content">
          {/* ── Header ── */}
          <div className="popup-header">
            <h5>
              <span style={{ marginRight: 8 }}>📋</span>
              GST E-Invoice
              {hasIRN && (
                <span
                  style={{
                    marginLeft: 10,
                    fontSize: 11,
                    fontWeight: 600,
                    padding: "2px 10px",
                    borderRadius: 20,
                    background: isCancelled ? "#fef2f2" : "#f0fff4",
                    color: isCancelled ? "#dc2626" : "darkgreen",
                    border: `1px solid ${isCancelled ? "#fecaca" : "darkgreen"}`,
                    verticalAlign: "middle",
                  }}
                >
                  {isCancelled ? "⛔ Cancelled" : "✅ Active"}
                </span>
              )}
            </h5>
            <div className="icon-popup-btn-grp">
              {!isSetting && (
                <span
                  className="icon-btn"
                  title="Settings"
                  onClick={() => {
                    setisSetting(true);
                    Area_Onchange(1);
                  }}
                >
                  <i className="fa-solid fa-gear"></i>
                </span>
              )}
              <span
                className="icon-btn"
                title="Close"
                onClick={() => dispatch(ShowHide_Popup("IsEInvoice"))}
              >
                <i className="fa-regular fa-rectangle-xmark"></i>
              </span>
            </div>
          </div>

          {/* ── Body ── */}
          <div className="popup-body">
            {/* Invoice Form */}
            {!isSetting && (
              <div className="row">
                {arrEntArea.map((area, i) => (
                  <div className="row" key={i}>
                    <h6 className="gstcol-h">{area.strAliasName}</h6>
                    {arrEntCol.map((col, j) => CreateHTMLElemet(col, area, j))}
                  </div>
                ))}
                <div className="TransactionTable">
                  <ReactTable
                    sortable={true}
                    data={ListEntItem}
                    columns={ItemColumn}
                    minRows={5}
                    defaultPageSize={500}
                    showPaginationBottom={false}
                    row_click={() => {}}
                  />
                </div>
              </div>
            )}

            {/* Settings */}
            {isSetting && (
              <div className="row p-2">
                <div className="col-sm-12 col-md-3">
                  <label>GST Column Type</label>
                  <CustomizedSelectoption
                    optionparem="isoptionShow10"
                    showoption={_selecrparem.isoptionShow10}
                    placeholder="Select Column Type"
                    select_value={(val) => Area_Onchange(val)}
                    btnname=""
                    btnshow={false}
                    show_popup={""}
                    valueonly={true}
                    defaultval={iAreaId}
                    displayName="strAreaCol"
                    disvalue="iAreaId"
                    arrydata={arrEntArea}
                    EmptVal="Column Type"
                  />
                </div>
                {[
                  { l: "GST Column Name", v: strColName, s: setstrColName },
                  { l: "Alias Name", v: strAliasName, s: setstrAliasName },
                  { l: "Trans Name", v: strTransName, s: setstrTransName },
                  { l: "Default Value", v: strdefaultval, s: setstrdefaultval },
                  { l: "Value", v: strval, s: setstrval },
                ].map(({ l, v, s }, i) => (
                  <div className="col-sm-12 col-md-3" key={i}>
                    <label>{l}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={v}
                      onChange={(e) => s(e.target.value)}
                      spellCheck={false}
                      autoComplete="off"
                    />
                  </div>
                ))}
                <div className="col-sm-12 col-md-3">
                  <label>Show Screen</label>
                  <input
                    type="checkbox"
                    className="form-check"
                    checked={isShow}
                    onChange={() => setisShow((v) => !v)}
                  />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label>Data Type</label>
                  <div className="row">
                    {["string", "date", "decimal", "cmb"].map((dt) => (
                      <div className="col-sm-3" key={dt}>
                        <label>{dt}</label>
                        <input
                          type="checkbox"
                          className="form-check"
                          checked={strDatatype === dt}
                          onChange={() => setstrDatatype(dt)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <ReactTable
                  columns={GstColumn}
                  data={arrEntCol}
                  minRows={5}
                  row_click={() => {}}
                  row_doubleclick={(rowInfo) => View_GSTColumns(rowInfo)}
                  background={true}
                  className="full-table"
                />
              </div>
            )}

            {/* ── IRN Result Card ── */}
            {hasIRN && !isSetting && (
              <div
                style={{
                  margin: "16px 2px 0",
                  border: `1.5px solid ${isCancelled ? "#fecaca" : "darkgreen"}`,
                  borderRadius: 12,
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                {/* Card Header */}
                <div
                  style={{
                    background: isCancelled
                      ? "#dc2626"
                      : "darkgreen",
                    padding: "12px 18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <span style={{ fontSize: 18 }}>
                      {isCancelled ? "⛔" : "✅"}
                    </span>
                    <div>
                      <div
                        style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}
                      >
                        {isCancelled
                          ? "E-Invoice Cancelled"
                          : "E-Invoice Generated Successfully"}
                      </div>
                      <div
                        style={{
                          color: "rgba(255,255,255,0.6)",
                          fontSize: 10.5,
                          marginTop: 1,
                        }}
                      >
                        {isCancelled
                          ? "This invoice is marked cancelled on the GST portal"
                          : "Verified and registered on NIC E-Invoice portal"}
                      </div>
                    </div>
                  </div>
                  {isActive && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        background: "rgba(255,255,255,0.12)",
                        padding: "4px 12px",
                        borderRadius: 20,
                      }}
                    >
                      <span
                        style={{
                          width: 7,
                          height: 7,
                          borderRadius: "50%",
                          background: "#ffffff",
                          display: "inline-block",
                          animation: "pulse 1.6s infinite",
                        }}
                      />
                      <span
                        style={{
                          color: "rgba(255,255,255,0.9)",
                          fontSize: 11,
                          fontWeight: 600,
                        }}
                      >
                        Active
                      </span>
                    </div>
                  )}
                </div>

                {/* Card Body */}
                <div
                  style={{
                    background: isCancelled ? "#fff5f5" : "#ffffff",
                    padding: "16px 18px",
                    display: "flex",
                    gap: 18,
                    alignItems: "flex-start",
                  }}
                >
                  {/* Left — details */}
                  <div style={{ flex: 1 }}>
                    <div style={{ marginBottom: 12 }}>
                      <div
                        style={{
                          fontSize: 10,
                          fontWeight: 700,
                          color: "#6b7280",
                          textTransform: "uppercase",
                          letterSpacing: ".7px",
                          marginBottom: 5,
                        }}
                      >
                        Invoice Reference Number (IRN)
                      </div>
                      <div
                        style={{
                          background: "#fff",
                          border: "1px solid #e2e8f0",
                          borderRadius: 8,
                          padding: "8px 12px",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                        }}
                      >
                        <CopyIRN irn={einvResp.irn} />
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                      <div>
                        <div
                          style={{
                            fontSize: 10,
                            fontWeight: 700,
                            color: "#6b7280",
                            textTransform: "uppercase",
                            letterSpacing: ".6px",
                            marginBottom: 4,
                          }}
                        >
                          Acknowledgement Number
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            color: "#0f172a",
                            fontWeight: 700,
                          }}
                        >
                          {einvResp.ackNo || "—"}
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 10,
                            fontWeight: 700,
                            color: "#6b7280",
                            textTransform: "uppercase",
                            letterSpacing: ".6px",
                            marginBottom: 4,
                          }}
                        >
                          Acknowledgement Date &amp; Time
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            color: "#0f172a",
                            fontWeight: 700,
                          }}
                        >
                          {formatAckDate(einvResp.ackDt) || "—"}
                        </div>
                      </div>
                    </div>

                    {isCancelled && (
                      <div
                        style={{
                          marginTop: 12,
                          padding: "9px 12px",
                          background: "#fef2f2",
                          border: "1px solid #fecaca",
                          borderRadius: 8,
                          fontSize: 12,
                        }}
                      >
                        <span style={{ fontWeight: 700, color: "#dc2626" }}>
                          Cancel IRN:{" "}
                        </span>
                        <span
                          style={{
                            fontFamily: "monospace",
                            color: "#7f1d1d",
                            fontSize: 11,
                          }}
                        >
                          {einvResp.cancelIRN}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Right — QR */}
                  <div style={{ textAlign: "center", flexShrink: 0 }}>
                    <div
                      style={{
                        width: 118,
                        height: 118,
                        border: "1.5px solid #e2e8f0",
                        borderRadius: 10,
                        background: "#fff",
                        padding: 6,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                      }}
                    >
                      {einvResp.qrCodeImage ? (
                        <img
                          src={`data:image/png;base64,${einvResp.qrCodeImage}`}
                          alt="QR"
                          style={{ width: 104, height: 104, display: "block" }}
                        />
                      ) : einvResp.signedQRCode ? (
                        <QRFromJWT jwt={einvResp.signedQRCode} size={104} />
                      ) : (
                        <div
                          style={{
                            width: 104,
                            height: 104,
                            border: "1.5px dashed #cbd5e1",
                            borderRadius: 6,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 10,
                            color: "#94a3b8",
                            background: "#f8fafc",
                            textAlign: "center",
                            padding: 8,
                          }}
                        >
                          QR N/A
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#94a3b8",
                        marginTop: 5,
                        fontWeight: 500,
                      }}
                    >
                      📷 Scan to verify on NIC
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ── Footer Buttons ── */}
          <div className="popup-footer">
            <div className="popup-btn-group">
              {!isSetting && (
                <>
                  {!hasIRN && (
                    <>
                      <button
                        onClick={Handle_Generate_Click}
                        className="btn-fabgreen"
                      >
                        <i className="fas fa-file-invoice"></i>&nbsp;Generate
                        E-Invoice
                      </button>
                      <button
                        onClick={() => {
                          if (!EntJsonInv?.[0]) return;
                          const blob = new Blob([JSON.stringify(EntJsonInv[0], null, 2)], { type: "application/json" });
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = `EInvoice_${_HT.SelectedVouchId || "payload"}.json`;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                          URL.revokeObjectURL(url);
                        }}
                        className="btn-fabgreen"
                      >
                        <i className="fas fa-download"></i>&nbsp;Download JSON
                      </button>
                    </>
                  )}
                  {isActive && (
                    <>
                      <button
                        onClick={() => Print_EInvoice()}
                        className="btn-fabgreen"
                      >
                        <i className="fas fa-print"></i>&nbsp;Print
                      </button>
                      <button
                        onClick={() => setShowCancelModal(true)}
                        className="btn-fabred"
                      >
                        <i className="fas fa-ban"></i>&nbsp;Cancel IRN
                      </button>
                    </>
                  )}
                  {isCancelled && (
                    <span
                      style={{
                        color: "#dc2626",
                        fontWeight: 700,
                        fontSize: 13,
                        padding: "7px 16px",
                        background: "#fef2f2",
                        border: "1.5px solid #fecaca",
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      ⛔ E-Invoice Cancelled
                    </span>
                  )}
                  <button
                    onClick={() =>
                      Load_EInvoice(_Common.iScrId, _HT.SelectedVouchId)
                    }
                    className="btn-fabgreen"
                  >
                    <i className="fas fa-sync-alt"></i>&nbsp;Refresh
                  </button>
                </>
              )}
              {isSetting && (
                <>
                  <button onClick={Updat_GSTColumn} className="btn-fabgreen">
                    Update&nbsp;<i className="fas fa-save"></i>
                  </button>
                  <button onClick={Clear_Colums} className="btn-fabgreen">
                    Clear&nbsp;<i className="fas fa-eraser"></i>
                  </button>
                  <button
                    onClick={() => setisSetting(false)}
                    className="btn-fabgreen"
                  >
                    <i className="bx bx-arrow-back"></i>&nbsp;Back
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%,100% { opacity:1; transform:scale(1); }
          50%      { opacity:0.5; transform:scale(1.4); }
        }
        @keyframes modalPop {
          from { opacity:0; transform:scale(0.88); }
          to   { opacity:1; transform:scale(1); }
        }
        @keyframes toastSlide {
          from { opacity:0; transform:translateX(60px) scale(0.9); }
          to   { opacity:1; transform:translateX(0) scale(1); }
        }
      `}</style>
    </>
  );
}

export default EInvoice;